/**
 * Español (es) — Spanish translations
 * - Latin American evangelical Spanish
 * - "tú" form throughout
 * - RVR1960 for Bible verse (standard in Latin American evangelical churches)
 */
const es = {
  reactions: {
    title:   'Reacciones',
    all:     'Todas',
    empty:   'Aún no hay reacciones.',
    end:     '— fin —',
    viewAll: 'Ver todas las reacciones',
  },

  common: {
    save:'Guardar', cancel:'Cancelar', delete:'Eliminar', edit:'Editar', close:'Cerrar',
    back:'Atrás', loading:'Cargando…', more:'Más', or:'o', search:'Buscar',
    yes:'Sí', no:'No', add:'Agregar', remove:'Quitar', create:'Crear',
    tryAgain:'Reintentar', somethingWrong:'Algo salió mal',
    error:'Algo salió mal. Inténtalo de nuevo.',
    darkMode:'Modo oscuro', lightMode:'Modo claro',
    themeSystem:'Según el dispositivo', themeButtonTitle:(m)=>`Tema: ${m} — toca para cambiar`,
    themeNowLight:'Modo claro', themeNowDark:'Modo oscuro',
    themeNowSystem:(dark)=>`Según tu dispositivo (${dark ? 'oscuro' : 'claro'})`,
    all:'Todo', today:'Hoy', yesterday:'Ayer',
    photo:'Foto', video:'Video', post:'Publicar',
    open:'Abrir', leave:'Salir', join:'Unirse',
    retry:'Reintentar', next:'Siguiente →', back2:'← Atrás',
    share:'Compartir algo', findMembers:'Buscar miembros',
    justNow:'justo ahora', mAgo:(m)=>`hace ${m}m`, hAgo:(h)=>`hace ${h}h`, dAgo:(d)=>`hace ${d}d`,
    editable:'editable',
    expired:'expirado',
    done:'Listo',
    reposition:'Reposicionar',
    dragToReposition:'Arrastra para reposicionar',
    dragImageHint:'Arrastra la imagen para elegir la posición',
  },

  auth: {
    legalNoticeSignIn: 'Al continuar, aceptas nuestros',
    legalNoticeSignUp: 'Al crear una cuenta, aceptas nuestros',
    termsOfService: 'Términos de Servicio',
    privacyPolicy: 'Política de Privacidad',
    legalAnd: 'y nuestra',
    tagline:'Oración · Unidad · Discipulado',
    welcomeBack:'Bienvenido de vuelta', email:'Correo electrónico', password:'Contraseña',
    emailPlaceholder:'tu@correo.com', passwordPlaceholder:'••••••••',
    signIn:'Iniciar sesión', forgotPassword:'¿Olvidaste tu contraseña?', createAccount:'Crear cuenta →',
    continueWithGoogle:'Continuar con Google', continueWithApple:'Continuar con Apple',
    joinCommunity:'Únete a la comunidad', fullName:'Nombre completo', namePlaceholder:'Tu nombre',
    passwordMinHint:'Mínimo 8 caracteres', createAccountBtn:'Crear cuenta',
    backToSignIn:'← Volver al inicio de sesión', checkEmail:'Revisa tu correo',
    enterCode:'Ingresa el código de 6 dígitos que te enviamos.',
    verificationCode:'Código de verificación', codePlaceholder:'123456',
    confirmEmail:'Confirmar correo', resendCode:'Reenviar código', codeResent:'¡Código reenviado!',
    confirmSuccess:'¡Correo confirmado! Por favor inicia sesión.',
    pleaseConfirmFirst:'Por favor confirma tu correo electrónico primero.',
    resetPassword:'Restablecer contraseña', sendResetCode:'Enviar código de restablecimiento',
    enterNewPassword:'Ingresa tu nueva contraseña', resetCode:'Código de restablecimiento',
    newPassword:'Nueva contraseña', resetPasswordBtn:'Restablecer contraseña',
    resetSuccess:'¡Contraseña restablecida! Por favor inicia sesión.',
    codeSentTo:(email)=>`Código de restablecimiento enviado a ${email}`,
    verificationSentTo:(email)=>`Enviamos un código de verificación a ${email}`,
    socialError:'Error al iniciar sesión. Inténtalo de nuevo.',
    accountExistsError:'Ya existe una cuenta con este correo. Por favor inicia sesión con tu correo y contraseña, y luego vincula Google o Apple desde tu perfil.',
    configError:'El inicio de sesión no está disponible temporalmente. Inténtalo de nuevo más tarde.',
    signInFailed:'Error al iniciar sesión', registrationFailed:'Error al registrarse',
    confirmFailed:'Error al confirmar', resetFailed:'Error al restablecer la contraseña',
    sendResetFailed:'Error al enviar el código de restablecimiento',
    setNewPasswordTitle:'Establece tu contraseña',
    setNewPasswordDesc:'Tu cuenta fue creada por un administrador. Establece una contraseña permanente para continuar.',
    setPasswordBtn:'Establecer contraseña e iniciar sesión',
    confirmPassword:'Confirmar contraseña',
    passwordMismatch:'Las contraseñas no coinciden',
    verse:'«Pon en manos del SEÑOR todo lo que haces, y tus planes se cumplirán.» — Proverbios 16:3',
  },

  username: {
    title:'¡Un último paso!',
    desc:'Elige un nombre de usuario para tu perfil en Ignite. Así es como otros te encontrarán y mencionarán.',
    welcome:(name)=>`Bienvenido, ${name} 👋`,
    placeholder:'tunombre', available:'Nombre de usuario disponible ✓',
    taken:'Ya está en uso', invalid:'De 3 a 30 caracteres, solo letras, números, puntos o guiones bajos',
    continue:'Continuar a Ignite →',
    hint:'Puedes cambiarlo más tarde en la configuración de tu perfil.',
    errorSave:'No se pudo guardar el nombre de usuario', preferSpanish:'¿Prefieres español?',
    next:'Siguiente →',
    dobTitle:'Una cosa más',
    dobDesc:'Necesitamos tu fecha de nacimiento para asegurarnos de que Ignite sea adecuado para ti.',
    dobLabel:'Fecha de nacimiento',
    dobRequired:'Por favor ingresa tu fecha de nacimiento.',
    finishSetup:'Finalizar configuración →',
    blockedTitle:'Requisito de edad no cumplido',
    blockedMsg:'Ignite es para usuarios de 13 años o más. Pide a un padre o tutor que te ayude a comenzar.',
    enterDifferentDob:'← Ingresar una fecha diferente',
    stepOf:(step,total)=>`Paso ${step} de ${total}`,
  },

  nav: {
    home:'Inicio', homeDesc:'Publicaciones, historias y tu diario',
    people:'Personas', peopleDesc:'Por quién oras y a quién discipulas',
    feed:'Publicaciones', feedDesc:'Actividad de la comunidad',
    stories:'Historias', storiesDesc:'Historias de todo el mundo',
    members:'Miembros', membersDesc:'Encuentra y conecta',
    connections:'Conexiones', connectionsDesc:'Tu red',
    communities:'Comunidades', communitiesDesc:'Tus círculos',
    prayer:'Oración', prayerDesc:'Intercedan juntos',
    bibleStudy:'Estudio Bíblico', bibleStudyDesc:'Sumérgete en la Escritura',
    myLineage:'Mi Linaje', myLineageDesc:'Tu árbol espiritual',
    notifications:'Notificaciones', notifDesc:'Menciones y novedades',
    courses:'Crecer en Dios', coursesDesc:'Profundiza tu fe', growShort:'Crecer',
    profile:'Perfil', profileDesc:'Tu cuenta',
    prayNow:'Orar Ahora', prayNowDesc:'Habla una oración en voz alta',
    myStory:'Mi Historia', myStoryDesc:'Crea y comparte tu testimonio',
    journal:'Mi Diario', journalShort:'Diario', journalDesc:'Tu registro espiritual privado',
    faq:'Ayuda y FAQ', faqDesc:'Preguntas frecuentes',
    notifSettings:'Configuración de notificaciones', notifSettingsDesc:'Gestiona cómo te contacta Ignite',
    settings:'Configuración', settingsDesc:'Cuenta y preferencias',
    messages:'Mensajes', messagesDesc:'Chats y mensajes directos',
    admin:'Admin', adminDesc:'Gestionar comunidad', more:'Más',
    signOut:'Cerrar sesión',
    mainNav:'Navegación principal',
    quickActions:{
      shareReflection:'Comparte una reflexión', addPrayer:'Agregar petición de oración',
      findCommunity:'Encontrar una comunidad', startCourse:'Crecer en Dios',
    },
    // Aviso único tras la reorganización del menú. Lista sencilla de dónde
    // quedó cada cosa — sin recorrido guiado.
    whatMoved:{
      title:'Algunas cosas cambiaron de lugar',
      intro:'Ordenamos el menú para que todo tenga un lugar visible. Esto es dónde están ahora:',
      home:'Publicaciones, Historias y Mi Diario están juntos en <b>Inicio</b>.',
      people:'Destinatarios y Mi Linaje están juntos en <b>Personas</b>.',
      grow:'Estudio Bíblico está en <b>Crecer</b>.',
      prayer:'Orar Ahora está en el calendario de <b>Oración</b>.',
      account:'Tu Perfil y la Configuración siguen bajo tu foto, arriba a la derecha.',
      gotIt:'Entendido',
    },
  },

  people: {
    title:'Personas',
    tabs:{ people:'Personas', encounters:'Encuentros', lineage:'Linaje' },
    subtitles:{
      people:'Ora por ellos. Camina con ellos.',
      encounters:'Conversaciones que vale la pena preparar',
      lineage:'Tu árbol genealógico espiritual',
    },
    empty:'Todavía no hay nadie aquí',
    emptyDesc:'Agrega a alguien por quien quieras orar y aparecerá aquí.',
    addPerson:'Agregar persona',
    searchPlaceholder:'Buscar por nombre',
    noMatches:'Nadie coincide.',
    filters:{
      all:'Todos',
      prayingLabel:'Orando por:',
      oikos:'Aún no siguen a Jesús',
      oikosHint:'Oculta a quienes ya lo siguen',
    },
    prayedTimes:(n) => `${n} ${n === 1 ? 'oración' : 'oraciones'}`,
    detail:{
      sections:'Sobre esta persona',
      about:'Datos', making:'Caminar Con', history:'Historial',
      notFound:'No encontramos a esa persona.',
      editDetails:'Editar sus datos',
    },
    about:{
      praying:'Por lo que estás orando',
      yourPrayers:'Tus oraciones por ellos',
      prayersLabel:'oraciones',
      streakLabel:'días seguidos',
      lastPrayedLabel:'última oración',
      prayedToday:'Oraste hoy',
      details:'Detalles',
      journey:'Dónde están',
      added:'Agregado',
      inviteSent:'Invitación enviada',
      inviteJoined:'Se unió a Ignite',
    },
    making:{
      whereTheyAre:'Dónde están',
      whereHint:'Tu propia lectura de dónde está esta persona. Nada lo cambia excepto tú.',
      whatYouKnow:'Lo que sabes de ellos',
      knowHint:'Notas para ti, y de donde se construye la guía. Solo tú puedes ver esto.',
      story:'Su historia', storyPh:'De dónde vienen…',
      weighing:'Qué les pesa', weighingPh:'Qué les está costando ahora mismo…',
      faithBg:'Trasfondo de fe', faithBgPh:'Iglesia, familia, cualquier cosa que hayan dicho de Dios…',
      notes:'Algo más', notesPh:'Cosas que vale recordar…',
      profileSaved:'Guardado',
      stageSaved:'Guardado',
      crossedIntoFaith:(name)=>`Has registrado que ${name} ahora sigue a Jesús. Vale la pena detenerse en eso.`,
      harvestLineage:(name)=>`${name} está ayudando a otros a seguir a Jesús. ¿Quieres agregarlos a tu linaje?`,
      lineageAsked:'Enviado. Verán tu invitación.',
    },
    history:{
      prayer:'Oración',
      lastPrayed:(date)=>`Última oración ${date}`,
      conversations:'Conversaciones',
      noneYet:(name)=>`Todavía no hay conversaciones con ${name}.`,
      // Se registró la conversación pero se omitió "qué aprendiste". Todas las
      // preguntas del resumen se pueden omitir, así que esto es normal.
      noNotes:'Sin notas de esta conversación.',
      stageHistory:'Lo que ha cambiado',
      movedFromTo:(from,to)=>`${from} → ${to}`,
      crossedTag:'llegó a la fe',
    },
    stagePicker:{
      boundary:'Aquí llegan a confiar en Jesús',
      suggested:'Sugerido',
    },
  },

  // ── Encuentros ───────────────────────────────────────────────────────────
  // Sin lenguaje de CRM: nada aquí cuenta, clasifica, puntúa ni mide a una
  // persona. Ver la nota en en.js.
  encounters:{
    aConversation:'Una conversación',
    planOne:'Planear una conversación',
    planWith:(name)=>`Una conversación con ${name}`,
    theyAre:(stage)=>`Ahora mismo: ${stage}`,
    firstHint:'Parece que es la primera con ellos. Empieza por descubrir dónde están.',
    notAvailable:'Esto no está disponible.',

    settings:{
      coffee:'Un café', truck:'En la camioneta', meal:'En una comida',
      walk:'Caminando', jobsite:'En el trabajo', boat:'En el bote', other:'En otro lugar',
    },
    whereLabel:'¿Dónde van a estar?',
    customPlaceholder:'¿Dónde van a estar?',

    modeLabel:'¿Qué tipo de conversación?',
    modeDiscovery:'Descubrir dónde están',
    modeDiscoveryDesc:'No estás seguro de dónde están. Escucha, y deja que ellos te lo digan.',
    modeStandard:'Dar un paso más',
    modeStandardDesc:'Tienes una idea de dónde están y quieres profundizar un poco.',
    firstTimeNote:'Todavía no has registrado una conversación con ellos — descubrir dónde están suele ser el mejor primer paso.',

    goalLabel:'¿Esperas algo en particular?',
    goalHint:'Opcional. Si lo dejas en blanco, no se dará nada por supuesto.',
    goalPlaceholder:'Quiero preguntarle cómo está de verdad…',

    knowsLabel:'De qué se va a construir',
    knowsStage:(stage)=>`Dónde dijiste que están: ${stage}`,
    knowsPrior:(n)=>n===1?'Una conversación anterior':`${n} conversaciones anteriores`,
    knowsNothing:'Todavía no has escrito nada sobre ellos. La guía será más general.',
    knowsEdit:'Agregar lo que sabes',

    generate:'Crear la guía',
    genShaping:'Dando forma a la conversación…',
    genWriting:'Escribiéndola…',
    genPatience:'Esto toma un momento. Está revisando cada línea contra dónde están.',
    genEmpty:'No llegó nada utilizable. Inténtalo de nuevo.',

    readyToGo:'lista',
    needsGenerating:'sin guía todavía',
    plannedFor:(date)=>`para ${date}`,
    noGuideYet:'Todavía no hay guía para esta conversación.',

    // Abrir una conversación que ya tiene guía. Esta copia insiste en que la
    // guía no se perdió, porque el error que reemplaza hacía creer que todo el
    // trabajo de planificación se había borrado.
    alreadyPlannedTitle:'Esta ya está planificada',
    alreadyPlannedBody:'Tu guía está guardada. Ábrela cuando estés listo — será la misma que creaste.',
    openGuide:'Abrir la guía',
    startOver:'Empezar de nuevo',
    startOverConfirm:'¿Crear una guía nueva para esta conversación? Esto reemplaza la guía que ya tienes.',
    startOverNote:'Al crearla se reemplazará la guía que ya tienes.',
    regenerate:'Crear una guía nueva',
    guideMenu:'Más',
    rowMenu:(name)=>`Más para ${name}`,
    deletePlan:'Eliminar este plan',
    deleteConfirm:'¿Eliminar esta conversación planificada? La guía se elimina con ella.',

    ifThey:(cond)=>`Si ${cond}`,
    next:'Siguiente',
    wereDone:'Terminamos',
    captureNote:'Anotar algo',
    notePlaceholder:'Lo que acaba de decir…',

    debriefTitle:(name)=>`Después de hablar con ${name}`,
    debriefSub:'Tres preguntas. Responde lo que quieras y salta el resto.',
    qLearned:'¿Qué aprendiste de ellos?',
    qLearnedPh:'Algo que no sabías antes…',
    qGodMoved:'¿Dónde viste a Dios?',
    qGodMovedPh:'Aunque sea algo pequeño…',
    qNextStep:'¿Cuál es el siguiente paso?',
    qNextStepPh:'Una cosa, no cinco…',
    debriefNeedsOne:'Responde al menos una de las tres.',
    debriefSave:'Guardar esto',
    debriefSaving:'Guardando…',
    debriefSaved:'Guardado.',
    noSuggestion:'Nada más que sugerir — tus propias notas son lo que importa aquí.',

    proposalsTitle:'Algunas cosas que podrías guardar',
    proposalsSub:'Solo sugerencias. Nada se guarda hasta que lo elijas.',
    propProfile:'Agregar a lo que sabes de ellos',
    propNextStep:'Guardar esto como el siguiente paso',
    propPrayer:'Agregar esto a tus oraciones',
    propPrayerNote:'Esto se agrega a tu calendario de oración de hoy. Tus propias notas de oración no se tocan.',
    applySelected:'Guardar lo que marqué',
    applied:'Guardado',

    stageProposalTitle:'Dónde están',
    stageProposal:(name,stage)=>`Esta conversación podría indicar que ${name} ahora está en ${stage}.`,
    stageYoursToMake:'Esta decisión es tuya. Toca una etapa solo si lo crees, y quedará registrada con la fecha de hoy.',
    allDone:'Listo',

    emptyTitle:'Todavía no hay conversaciones',
    emptyDesc:'Elige a alguien y planea una conversación real — dónde van a estar, y qué esperas.',
    needAPersonFirst:'Primero agrega a alguien a tus personas.',
    pickUp:'Continúa donde lo dejaste',
    recent:'Conversaciones anteriores',
    whoWith:'¿Con quién es?',
  },

  feed: {
    postTypes:{
      reflection:'Reflexión', scripture:'Escritura',
      prayer:'Oración', praise:'Alabanza', surrender:'Rendición',
      prayer_request:'Petición de Oración',
      // Banner taglines
      scriptureTagline:'Su Palabra Viva',
      reflectionTagline:'Desde el Corazón',
      prayerTagline:'Elevándolo a Dios',
      praiseTagline:'Gloria a Dios',
      surrenderTagline:'Entregándolo',
      prayerRequestTagline:'Contigo en Oración',
    },
    visibility:{
      public:'Público', connections:'Conexiones y grupos',
      friends:'Solo conexiones', groups:'Solo mis grupos',
    },
    filters:{ all:'Todo', reflections:'Reflexiones', scripture:'Escritura', prayer:'Oración', praise:'Alabanza', surrender:'Rendición' },
    placeholders:{
      scripture:'Comparte lo que este pasaje significa para ti…',
      prayer:'¿Por qué quisieras oración?',
      reflection:'¿Qué tienes en el corazón hoy?',
      praise:'Comparte cómo Dios se ha movido… (opcional)',
      surrender:'Comparte lo que significa esta rendición… (opcional)',
    },
    composePlaceholder:'¿Qué tienes en el corazón hoy?',
    modalTitle:'Compartir con la comunidad',
    editPost:'Editar publicación',
    postType:'Tipo de publicación', visibleTo:'Visible para',
    mentionHint:'Usa @nombre para mencionar · #etiqueta para hashtags',
    writeSomething:'Por favor escribe algo primero',
    failedPost:'Error al publicar', failedSave:'Error al guardar', failedLoad:'No se pudieron cargar las publicaciones',
    deleteConfirm:'¿Eliminar esta publicación?',
    noPosts:'Nada aquí todavía', beFirst:'Sé el primero en compartir algo con la comunidad.',
    noPostsHashtag:(tag)=>`No hay publicaciones con #${tag}`,
    somethingWrong:'Algo salió mal',
    reply:'Responder', cancelReply:'Cancelar',
    writeComment:'Escribe un comentario…', writeReply:'Escribe una respuesta…',
    shareSomething:'Compartir algo',
    feedTitle:'Inicio', feedSubtitle:'Mira lo que Dios está haciendo en tu comunidad',
    feedTab:'Inicio', savedTab:'Guardados',
    noSavedPosts:'Aún no hay publicaciones guardadas',
    noSavedPostsDesc:'Toca el ícono de marcador en cualquier publicación para guardarla aquí.',
    repost:'Republicar', repostTitle:'Republicar',
    addComment:'Agrega un comentario… (opcional)',
    cancel:'Cancelar',
    reportPost:'Reportar publicación', reportCommunity:'Reportar comunidad', reportPrayer:'Reportar petición de oración',
    // Structured post inputs
    praiseWhatLabel:'¿Por qué estás alabando a Dios?',
    praiseWhatPlaceholder:'ej. Dios sanó a mi padre, llegó el ascenso…',
    praiseMissing:'Por favor comparte por qué estás alabando a Dios.',
    surrenderWhatLabel:'¿Qué le estás entregando a Dios?',
    surrenderWhatPlaceholder:'ej. Mi miedo al futuro, el control de mis finanzas…',
    surrenderMissing:'Por favor comparte qué le estás entregando a Dios.',
    verseLabel:'Adjuntar un versículo (opcional)',
    versePlaceholder:'ej. Juan 3:16 o Salmo 23',
    verseLookup:'Buscar',
    verseNotFound:'Versículo no encontrado — intenta otro formato (ej. "Juan 3:16").',
    addPrayerText:'Agregar una oración escrita (opcional)',
    prayerTextLabel:'Tu oración',
    prayerTextPlaceholder:'Señor, te elevo…',
    // Share to Feed (desde PrayNow / BibleStudy / PrayerWall)
    shareToFeed:'Compartir en el Feed',
    shareToFeedTitle:'Compartir en el Feed',
    prayNowShareTitle:'Compartir Esta Oración',
    prayNowShareNote:'Tu sesión de oración aparecerá en el feed para que otros oren contigo.',
    bibleStudyShareTitle:'Compartir Estudio Bíblico',
    bibleStudyShareNote:'Comparte tu estudio y reflexiones con tu comunidad.',
    prayerWallShareTitle:'Compartir Petición de Oración',
    prayerWallShareNote:'Esta petición tiene visibilidad limitada. Puedes compartirla en el feed con el mismo nivel de restricción o mayor — pero no más abiertamente que el original.',
    prayerWallPrivateNote:'Esta petición de oración es privada y no puede compartirse en el feed.',
    sharedSuccess:'¡Compartido en tu feed!',
    loadMore:'Cargar publicaciones anteriores',
    loadingMore:'Cargando…',
  },

  invite: {
    title: 'Estás invitado a Ignite',
    subtitle: 'Ignite es una comunidad de fe para orar, leer la Escritura y crecer como seguidor de Jesús — juntos. Alguien te quería aquí.',
    join: 'Unirme a Ignite',
    haveAccount: 'Ya tengo una cuenta',
  },
  testimony: {
    // ── Lista ──
    listTitle: 'Mi historia',
    listIntro: 'Tus historias de vida con Dios. Escribe todas las que quieras — cada una es un capítulo de cómo él ha estado obrando.',
    newStory: 'Nueva historia',
    empty: 'Aún no has escrito una historia',
    emptyHint: 'Tu historia es una de las cosas más poderosas que puedes compartir. Empieza con unas notas — Ignite te ayudará a darles forma.',
    emptyCta: 'Escribe tu primera historia',
    loadError: 'No pudimos cargar tus historias.',
    saveError: 'Algo salió mal. Inténtalo de nuevo.',
    deleteConfirm: (title) => `¿Eliminar "${title || 'esta historia'}"? No se puede deshacer.`,
    untitled: 'Historia sin título',
    draft: 'Borrador',
    draftEmpty: 'Aún sin escribir — toca para continuar.',
    editStory: 'Editar',
    deleteStory: 'Eliminar',
    manageStories: 'Administrar',
    profileSection: 'Sus historias',
    profileSectionOwn: 'Mis historias',

    // ── Asistente / editor ──
    stepLabels: ['Inicio', 'Notas', 'Historia', 'Compartir'],
    pickTemplateTitle: '¿Dónde comienza tu historia?',
    pickTemplateIntro: 'Elige qué tipo de historia es. No todos tienen una conversión dramática — y está bien. Puedes cambiarlo cuando quieras.',
    titleLabel: 'Ponle un título',
    titlePlaceholder: 'p. ej. El año en que todo se derrumbó',
    editTitle: 'Editar historia',
    editNotes: 'Editar respuestas',
    next: 'Siguiente',
    back: 'Atrás',
    skip: 'Omitir',
    generate: 'Escribir mi historia',
    regenerate: 'Reescribir',
    generating: 'Escribiendo…',
    questionOf: (n, total) => `Pregunta ${n} de ${total}`,
    promptStepHint: 'Una o dos frases bastan. Omite lo que no encaje con tu historia.',
    draftTitle: 'Tu historia',
    draftHint: 'Aquí tienes un primer borrador a partir de tus notas. Hazla tuya — edita lo que quieras o reescríbela.',
    keepStory: 'Conservar mi historia',
    coverLabel: 'Imagen de portada (opcional)',
    coverUpload: 'Subir imagen',
    coverGenerate: 'Generar con IA',
    coverGenerating: 'Creando imagen…',
    coverRemove: 'Quitar',
    coverNeedsDraft: 'Escribe tu historia primero y la IA podrá ilustrarla.',
    coverFailed: 'No se pudo añadir la imagen. Inténtalo de nuevo.',
    needNotes: 'Responde algunas preguntas primero y podré ayudarte.',
    yourNotes: 'Tus notas',
    yourStory: 'Tu historia',
    editorPlaceholder: 'Tu historia aparecerá aquí. Puedes editarla libremente.',
    visibilityTitle: '¿Quién puede verla?',
    visibilityOptions: {
      private:     { label: 'Solo yo',                desc: 'Un borrador privado. Nadie más puede verlo.' },
      connections: { label: 'Mis conexiones',         desc: 'Las personas con las que estás conectado pueden leerla en tu perfil.' },
      public:      { label: 'Cualquiera con el enlace', desc: 'Para compartir con cualquiera — y, tras una breve revisión, aparece en el feed global del Movimiento.' },
    },
    getLink: 'Crear enlace para compartir',
    shareAgain: 'Compartir de nuevo',
    finish: 'Listo',
    save: 'Guardar',
    share: 'Compartir',
    saved: 'Guardado',
    shared: 'Compartido',
    linkCopied: 'Enlace copiado',
    fallbackNote: 'Redactado a partir de tus notas',
    shareTitle: 'Mi historia',
    shareText: 'Quería compartir mi historia contigo.',

    // ── Compartir con el feed del Movimiento (se muestra al elegir "público") ──
    movementSection: 'Compartir con el Movimiento',
    movementIntro: 'Las historias públicas se añaden al feed global del Movimiento para animar a creyentes de todo el mundo. Nuestro equipo revisa cada una antes de publicarla.',
    locationLabel: '¿Dónde estás (región / país)?',
    locationPlaceholder: 'p. ej. Nairobi, Kenia',
    categoryLabel: 'Tema',
    categoryNone: 'Elige un tema (opcional)',
    anonymousLabel: 'Mostrar en el feed del Movimiento de forma anónima',
    anonymousNamePlaceholder: 'Nombre para mostrar (p. ej. "Un creyente en Irán")',
    publicConsent: 'Las historias aprobadas aparecen públicamente en Ignite y pueden mostrarse en buscadores como Google. Si la marcas como anónima, tu nombre se oculta en el feed del Movimiento.',
    movementPending: 'Pendiente de revisión: tu enlace ya funciona; se unirá al feed del Movimiento cuando nuestro equipo la apruebe.',
    movementLive: 'Publicada en el Movimiento.',
    movementViewInFeed: 'Ver en el Movimiento',
    movementCategories: {
      salvation: 'Salvación',
      healing: 'Sanidad',
      provision: 'Provisión',
      persecution: 'Persecución',
      revival: 'Avivamiento',
      other: 'Historia',
    },

    // ── Vista pública ──
    publicTitle: (name) => `La historia de ${name}`,
    joinCta: 'Unirme a Ignite',
    learnMore: 'Conoce más sobre Ignite',
    notFoundTitle: 'Historia no encontrada',
    notFoundBody: 'Esta historia puede haber sido eliminada o hecha privada.',

    // ── Reflexión final compartida (se añade a cada plantilla) ──
    sharedPrompts: {
      grace: {
        label: '¿Dónde ves más el amor, la gracia o la misericordia de Dios al mirar atrás?',
        placeholder: 'Lo que él hizo, cómo te encontró, lo que quieres que otros sepan de él…',
        example: 'p. ej. No lo merecía, pero él nunca me soltó — y quiero que la gente sepa que hace lo mismo por ellos.',
      },
    },

    // ── Plantillas (puntos de partida) ──
    templates: {
      classic: {
        label: 'Cómo conocí a Jesús',
        desc: 'El arco clásico — la vida antes, el punto de inflexión y la vida ahora.',
        prompts: {
          before:  { label: '¿Cómo era tu vida antes de conocer a Jesús?', placeholder: 'Por qué vivías, qué te faltaba, qué era difícil…', example: 'p. ej. Buscaba éxito y aprobación, pero por dentro me sentía vacío y ansioso.' },
          meeting: { label: '¿Cómo llegaste a seguir a Jesús?', placeholder: '¿Qué pasó? ¿A quién o qué usó Dios?', example: 'p. ej. Un amigo me invitó a la iglesia en una temporada difícil y por fin todo cobró sentido.' },
          after:   { label: '¿Cómo es diferente tu vida ahora, caminando con él?', placeholder: 'Qué ha cambiado — aunque no sea perfecto…', example: 'p. ej. Aún lucho, pero tengo una paz y un propósito que nunca tuve antes.' },
        },
      },
      deeper: {
        label: 'Crecí en la fe',
        desc: 'Siempre has creído — esta es la historia de ir más profundo.',
        prompts: {
          upbringing:   { label: '¿Cómo era la fe al crecer?', placeholder: 'Iglesia, familia, qué creías y por qué…', example: 'p. ej. Iba a la iglesia cada domingo y nunca dudé de que Dios existía.' },
          turningPoint: { label: '¿Cuándo la fe se volvió verdaderamente tuya?', placeholder: 'Un momento o temporada en que dejó de ser heredada…', example: 'p. ej. Lejos de casa por primera vez, tuve que decidir si de verdad lo creía por mí mismo.' },
          nowFaith:     { label: '¿Cómo estás creciendo o profundizando hoy?', placeholder: 'Dónde está obrando Dios en ti hoy…', example: 'p. ej. Estoy aprendiendo a confiarle cosas que antes intentaba controlar.' },
        },
      },
      prodigal: {
        label: 'El regreso',
        desc: 'Conociste la fe, te alejaste por un tiempo y fuiste atraído de vuelta.',
        prompts: {
          drifting:  { label: '¿Qué te alejó y cómo fue esa temporada?', placeholder: 'Con sinceridad — qué pasó y cómo se sintió…', example: 'p. ej. Tras una pérdida dejé de orar. Me decía que estaba bien sin ello.' },
          awakening: { label: '¿Qué empezó a atraerte de vuelta?', placeholder: 'El impulso, el anhelo, la persona, el momento…', example: 'p. ej. Una inquietud que no podía calmar y un viejo amigo que nunca se rindió conmigo.' },
          return:    { label: '¿Cómo es tu caminar con Dios ahora?', placeholder: 'Dónde estás hoy, aunque aún sanando…', example: 'p. ej. Volví esperando vergüenza y encontré que era bienvenido a casa.' },
        },
      },
      waiting: {
        label: 'Una temporada de espera',
        desc: 'Cuando la vida no salió según el plan y Dios parecía lento o callado.',
        prompts: {
          longing:   { label: '¿Qué esperabas o anhelabas?', placeholder: 'Aquello que anhelabas…', example: 'p. ej. Oramos por un hijo durante años sin respuesta.' },
          wrestling: { label: '¿Qué fue difícil de la espera?', placeholder: 'Con Dios, contigo mismo, con otros…', example: 'p. ej. Estaba enojado con Dios y cansado de fingir que estaba bien.' },
          meeting:   { label: '¿Dónde encontraste a Dios en ello?', placeholder: 'Aunque siga sin resolverse…', example: 'p. ej. No obtuve mi respuesta, pero descubrí que estaba más cerca de lo que pensaba.' },
        },
      },
      miracle: {
        label: 'Una oración respondida',
        desc: 'Una vez concreta en que Dios obró de forma inconfundible.',
        prompts: {
          need:   { label: '¿Cuál era la situación o necesidad?', placeholder: 'Describe la escena…', example: 'p. ej. Los médicos dijeron que ya no había nada más que hacer.' },
          prayer: { label: '¿Cómo oraste y quién oró contigo?', placeholder: 'El clamor, las personas a tu lado…', example: 'p. ej. Todo nuestro grupo pequeño oró por nosotros cada noche durante un mes.' },
          answer: { label: '¿Qué pasó y cómo cambió tu confianza en Dios?', placeholder: 'El giro y lo que hizo en ti…', example: 'p. ej. El siguiente estudio salió limpio. Nunca dudaré de que él escucha.' },
        },
      },
      freeform: {
        label: 'Empezar de cero',
        desc: '¿No sabes dónde encaja? Cuéntala a tu manera.',
        prompts: {
          part1: { label: '¿Dónde comienza tu historia?', placeholder: 'Empieza donde te parezca bien…', example: 'p. ej. Quién eras y dónde estabas.' },
          part2: { label: '¿Qué pasó — el corazón de todo?', placeholder: 'El punto de inflexión o lo que más importa…', example: 'p. ej. El momento, la lucha o el cambio.' },
          part3: { label: '¿Dónde estás ahora y qué quieres que otros aprendan?', placeholder: 'A dónde te ha llevado…', example: 'p. ej. Lo que querrías que un amigo supiera.' },
        },
      },
    },
  },

  // ── Historias del Movimiento — feed "Alrededor del Mundo" ──────────────────
  movement: {
    feedTab: 'Movimiento',
    screenTitle: 'Historias del Movimiento',
    screenSubtitle: 'Mira lo que Dios está haciendo en el mundo — y comparte la tuya.',
    tabWorld: 'Alrededor del Mundo',
    tabMap: 'Mapa',
    tabExplore: 'Explorar',
    tabMine: 'Mis Historias',
    map: {
      statStories:  (n) => `${n} ${n === 1 ? 'historia' : 'historias'}`,
      statCountries:(n) => `${n} ${n === 1 ? 'país' : 'países'}`,
      statStates:   (n) => `${n} ${n === 1 ? 'estado' : 'estados'} de EE. UU.`,
      hint: 'Arrastra para girar · desplaza para acercar · toca un país',
      hintStates: 'Toca un estado · aleja para ver el mundo',
      resetGlobe: 'Restablecer vista',
      backToWorld: 'Volver al mundo',
      clearSelection: (place) => `Quitar ${place}`,
      storiesFrom: (place) => `Historias de ${place}`,
      noneHereYet: (place) => `Aún no hay historias de ${place} — sé el primero.`,
      oneInView: '1 historia a la vista',
      nInView: (n) => `${n} historias a la vista`,
      noneInView: 'Aún no hay historias en esta parte del mundo. Prueba a alejar el mapa.',
      showMore: 'Ver más',
      showOnMap: 'Ver en el mapa',
      oneStoryHere: '1 historia',
      nStoriesHere: (n) => `${n} historias`,
      approximate: 'ubicación aproximada',
      unknownPlace: 'En algún lugar del mundo',
      thisPlace: 'Este lugar',
      close: 'Cerrar',
      emptyTitle: 'Aún no hay historias en el mapa',
      emptyBody: 'A medida que lleguen historias con ubicación, aparecerán aquí.',
    },
    dismiss: 'Descartar',
    introTitle: 'Alrededor del Mundo',
    introBody: 'Mira lo que Dios está haciendo en todo el mundo — y comparte tu propia historia.',
    submit: 'Compartir historia',
    readStory: 'Leer historia',
    whoReacted: 'Ver reacciones',
    sourcePrefix: 'Fuente:',
    report: 'Reportar',
    anonymous: 'Anónimo',
    back: 'Atrás',

    emptyTitle: 'Aún no hay historias',
    emptyBody: 'Sé el primero en compartir lo que Dios está haciendo donde estás.',
    somethingWrong: 'Algo salió mal',
    failedLoad: 'No se pudieron cargar las historias.',
    retry: 'Reintentar',
    loadMore: 'Cargar más historias',
    loadingMore: 'Cargando…',
    notFoundTitle: 'Historia no encontrada',
    notFoundBody: 'Es posible que esta historia se haya eliminado o ya no esté disponible.',

    // Diseño de descubrimiento
    sectionFeatured: 'Destacadas',
    mostLoved: 'Lo más querido',
    latest: 'Historias recientes',
    seeAll: 'Ver todo',
    allStories: 'Todas las historias',
    regionLabel: 'Región',
    regionAuto: 'Detectar automáticamente por ubicación',
    byRegion: {
      africa: 'Desde África',
      asia: 'Desde Asia',
      middle_east: 'Desde Oriente Medio',
      europe: 'Desde Europa',
      americas: 'Desde las Américas',
      oceania: 'Desde Oceanía',
    },

    // Modal de envío
    submitTitle: 'Comparte tu historia',
    submitIntro: 'Cuéntales a los creyentes de todo el mundo lo que Dios ha hecho. Nuestro equipo revisa cada historia antes de publicarla.',
    fromExisting: 'Comenzar desde una de tus historias',
    startBlank: 'Comenzar desde cero',
    untitledStory: 'Historia sin título',
    titleLabel: 'Título',
    titlePlaceholder: 'p. ej. Él me encontró en la espera',
    locationLabel: '¿Dónde estás (región / país)?',
    locationPlaceholder: 'p. ej. Nairobi, Kenia',
    categoryLabel: 'Tema',
    categoryNone: 'Elige un tema (opcional)',
    storyLabel: 'Tu historia',
    storyPlaceholder: 'Comparte lo que sucedió y cómo viste a Dios obrar…',
    anonymousLabel: 'Compartir de forma anónima',
    anonymousNamePlaceholder: 'Nombre para mostrar (p. ej. "Un creyente en Irán")',
    bodyRequired: 'Por favor escribe tu historia primero.',
    submitFailed: 'No se pudo enviar. Inténtalo de nuevo.',
    submitForReview: 'Enviar para revisión',
    cancel: 'Cancelar',
    close: 'Cerrar',
    submittedTitle: 'Enviado para revisión',
    submittedBody: 'Gracias por compartir. Revisaremos tu historia y la publicaremos pronto.',
    publicConsent: 'Las historias aprobadas aparecen públicamente en Ignite y pueden mostrarse en buscadores como Google. Las identidades que marques como anónimas se mantienen privadas.',

    // Compartir
    shareTitle: 'Compartir',
    shareText: 'Mira lo que Dios está haciendo en todo el mundo.',
    shareCopyOrShare: 'Copiar / Compartir',
    sendInMessage: 'Enviar en un mensaje',
    linkCopied: 'Enlace copiado',
    shared: 'Compartido',
    shareSentTo: (name) => `Enviado a ${name}`,
    shareSendSub: 'Elige a quién enviar esta historia.',
    shareSearchConnections: 'Buscar conexiones',
    shareNoConnections: 'Aún no tienes conexiones.',
    shareDmNotePlaceholder: 'Agrega una nota (opcional)',
    openInApp: 'Abrir en la app',
    joinCta: 'Únete a Ignite',
    publicTagline: 'Conoce Ignite',

    categories: {
      salvation: 'Salvación',
      healing: 'Sanidad',
      provision: 'Provisión',
      persecution: 'Persecución',
      revival: 'Avivamiento',
      other: 'Historia',
    },

    // Consola de administración
    admin: {
      title: 'Historias del Movimiento',
      tabPending: 'Pendientes',
      tabPublished: 'Publicadas',
      tabDrafts: 'Borradores',
      create: 'Crear historia',
      aiGenerate: 'Generar con IA',
      generating: 'Generando…',
      regionLabel: 'Región (opcional)',
      regionPlaceholder: 'p. ej. Sudeste Asiático',
      themeLabel: 'Tema (opcional)',
      themePlaceholder: 'p. ej. avivamiento de iglesias en casas',
      approve: 'Aprobar',
      reject: 'Rechazar',
      retire: 'Retirar',
      edit: 'Editar',
      delete: 'Eliminar',
      save: 'Guardar',
      feature: 'Destacar',
      featured: 'Destacada',
      rejectReason: 'Motivo (opcional, se comparte con quien la envió)',
      publishNow: 'Publicar de inmediato',
      confirmDelete: '¿Eliminar esta historia permanentemente?',
      confirmRetire: '¿Retirar esta historia? Se ocultará del feed.',
      emptyPending: 'No hay envíos esperando revisión.',
      emptyPublished: 'Aún no hay historias publicadas.',
      bySubmitter: 'por',
      source: 'Origen',
      sourceSystem: 'Curada',
      sourceUser: 'Envío',
      sourceUrlLabel: 'Enlace de la fuente (historia real y publicada)',
      sourceNameLabel: 'Nombre de la fuente (opcional)',
      sourceNamePlaceholder: 'p. ej. Open Doors, Christianity Today',
      viewSource: 'Ver fuente',
      savedToast: 'Guardado',
      coverageTitle: 'Cobertura',
      coverageCountries: 'Países',
      coverageStates: 'Estados de EE. UU.',
      coverageShowMissing: 'Ver faltantes',
      coverageHide: 'Ocultar',
      geoTitle: 'Ubicación en el mapa',
      geoCity: 'Ciudad (opcional)',
      geoCountry: 'CC',
      geoState: 'ST',
      geoLat: 'Latitud',
      geoLng: 'Longitud',
      geoHint: 'Deja las coordenadas en blanco para situar el punto en el centro del estado o del país.',
      geoCurrent: (p) => `Actualmente situado en ${p}. Si introduces coordenadas, el punto queda fijado a mano y no se volverá a calcular.`,
      geoPrecision: {
        city: 'un punto exacto',
        state: 'el centro del estado',
        country: 'el centro del país',
      },
    },
  },

  prayer: {
    title:'Oración', subtitle:'Las personas en tu corazón',
    tabTitles: {
      calendar:   'Calendario de Oración',
      discover:   'Descubrir Peticiones',
      recipients: 'Personas de Oración',
      requests:   'Peticiones de Oración',
    },
    tabSubtitles: {
      calendar:   'Fieles en oración, día a día',
      discover:   'Levanta a alguien en oración hoy',
      recipients: 'Las personas en tu corazón',
      requests:   'Presenta tus necesidades ante el Cuerpo',
    },
    addMenu: {
      label:     '+ Agregar',
      person:    'Persona de oración',
      personSub: 'Privado — solo visible para ti',
      request:   'Petición de oración',
      requestSub:'Tú controlas quién la ve',
    },
    witness: {
      title: '¿Dónde están en el camino?',
      intro: 'Seis fases mapeadas a las Cuatro Sillas — desde romper tierra dura hasta liberar a un discípulo que multiplica.',
      preFaithLabel: 'Antes de la fe — Silla 1: Ven y mira',
      postFaithLabel: 'Siguiendo a Jesús — Sillas 2, 3 y 4',
      till: 'Labrar',
      soil: 'Suelo',
      seed: 'Semilla',
      sprout: 'Brote',
      plant: 'Planta',
      harvest: 'Cosecha',
      tillHint: 'Rompe tierra dura — ora, sirve y escucha sin condiciones.',
      soilHint: 'El corazón se ablanda — comparte vida, haz preguntas, invítalo.',
      seedHint: 'Siembra la Palabra — abran la Escritura juntos, invítalo a un DBS.',
      sproutHint: 'Fe nueva — cuida, protege, bautismo y hábitos básicos.',
      plantHint: 'Raíces profundas — equípalo para servir, delega, entrénalo a alcanzar a su oikos.',
      harvestHint: 'Multiplicando — él hace discípulos; tú pasas al rol de entrenador.',
      oikosFilter: 'Oikos',
      oikosFilterHint: 'Solo personas que aún no siguen a Jesús',
      startDiscipling: 'Empezar a discipular',
      inviteToIgnite: 'Invitar a Ignite',
      shareTitle: 'Únete a mí en Ignite',
      shareModalTitle: 'Enviar tu invitación',
      shareModalIntro: (name) => `Personaliza el mensaje para ${name}. Su enlace se agregará automáticamente.`,
      shareModalUrlLabel: 'Tu enlace de invitación',
      shareNow: 'Abrir compartir',
      linkCopied: 'Enlace de invitación copiado',
      inviteSent: 'Invitación compartida',
      discipleSent: 'Solicitud de discipulado enviada',
      discipleNeedsConnection: 'Conéctate con ellos primero para discipular',
      inviteTemplates: {
        till: (name) => `Hola ${name} — he estado orando por ti. Quería compartirte Ignite; me ha ayudado a crecer. Sin presión, échale un vistazo cuando puedas.`,
        soil: (name) => `${name}, has estado en mi corazón últimamente. Uso Ignite para orar y crecer — quería invitarte a verlo. Me encantaría saber qué piensas.`,
        seed: (name) => `${name} — hemos estado hablando de fe y quería compartirte Ignite. Me ha ayudado mucho a profundizar en la Escritura. ¿Quieres revisarlo juntos?`,
        sprout: (name) => `¡${name}! Qué alegría que estás caminando con Jesús. Ignite ha sido enorme para mí en construir ritmos diarios de oración y Biblia. Ven a crecer con nosotros.`,
        plant: (name) => `${name} — creo que apreciarías Ignite. Es un buen lugar para crecer, formar hábitos de oración y caminar con otros.`,
        harvest: (name) => `${name} — te comparto Ignite. Me ha servido para orar y discipular a las personas que Dios ha puesto en mi vida. Espero ver cómo lo usas.`,
      },
      inviteStatus: {
        justSent: 'Invitación enviada — ahora mismo',
        sent: (days) => `Invitado hace ${days}d — sin aceptar aún`,
        sentWithClicks: (days, clicks) => `Invitado hace ${days}d — abierto ${clicks}×`,
        claimedJustNow: 'Acaba de unirse por tu invitación',
        claimed: (days) => `Se unió hace ${days}d por tu invitación`,
      },
      nextStepsTitle: 'Un siguiente paso que podrías dar',
      nextSteps: {
        till: [
          'Ora por él por nombre — en voz alta y con detalle.',
          'Haz un acto pequeño de servicio esta semana, sin condiciones.',
          'Contáctalo sin agenda — solo hazte presente.',
          'Envía un mensaje breve: "Estaba pensando en ti".',
          'Pídele a Dios que ablande la tierra; no fuerces la conversación.',
          'Detecta una necesidad práctica y atiéndela calladamente.',
        ],
        soil: [
          'Pregunta cómo le va — escucha, no resuelvas.',
          'Invítalo a un café o a una comida.',
          'Comparte una parte de tu historia cuando encaje.',
          'Plantea una pregunta más profunda y quédate para escuchar la respuesta.',
          'Invítalo a tu vida — a tu mesa, a un proyecto de servicio.',
          'Nombra en voz alta algo que veas que Dios está haciendo en él.',
        ],
        seed: [
          'Invítalo a leer un pasaje de la Escritura contigo.',
          'Comiencen un Discovery Bible Study con un pasaje.',
          'Pregúntale si pueden orar juntos por algo que está enfrentando.',
          'Comparte el Evangelio con claridad cuando se abra el momento.',
          'Llévalo contigo a algún lugar donde se abra la Palabra.',
          'Pregunta: "¿Dónde dirías que estás con Jesús ahora mismo?"',
        ],
        sprout: [
          'Conversen sobre el bautismo si aún no se ha bautizado.',
          'Ayúdalo a construir un ritmo diario de Biblia + oración.',
          'Oren juntos — y deja que él ore en voz alta.',
          'Pregúntale qué le ha estado mostrando Dios esta semana.',
          'Explícale qué significa pertenecer a un cuerpo de creyentes.',
          'Ayúdalo a escribir su testimonio en tres párrafos cortos.',
        ],
        plant: [
          'Pregúntale por quién está orando y buscando en su vida.',
          'Capacítalo para compartir su testimonio en voz alta.',
          'Delega una pieza del ministerio — déjalo dirigir algo.',
          'Lean juntos un libro de la Biblia y conversen semanalmente.',
          'Hablen de un área de obediencia con la que esté luchando.',
          'Oren juntos por nombre por alguien a quien él está alcanzando.',
        ],
        harvest: [
          'Pregunta por las personas a quienes está discipulando.',
          'Ora por sus discípulos por nombre.',
          'Anímalo — la multiplicación es pesada y solitaria.',
          'Pregúntale dónde está atorado y entrénalo con suavidad.',
          'Celebra un fruto específico que veas en su vida.',
          'Ora por su próximo traspaso y liberación.',
        ],
      },
    },
    calendarTab:'Calendario', recipientsTab:'Lista',
    viewCalendar:'Ver calendario →', addPerson:'Agregar persona',
    addFirstRecipient:'Agregar primera persona', tryAgain:'Reintentar',
    // Frecuencia de oración, no un ranking. Los valores guardados siguen
    // siendo normal|high|urgent, pero nadie debería leer "Urgente" junto al
    // rostro de una persona — mostramos con qué frecuencia oramos por ella.
    priorities:{ normal:'Rotación regular', high:'Semanal', urgent:'Diaria',
      normalDesc:'Una persona por día, recorriendo tu lista',
      highDesc:'Ora cada semana', urgentDesc:'Ora cada día' },
    faith:{ yes:'Sí', no:'No', unknown:'No sé', na:'N/A' },
    faithChips:{ yes:'Tiene fe', no:'Sin fe', unknown:'Desconocido' },
    relationshipGroups:{
      immediate:'Familia inmediata', extended:'Familia extendida', friends:'Amigos, vecinos y conocidos',
    },
    relationships:[
      'Esposo','Esposa','Prometido/a','Mamá','Madrastra','Papá','Padrastro',
      'Hermano','Hermanastro','Hermana','Hermanastra','Hijo','Hijastro','Hija','Hijastra',
      'Primo/a','Tío','Tía','Sobrina','Sobrino','Nieto','Nieta',
      'Abuela','Abuelo','Suegra','Suegro','Cuñado','Cuñada',
      'Yerno','Nuera',
      'Novio','Novia','Mejor amigo/a','Amigo/a cercano/a','Amigo/a',
      'Vecino/a','Empleado/a','Jefe/a','Compañero/a de trabajo','Conocido/a',
      'Desconocido/a','Hermano/a de iglesia','Compañero/a de clase','Pastor','Mentor','Discípulo',
    ],
    months:['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
    days:['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'],
    formType:'Tipo', formIgniteMember:'Miembro de Ignite',
    formName:'Nombre', formNamePlaceholder:'Nombre completo',
    formPriority:'Frecuencia de oración', formRelationship:'Relación',
    formSelectRelationship:'Selecciona la relación…',
    formFaith:'¿Tiene fe?',
    formRequest:'Petición de oración / Notas',
    formRequestPlaceholder:'¿Por qué estás orando por esta persona?',
    searchMembers:'Buscar miembros de Ignite…',
    editRecipient:'Editar destinatario', addRecipient:'Agregar persona de oración',
    nameRequired:'El nombre es obligatorio', selectMember:'Por favor selecciona un miembro de Ignite',
    failedSave:'Error al guardar',
    prayFor:'Orar por', myNotes:'Mis notas', addNotes:'+ Agregar notas…', editNotes:'Editar', editingMyNotes:'Editando mis notas',
    viewWeek:'Semana', viewMonth:'Mes', todayBtn:'Hoy',
    statsAllPrayed:'Todo orado por hoy',
    statsStillToday:(n)=>`${n} ${n===1?'oración':'oraciones'} aún por hoy`,
    prayNowBtn:'Orar ahora',
    motivStart:'Ora hoy para comenzar una nueva racha.',
    motivBeatBest:(d,best)=>`¡${d} ${d===1?'día':'días'} más para superar tu mejor racha de ${best}!`,
    motivNewRecord:'¡Estás en tu racha más larga! Sigue así.',
    motivGoingStrong:(n)=>`${n} días firmes. ¡Mantén la cadena!`,
    motivAllDone:'Hoy elevaste a todos en oración. Bien hecho.',
    motivAllDoneStreak:'¡Todos elevados, y tu racha más larga hasta ahora!',
    myRelationship:(rel)=>`Mi ${rel}`,
    prayedToday:'Oré hoy', prayButton:'¡Oré!', prayTodayMenu:'Orar hoy', prayingButton:'Orando…', prayedButton:'¡Oré!',
    samplePrayer:'Oración de muestra', generatePrayer:'Generar oración de muestra',
    generatingPrayer:'Generando…', noPrayersDay:'No hay oraciones programadas para este día.',
    couldNotSaveNotes:'No se pudieron guardar las notas', couldNotMarkPrayed:'No se pudo marcar como orado',
    couldNotGenerate:'No se pudo generar la oración',
    wantToBrighten:'¿Quieres alegrarle el día?',
    nudges:(name)=>[
      `"Hola ${name} — saliste en mi calendario de oración hoy. ¿Hay algo específico por lo que pueda orar por ti esta semana?"`,
      `"Hola ${name}, solo quería que supieras que oré por ti hoy. ¿Cómo estás?"`,
      `"${name}, estuviste en mi corazón hoy — te eleví en oración. ¡Espero que estés muy bien!"`,
      `"Hola ${name}, pensando en ti hoy y orando. ¿Hay alguna petición que pueda llevar a Dios por ti?"`,
      `"Hola ${name} — pensé en ti durante mi tiempo de oración. Solo quería que supieras que estás siendo orado/a ❤️"`,
      `"${name}, ¡oré por ti hoy! Me encantaría saber cómo puedo ser más específico/a al orar por ti."`,
    ],
    addBtn:'Agregar',
    calMyRequest:'Mi Petición',
    yourPrayerRequest:'Tu petición de oración', fromNetwork:(name)=>`De ${name || 'tu red'}`,
    prayerRequestLabel:'Petición de oración',
    activeLabel:'Activas', answeredLabel:'Respondidas',
    activeToday:'Activo hoy', activeYesterday:'Activo ayer', activeDaysAgo:(d)=>`Activo hace ${d}d`,
    addToCalendar:'Orar en día específico', addingToCalendar:'Agregando…',
    addToCalendarShort:'Calendario', addedToCalendarShort:'Agregado',
    prayToday:'Orar hoy', pickADay:'Elegir un día…', praySpecificDay:'Orar en día específico', removeFromList:'Quitar de la lista',
    addUpdate:'Agregar actualización', updatesLabel:(n)=>`${n} Actualización${n!==1?'es':''}`, updatePlaceholder:'Comparte una actualización de oración…', showMoreUpdates:(n)=>`Mostrar ${n} actualización${n!==1?'es':''} más`,
    copyPrayer:'Copiar', sharePrayer:'Compartir', newPrayer:'Nueva',
    previousPrayer:'Oración anterior', nextPrayer:'Oración siguiente',
    discoverTitle:'Descubrir', requestsTitle:'Peticiones',
    discoverEmpty:'Estás al día', discoverEmptyDesc:'No hay nuevas peticiones de tu red en este momento.',
    discoverReviewBtn:'Revisar peticiones pasadas', discoverReviewMode:'Revisando peticiones pasadas',
    discoverReviewEmpty:'Las has revisado todas', discoverReviewEmptyDesc:'Nada más que revisar por ahora.',
    addPrayerRequest:'Agregar una petición de oración',
    myRequests:'Mis Peticiones', prayingFor:'Orando Por',
    youPrayed:(n)=>`Oraste ${n}×`,
    godAnswered:'¡Dios respondió!', godAnsweredTitle:'Dios respondió esta oración', editRequest:'Editar', deleteRequest:'Eliminar', reportRequest:'Reportar',
    yourPrayerListEmpty:'Tu lista de oración está vacía',
    prayerListEmptyDesc:'Desliza a la derecha las peticiones en la pestaña Descubrir para agregarlas aquí.',
    quickAddRecipients:'Agregar personas rápidamente', addMultiplePeople:'Agrega varias personas a la vez',
    showMore:'Ver más', showLess:'Ver menos',
    addToCalendarDone:'Agregado al calendario', addToCalendarBtn:'Agregar al calendario',
    pickDateAdd:'Add',
    chooseDate:'Por favor elige una fecha.',
    addedToday:'Agregado a tu calendario de oración para hoy.',
    addedDate:'Agregado a tu calendario de oración.', couldNotAdd:'No se pudo agregar al calendario',
    showMore:'Ver más', showLess:'Ver menos',
    removeConfirm:'¿Quitar esta persona de oración?',
    noPrayerRecipients:'Aún no hay personas de oración', noneInFilter:'Nadie en este filtro',
    addPeoplePrompt:'Agrega personas por las que quieras orar.',
    tryDifferentFilter:'Prueba otro filtro.',
    noRecipientsYet:'Agrega personas por las que orar y tu calendario se construirá automáticamente.',
    failedToLoad:'No se pudieron cargar los datos de oración. Inténtalo de nuevo.',
    memorial: {
      toggle: 'Esta persona ha fallecido',
      toggleSub: 'Cambiar a modo de oración memorial',
      convertBtn: 'Marcar como fallecido/a',
      passedOnLabel: 'Fecha de fallecimiento',
      passedOnOptional: '(opcional)',
      frequencyLabel: 'Con qué frecuencia recordar en oración',
      frequencyOptions: {
        anniversaries: 'Solo en aniversarios',
        anniversariesDesc: 'Aniversario de fallecimiento · Día de Todos los Santos · Navidad · Pascua',
        monthly: 'Una vez al mes',
        monthlyDesc: 'El mismo día cada mes',
        quarterly: 'Trimestralmente',
        quarterlyDesc: 'Enero, abril, julio y octubre',
      },
      faithLegacyLabel: 'Su legado de fe',
      faithLegacyPlaceholder: 'Una frase sobre su caminar con Dios — p.ej. "Ella oraba por mí cada mañana"',
      faithLegacyOptional: '(opcional)',
      calEventLabel: 'Recordando a',
      calEventSub: 'Oración memorial',
      detailTitle: (name) => `Recordando a ${name}`,
      detailSub: 'En gratitud por su vida y su fe',
      prayedBtn: 'Los recordé en oración',
      recipientTag: 'Memorial',
      anniversaryTag: 'Aniversario',
      allSaintsTag: 'Día de Todos los Santos',
      christmasTag: 'Navidad',
      easterTag: 'Pascua',
      monthlyTag: 'Recuerdo mensual',
      quarterlyTag: 'Recuerdo trimestral',
    },
  },

  bibleStudy: {
    title:'Estudio Bíblico',
    subtitle:'Deja que la Palabra te examine',
    newStudy:'Nuevo estudio', currentStudy:'Estudio actual', pastStudies:'Estudios anteriores',
    searchBooks:'Buscar libros…',
    oldTestament:'Antiguo Testamento', newTestament:'Nuevo Testamento',
    noMatch:(q)=>`No hay libros que coincidan con "${q}".`,
    chaptersHint:'Toca los capítulos para seleccionarlos.',
    chaptersSelected:(n,chs)=>`${n} capítulo${n>1?'s':''} seleccionado${n>1?'s':''}: ${chs}`,
    continueToVerses:'Continuar a los versículos →',
    tapOrDrag:'Toca o arrastra para seleccionar versículos. Puedes seleccionar en varios capítulos.',
    dragHint:'Toca un versículo para seleccionarlo · Mantén y arrastra para seleccionar un rango',
    chapter:(n)=>`Capítulo ${n}`,
    tapToSelect:'toca para seleccionar versículos',
    versesSelected:(n)=>`${n} versículo${n>1?'s':''} seleccionado${n>1?'s':''}`,
    diveIn:'Iniciar estudio bíblico',
    generate:'Generar estudio', generating:'Generando…',
    preparingStudy:'Preparando tu estudio…',
    aiStudying:'La IA de Ignite está estudiando el pasaje — esto toma unos segundos.',
    saveAnswers:'Guardar mis respuestas',
    saving:'Guardando…', savedLabel:'Respuestas guardadas',
    background:'Contexto y trasfondo',
    readInTranslations:'📖 Lee el pasaje en al menos 2 traducciones diferentes',
    translationsNote:(ref)=>`Te animamos a leer ${ref} en varias traducciones antes de responder las preguntas. Cada traducción ofrece una perspectiva única.`,
    loadingPassage:'Cargando pasaje\u2026',
    aboutGod:'¿Qué nos dice este pasaje sobre Dios y/o Jesús?',
    aboutHumans:'¿Qué nos dice este pasaje sobre las personas?',
    howRespond:'¿Cómo te está invitando Dios a responder a este pasaje?',
    sharePrompt:'💬 ¿Hay alguien a quien podrías animar compartiendo este pasaje?',
    shareHint:'Piensa en alguien que podría ser bendecido por estos versículos. ¿Quién te viene a la mente?',
    shareAnswerPlaceholder:'¿Quién te vino a la mente? Puedes anotar su nombre o escribir un pensamiento sobre cómo acercarte…',
    thinkFirst:'Piensa primero en esta pregunta tú mismo, luego toca para ver los pensamientos de la IA de Ignite.',
    yourAnswer:'Tu respuesta (privada)…',
    personalReflection:'Tu reflexión personal (privada)',
    newStudyBtn:'← Nuevo estudio',
    bibleStudyLabel:'Estudio Bíblico',
    savedStudies:(n)=>`${n} estudio${n===1?'':'s'} guardado${n===1?'':'s'} — toca para revisar y seguir reflexionando.`,
    noStudiesYet:'Aún no hay estudios bíblicos',
    noStudiesDesc:'Comienza tu primer estudio arriba y aparecerá aquí para referencia futura.',
    startStudy:'Iniciar un estudio',
    loadingPast:'Cargando estudios anteriores…',
    noStudies:'Aún no hay estudios anteriores.', delete:'Eliminar',
    deleteConfirm:'¿Eliminar este estudio bíblico? Esta acción no se puede deshacer.',
    inspireMe:'✨ Inspirarme — IA elige un pasaje',
    inspiring:'Eligiendo un pasaje…',
    failedGenerate:'Error al generar el estudio bíblico',
    failedSave:'Error al guardar', failedLoad:'Error al cargar el estudio', failedDelete:'Error al eliminar',
    lessons:(n)=>`${n} lecciones`, done:'completadas',
    complete:'Completo', back:'Atrás', lessons2:'Lecciones', by:'por',
    selectBook:'Selecciona un libro de la Biblia para comenzar tu estudio.',
    selectChapters:(book)=>`Selecciona uno o más capítulos en ${book}. Puedes elegir varios para seleccionar versículos en ellos.`,
    chapterAbbr:(n)=>`Cap. ${n}`,
    chaptersAbbr:(n)=>`${n} capítulos`,
    // ── Compartir ──
    shareStudyBtn:'Compartir',
    shareTitle:'Compartir este estudio',
    shareWhoCanView:'Quién puede ver',
    shareVisPublic:'Cualquiera con el enlace',
    shareVisPublicDesc:'Funciona para cualquiera, incluso sin una cuenta.',
    shareVisConnections:'Solo conexiones',
    shareVisConnectionsDesc:'Solo tus conexiones, con sesión iniciada, pueden abrirlo.',
    shareIncludeAnswers:'Incluir mis respuestas de reflexión',
    shareIncludeAnswersHint:'Desactivado por defecto: tus notas privadas siguen siendo privadas a menos que lo actives.',
    shareCreateLink:'Crear enlace',
    shareCopy:'Copiar',
    shareCopied:'Copiado',
    shareUpdate:'Actualizar',
    shareUpdateHint:'¿Cambiaste las opciones de arriba? Toca Actualizar para aplicarlas al enlace.',
    shareSendMessage:'Enviar en un mensaje',
    shareStop:'Dejar de compartir',
    shareCancel:'Cancelar',
    shareBack:'Atrás',
    shareSendSub:'Envía este estudio a una conexión en un mensaje directo.',
    shareSearchConnections:'Buscar conexiones…',
    shareNoConnections:'Aún no tienes conexiones.',
    shareDmNotePlaceholder:'Añade una nota… (opcional)',
    shareSentTo:(name)=>`Enviado a ${name}`,
    shareFailed:'Algo salió mal. Inténtalo de nuevo.',
    sharedBy:(name)=>`Compartido por ${name}`,
    sharedReflectionLabel:(name)=>`Reflexión de ${name}`,
    shareNotFoundTitle:'Estudio no encontrado',
    shareNotFoundBody:'Es posible que este estudio se haya eliminado o se haya hecho privado.',
    shareForbiddenTitle:'Inicia sesión para ver',
    shareForbiddenBody:'Este estudio se comparte con las conexiones del autor. Inicia sesión para ver si tienes acceso.',
    shareSignIn:'Iniciar sesión',
    shareJoinCta:'Únete a Ignite',
    shareLearnMore:'Conoce más sobre Ignite',
  },

  communities: {
    title:'Comunidades', subtitle:'Caminen juntos en la fe', addBtn:'Agregar',
    searchPlaceholder:'Buscar comunidades…',
    tabs:{ mine:'Las mías', pending:'Pendientes', discover:'Descubrir' },
    types:{
      church:'Iglesia', ministry:'Ministerio', missional:'Misional / Evangelización',
      small_group:'Grupo pequeño', bible_study:'Estudio bíblico',
      prayer_group:'Grupo de oración', recovery:'Recuperación',
      family_friends:'Familia y amigos',
      interests_hobbies:'Intereses y pasatiempos',
      // Etiquetas heredadas — se mantienen para que las comunidades existentes sigan mostrando un nombre
      neighborhood:'Vecindario', friend:'Grupo de amigos', family:'Familia',
      volunteer:'Voluntariado',
    },
    visibility:{
      public:'Público', private:'Privado', hidden:'Oculto',
      publicDesc:'Cualquiera puede ver y unirse',
      privateDesc:'Visible, pero se debe solicitar unirse',
      hiddenDesc:'Solo por invitación, no aparece en búsquedas',
    },
    join:'Unirse', leave:'Salir', open:'Abrir',
    requestToJoin:'Solicitar unirse', requested:'Solicitado',
    noCommunities:'Aún no hay comunidades',
    joinOrCreate:'Únete a una comunidad o crea la tuya.',
    browse:'Explorar comunidades',
    nothingToDiscover:'Nada por descubrir',
    featured:'Destacada',
    createYourOwn:'Crea una nueva comunidad para tu grupo.',
    activeToday:'Activo hoy', activeYesterday:'Activo ayer', activeDaysAgo:(d)=>`Activo hace ${d}d`,
    failedLoad:'No se pudieron cargar las comunidades',
    somethingWrong:'Algo salió mal',
    createModal:{
      title:'Crear una comunidad',
      steps:['Básico','Privacidad','Funciones'],
      featuresTitle:'¿Qué usará esta comunidad?',
      featuresHelp:'Puedes cambiar todo esto después en Funciones de la Comunidad.',
      nameLabel:'Nombre de la comunidad *', namePlaceholder:'p. ej. Grupo de oración del domingo',
      descLabel:'Descripción', descPlaceholder:'¿De qué trata esta comunidad?',
      typeLabel:'Tipo',
      parentLabel:'Comunidad principal', parentOptional:'— opcional',
      parentSearch:'Busca tus comunidades…',
      nameRequired:'El nombre es obligatorio', failedCreate:'Error al crear',
      createBtn:'Crear comunidad 🎉',
      subCommunity:'Subcomunidad',
    },
  },

  community: {
    tabs:{ home:'Inicio', feed:'Publicaciones', activity:'Actividad', bible:'Plan de Lectura Bíblica', growth:'Crecimiento', calendar:'Calendario', members:'Miembros', chat:'Chat', sub:'Subcomunidades', invites:'Invitaciones', manage:'Gestionar', leave:'Salir', rhythm:'Ritmo Diario', features:'Funciones de la Comunidad', fasting:'Ayuno' },

    // Interruptores de funciones para organizadores (/communities/:id/features).
    // Cada texto dice qué pierden los miembros al desactivar la función: no son
    // preferencias, cada una quita una sección para toda la comunidad.
    features: {
      title:    'Funciones de la Comunidad',
      subtitle: 'Elige qué ofrece esta comunidad. Lo que desactives desaparece para los miembros — no se borra nada, y al volver a activarlo reaparece igual.',
      savedNote:'Los cambios se aplican a todos de inmediato.',
      calendar: {
        label: 'Calendario',
        hint:  'Eventos, la franja semanal en Inicio y la lista de próximos eventos.',
        disableConfirm: '¿Desactivar el Calendario? Los miembros dejarán de ver los eventos y la franja semanal, y la sala de Zoom se ocultará con él. Tus eventos se conservan.',
      },
      biblePlans: {
        label: 'Planes de Lectura Bíblica',
        hint:  'Planes de lectura compartidos con lecturas diarias y preguntas de reflexión.',
        disableConfirm: '¿Desactivar los Planes de Lectura Bíblica? Los miembros perderán el acceso a todos los planes de esta comunidad hasta que vuelvas a activarlos. Sus reflexiones siguen en su Diario.',
      },
      growth: {
        label: 'Planes de Crecimiento',
        hint:  'La vista compartida de los planes de crecimiento que los miembros hacen juntos aquí.',
        disableConfirm: '¿Desactivar los Planes de Crecimiento? Los miembros conservan todos los planes en los que están inscritos — solo desaparece la vista compartida de esta comunidad.',
      },
      zoom: {
        label:        'Sala de Zoom',
        hint:         'Una reunión de Zoom recurrente para esta comunidad, visible en el Calendario.',
        requiresCalendar: 'Activa el Calendario para usar una sala de Zoom.',
        disableConfirm:   '¿Desactivar la sala de Zoom? El enlace dejará de mostrarse a los miembros. La reunión se conserva — usa Eliminar sala abajo para borrarla definitivamente.',
      },
      fasting: {
        label: 'Ayuno',
        hint:  'Ayunos en relevo o juntos con hoja de inscripción, recordatorios y una página pública opcional para quienes no tienen la app.',
        disableConfirm: '¿Desactivar el Ayuno? Los miembros y la página pública pierden el acceso, y los recordatorios se detienen. Todos los ayunos e inscripciones se conservan.',
      },
    },
    switcher:{
      label:'Cambiar comunidad',
      exploreMore:'Explorar',
      exploreAria:'Explorar más comunidades',
    },
    home:{
      happeningNow:'Ahora mismo',
      serviceStartingIn:(mins)=>`El servicio comienza en ${mins} min`,
      serviceLive:'En vivo ahora — únete a la sala',
      joinNow:'Unirse Ahora',
      todayReadingDue:'La lectura de hoy está lista',
      eventStartsIn:(label, dur)=>`${label} en ${dur}`,
      todayReading:'Lectura de hoy',
      dayOfN:(day, total)=>`Día ${day} de ${total}`,
      noActivePlan:'Aún no hay plan de lectura',
      startReadingPlan:'Iniciar un plan de lectura',
      readingProgress:'Tu progreso',
      thisWeek:'Esta semana',
      nextEvent:'Próximo evento',
      noEventsThisWeek:'No hay eventos esta semana',
      addFirstEvent:'Agregar un evento',
      growthPlan:'Plan de crecimiento',
      sessionOfN:(s, total)=>`Sesión ${s} de ${total}`,
      membersInPlan:(n)=> n===1 ? '1 miembro en este plan' : `${n} miembros en este plan`,
      noGrowthPlan:'Aún no hay plan de crecimiento',
      addGrowthPlan:'Iniciar un plan de crecimiento',
      theWell:'El Pozo',
      latestSermon:'Última conversación de sermón',
      repliesCount:(n)=> n===1 ? '1 respuesta' : `${n} respuestas`,
      noWellThreads:'Aún no hay conversaciones de sermón',
      addWellThread:'Iniciar una conversación',
      subCommunities:'Subcomunidades',
      recentActivity:'Actividad reciente',
      seeAll:'Ver todo',
      noRecentPosts:'Sé el primero en compartir',
      membersTitle:'Miembros',
      upcomingEvents:'Próximos eventos',
      organizerTools:'Herramientas de organizador',
      viewAll:'Ver todo',
      more:'Más',
      overflowMenuTitle:'Menú de comunidad',
      comingSoon:'Próximamente',
      viewAllPlans:'Ver todos los planes de lectura',
      viewAllGrowthPlans:'Ver todos los planes de crecimiento',
      viewAllThreads:'Ver todas las conversaciones',
      personOne:'persona',
      personMany:'personas',
      shareWithCommunity:'Comparte con la comunidad…',
      nextUp:'Lo siguiente para ti',
      planComplete:'¡Has completado este plan!',
      planNotStarted:'Este plan aún no ha comenzado.',
      tapToRead:'Toca para leer',
      wellSubtitle:'Continúa la conversación sobre el sermón del domingo',
      growthPlanSubtitle:'Crezcan juntos como comunidad',
      todayReadingSubtitle:'Mantén el ritmo con tu comunidad',
      recentActivitySubtitle:'Lo que está en el corazón de todos',
      // Non-member landing
      joinToSee:'Únete para ver lo que hay dentro',
      joinToSeeSubtitle:'Los planes de lectura, planes de crecimiento, discusiones de sermones y el feed de la comunidad están disponibles para los miembros.',
      joinToSeePrivateSubtitle:'Esta es una comunidad privada. Los miembros tienen acceso a planes de lectura, planes de crecimiento, discusiones de sermones y el feed de la comunidad.',
      invitedTitle:'Estás invitado',
      invitedSubtitle:'Esta es una comunidad privada, solo por invitación. Solo los miembros pueden verla.',
      invitedBody:'Toca Aceptar invitación arriba para unirte y ver todo lo que hay dentro.',
      joinPromptBody:'Usa el botón de arriba para unirte (o solicitar unirte) a esta comunidad y desbloquear todo su contenido.',
    },
    acceptInviteBtn:'Aceptar invitación',
    join:'Unirse', leave:'Salir', request:'Solicitar', pending:'Pendiente',
    leaveConfirm:'¿Salir de esta comunidad?',
    leaveTab:{
      title:'Salir de la Comunidad',
      btn:'Salir de la Comunidad',
      publicNote:'Puedes volver a unirte en cualquier momento.',
      privateNote:'Esta es una comunidad privada. Necesitarás solicitar permiso para volver a unirte.',
      hiddenNote:'Esta es una comunidad oculta. Ya no podrás verla y necesitarás una invitación directa para volver.',
    },
    parentCommunity:'Comunidad Principal',
    parentPlaceholder:'Seleccionar comunidad (opcional)',
    parentNone:'Ninguna',
    deleteConfirm:(name)=>`¿Eliminar "${name}"? Esta acción no se puede deshacer.`,
    postTypes:{
      reflection:'Reflexión', scripture:'Escritura', prayer:'Oración', praise:'Alabanza', surrender:'Rendición',
      prayer_request:'Petición de Oración',
    },
    placeholders:{
      reflection:'¿Qué tienes en el corazón hoy?',
      scripture:'Comparte un versículo que te habló…',
      prayer:'¿Por qué quisieras oración?',
      praise:'Comparte algo que vale la pena celebrar…',
      surrender:'¿Qué le estás entregando a Dios hoy?',
    },
    sharePlaceholder:'Compartir con la comunidad…',
    writeSomething:'Por favor escribe algo primero', failedPost:'Error al publicar',
    sharedWithComm:'¡Compartido con la comunidad! ✨',
    noPostsYet:'Aún no hay publicaciones', beFirstComm:'¡Sé el primero en compartir!',
    shareModalTitle:'Compartir con la comunidad',
    postingTo:'Publicando solo en esta comunidad',
    deletePost:'¿Eliminar esta publicación?',
    zoomRoom:'Sala Zoom de la comunidad', zoomAvailable:'Siempre disponible — únete cuando quieras',
    zoomPasscode:(code)=>`Contraseña: ${code}`, joinNow:'Unirme ahora',
    upcomingEvents:'Próximos eventos',
    noUpcomingEvents:'No hay eventos próximos', addEventPrompt:'Agrega eventos para tu comunidad.',
    addEvent:'+ Agregar evento',
    days:['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'],
    repeats:(r)=>`Se repite ${r}`,
    eventModal:{
      addTitle:'Agregar evento', editTitle:'Editar evento',
      titleLabel:'Título *', titlePlaceholder:'p. ej. Servicio dominical',
      descLabel:'Descripción', locationLabel:'Lugar',
      locationPlaceholder:'p. ej. Salón principal o enlace de Zoom',
      startLabel:'Inicio *', endLabel:'Fin',
      repeatsLabel:'Se repite', onDaysLabel:'Los días',
      repeatOptions:{ none:'No se repite', daily:'Diariamente', weekly:'Semanalmente', biweekly:'Cada dos semanas', monthly:'Mensualmente' },
      addBtn:'Agregar evento', editBtn:'Actualizar evento',
    },
    roles:{ organizer:'Organizador', co_organizer:'Co-organizador', member:'Miembro' },
    removeFromComm:'¿Quitar a este miembro?',
    joinRequests:(n)=>`Solicitudes de unión (${n})`,
    membersCount:(n)=>`Miembros (${n})`,
    accept:'Aceptar',
    chatPlaceholder:'Mensaje a la comunidad…',
    chatMsgPlaceholder:'Mensaje…',
    noMessages:'Aún no hay mensajes',
    beFirstChat:'¡Sé el primero en decir algo!',
    noSubComms:'Sin subcomunidades',
    noSubCommsDesc:'Crea una subcomunidad cuando necesites un grupo más específico dentro de este.',
    searchInvite:'Buscar miembros para invitar…',
    sentInvites:(n)=>`Invitaciones enviadas (${n})`,
    noInvites:'Aún no hay invitaciones',
    noInvitesDesc:'Invita personas arriba para hacer crecer tu comunidad.',
    invite:'Invitar',
    manage:{
      title:'Gestionar', typeLabel:'Tipo', visibilityLabel:'Visibilidad',
      communityName:'Nombre de la comunidad', description:'Descripción',
      communityInfo:'Información de la comunidad',
      visibilityOptions:{
        public:'Público — cualquiera puede ver y unirse',
        private:'Privado — cualquiera puede ver, pero debe solicitar unirse',
        hidden:'Oculto — solo por invitación, no aparece en búsquedas',
      },
      saveChanges:'Guardar cambios',
      changeCover:'Cambiar portada', addCover:'Agregar foto de portada',
      zoomSection:'Sala Zoom', joinLink:'Enlace para unirse', hostLink:'Enlace de anfitrión',
      openHost:'Abrir como anfitrión →', passcodeLabel:'Contraseña',
      replace:'Reemplazar sala', removeZoom:'Eliminar',
      noRoom:'No hay sala Zoom asignada. Crea una para que los miembros siempre tengan un enlace de reunión.',
      createRoom:'Crear sala Zoom',
      replaceConfirm:'Esto reemplazará la sala Zoom existente con una nueva. Los miembros con el enlace anterior necesitarán el nuevo. ¿Continuar?',
      removeConfirm:'¿Eliminar la sala Zoom de esta comunidad? Los miembros perderán acceso al enlace.',
      zoomRemoved:'Sala Zoom eliminada.',
      dangerZone:'Zona de peligro', deleteCommunity:'Eliminar esta comunidad',
    },
    biblePlan:{
      allPlans:'Todos los planes', editPlan:'Editar plan', download:'Descargar', editDay:'Editar Día',
      editDayModal:{title:(n)=>`Editar Día ${n}`,titleOptional:'Título del día (opcional)',dayTitle:'ej. Caminando en Fe',verses:'Versículos bíblicos',versesPlaceholder:'ej. Juan 3:16-18',commentary:'Comentario / Devocional',commentaryLabel:'Comentario',commentaryPlaceholder:'Notas devocionales breves para este día...',questions:'Preguntas de reflexión',addQuestion:'Agregar pregunta',saveChanges:'Guardar cambios'},
      createReadingPlan:'Crear plan de lectura',
      days:(n)=>`${n} día${n===1?'':'s'}`,
      noDaysYet:'Aún no hay días',
      noDaysDesc:'Los organizadores pueden agregar días de lectura.',
      noPlansOrg:'Crea un plan de lectura bíblica para tu comunidad.',
      noPlansMember:'Pídele a un organizador que cree un plan de lectura.',
      noPlans:'Aún no hay planes de lectura.',
      addDay:(uw)=>`+ Agregar ${uw}`,
      unitWord:'Día', unitWordWeek:'Semana', unitWordReading:'Lectura',
      weekNum:(n)=>`Semana ${n}`,
      readingNum:(n)=>`Lectura ${n}`,
      thisWeek:'Esta semana',
      weekProgress:(done,total)=>`${done} de ${total} hechas`,
      noReadingsThisWeek:'Aún no hay lecturas — agrega algunas.',
      noReadingsYet:'Aún no hay lecturas para esta semana.',
      lockedTitle:'Lectura bloqueada',
      lockedSub:(range)=>`Disponible ${range}.`,
      startsOn:(date)=>`Comienza el ${date}`,
      notStartedYet:'El plan empieza en su fecha de inicio — las lecturas se desbloquearán entonces.',
      planEnded:'Plan finalizado',
      createNextYear:'Crea un nuevo plan para continuar el próximo año.',
      readingPlanLabel:'Plan de Lectura',
      scripturePassage:'Pasaje bíblico *',
      addDayBtn:(uw)=>`Agregar ${uw}`,
      activeBadge:'Activo', draftBadge:'Borrador',
    planCategory: 'Categoría',
    planRating: 'Clasificación de contenido',
    oakdaleCore4Label: 'Incluir siempre las 5 preguntas Oakdale',
    oakdaleCore4Desc: 'La IA siempre incluirá las 5 preguntas de reflexión estándar y agregará 1–3 más.',
    aiAutoFillLabel: 'Completar campos vacíos con IA',
    aiAutoFillDesc: 'Un proceso en segundo plano completará cualquier Título o Comentario vacío con contenido bíblico específico al plan, normalmente en pocos minutos.',
    narratorVoice: 'Voz del narrador',
    narratorVoiceDesc: 'Voz utilizada al generar audio para las unidades de este plan.',
    voiceFemale: 'Femenina',
    voiceMale: 'Masculino',
    voiceBoth: 'Ambas',
    publishedLabel: 'Publicado',
    publishedDesc: 'Visible para usuarios inscritos',
    unpublishedDesc: 'Oculto — solo visible para ti',
    categories: {
      faith_foundations:    'Fundamentos de fe',
      universal_human:      'Solo soy humano',
      battles_against_sin:  'Batallas contra el pecado',
      grief_and_loss:       'Duelo y pérdida',
      real_world:           'Situaciones de la vida real',
      discipleship:         'Discipulado',
      church_community:     'Iglesia y comunidad',
    },
    ratings: {
      everyone:            '✅ Para todos',
      everyoneDesc:        'Apto para todas las edades',
      guidance_suggested:  '👁 Guía parental',
      guidanceDesc:        'Algunos temas maduros — apropiado para adolescentes y adultos',
      mature:              '🔞 Maduro',
      matureDesc:          'Aborda pecado explícito, adicción, integridad sexual o duelo profundo — solo adultos',
    },
      brpDayShort:'día', brpWeekShort:'sem',
      publishConfirm:'¿Publicar este plan? Se notificará a los miembros.',
      backToPlan2:'Volver al plan',
      communityProgressLabel:'Progreso de la comunidad',
      editCoverBtn:'Editar portada',
      repositionBtn:'Reposicionar',
      planCategory: 'Categoría', planRating: 'Clasificación de contenido',
    oakdaleCore4Label: 'Incluir siempre las 5 preguntas Oakdale',
    oakdaleCore4Desc: 'La IA siempre incluirá las 5 preguntas estándar y agregará 1–3 más.',
    narratorVoice: 'Voz del narrador',
    narratorVoiceDesc: 'Voz utilizada al generar audio para las unidades de este plan.',
    voiceFemale: 'Femenina',
    voiceMale: 'Masculino',
    voiceBoth: 'Ambas',
    publishedLabel: 'Publicado', publishedDesc: 'Visible para usuarios inscritos',
    unpublishedDesc: 'Oculto — solo visible para ti',
    loadingPassage:'Cargando pasaje…',
      addCustomQuestion:'Agregar pregunta personalizada',
      commentaryLabel:'Comentario',
      readMultipleTranslations:'Leer en múltiples traducciones',
      studyPassage:'Estudiar este pasaje',
      alwaysIncluded:'Siempre incluido',
      chooseAnswersToShare:'Elige qué respuestas compartir con tu comunidad. Las Escrituras siempre se incluyen.',
      postToCommunity:'Publicar en la comunidad',
      shareReflectionTitle:'Compartir reflexión',
      noActivityYet:'Aún no hay actividad',
      noActivityDesc:(uw)=>`Completa un ${uw} y comparte tu reflexión para comenzar.`,
      noReflectionsYet:'Aún no hay reflexiones compartidas',
      noReflectionsDesc:(uw)=>`Toca "Compartir con la comunidad" al completar un ${uw}.`,
      progressStages:['Apenas comenzando','Creciendo en fe','Construyendo juntos','Comunidad fuerte','¡Casi terminamos!','¡Comunidad completa!'],
      progressSub:'toca para ver reflexiones',
      beFirstComplete:(uw)=>`Sé el primero — completa un ${uw} para comenzar`,
      updateBtn:'Actualizar',
      cancelBtn:'Cancelar',
      publishBtn:'Publicar',
      downloadFailed:'Error al descargar',
      couldNotPublish:'No se pudo publicar',
      couldNotShare:'No se pudo compartir',
      uploadingMedia:'Subiendo…',
      photoUploadFailed:'Error al subir la foto',
      coverUpdateFailed:'Error al actualizar la portada',
      backToAllPlans:'Todos los planes',
      dayNum:(n)=>`Día ${n}`,
      reflectionQuestions:'Preguntas de reflexión',
      yourThoughts:'Tus pensamientos…',
      addCustomQuestion:'+ Agregar pregunta personalizada',
      backToPlan:'← Volver al plan',
      savePrivately:'Guardar de forma privada',
      shareWithComm:'Compartir con la comunidad',
      createPlan:'Crear plan',
      titleLabel:'Título del plan *', aiGenerate:'Generar con IA', aiGenerating:'Generando…',
      createModal:{
        title:'Crear plan de lectura',
        titleLabel:'Título del plan *', titlePlaceholder:'p. ej. 30 días en los Salmos',
        descLabel:'Descripción', descPlaceholder:'¿Qué leerá tu comunidad?',
        totalDays:'Total de días',
        addManually:'Agregar días manualmente',
        createWithAI:'Crear con IA ✨',
        aiDesc:(n)=>`La IA planifica las ${n} lecturas con versículos, devocionales y preguntas para tu comunidad.`,
        aiStatus:'Pidiendo a la IA que elabore tu plan de lectura…',
        saving:(n)=>`Guardando plan con ${n} días…`,
        progressOutline:(done, total)=>`Eligiendo pasajes… ${done} de ${total}`,
        progressSaving:'Guardando tu plan…',
        progressWriting:(done, total)=>`Escribiendo devocionales… ${done} de ${total} lecturas`,
        keepOpen:'Mantén esta ventana abierta: un plan largo tarda unos minutos.',
        partialDone:(n)=>`Tu plan se guardó como borrador, pero ${n===1?'a 1 lectura le falta':`a ${n} lecturas les falta`} el devocional. Se completarán automáticamente en segundo plano; publica el plan cuando estén listas.`,
        draftNotPublished:'Tu plan está listo, pero no se pudo publicar. Se guardó como borrador; publícalo desde Editar.',
        openPlan:'Abrir plan',
        capHint:(n, max)=>`Son ${n} lecturas. Un plan de lectura puede tener como máximo ${max} días, semanas o lecturas.`,
        aiFailed:'La generación con IA falló. Inténtalo de nuevo.',
      },
      weekStart:{
        label:'Fecha de inicio (primer día de la semana 1)',
        shape:(from, to)=>`Las semanas van de ${from} a ${to}`,
        week1:(range)=>`Semana 1: ${range}`,
        lastWeek:(n, range)=>`Semana ${n}: ${range}`,
        hint:'Cualquier día sirve. ¿Se reúnen los domingos? Empiecen el lunes anterior, así la reunión cae en el último día de la semana que comentan y la siguiente semana se abre a la mañana siguiente.',
      },
      editModal:{
        title:'Editar plan de lectura',
        titleLabel:'Título del plan', descLabel:'Descripción', totalDays:'Total de días',
        saveChanges:'Guardar cambios',
        regenerate:'Regenerar con IA',
        regenerateNote:'Regenerar reemplaza todos los días existentes con contenido nuevo generado por IA.',
        deletePlan:'Eliminar este plan',
        regenerateConfirm:(n)=>`Regenerar reemplazará los ${n} días existentes con contenido nuevo de IA. Las respuestas de los miembros se perderán. ¿Continuar?`,
        deleteConfirm:(title)=>`¿Eliminar "${title}"? Todos los días y respuestas de los miembros se perderán.`,
        regenerating:'Generando nuevos días con IA…',
        savingRegen:(n)=>`Guardando ${n} días regenerados…`,
        regenFailed:'La regeneración falló. Inténtalo de nuevo.',
        failedSave:'Error al guardar', failedDelete:'Error al eliminar',
      },
      addDayModal:{
        title:'Agregar día de lectura',
        dayNum:'Día #', dayTitle:'Título del día',
        titleOptional:'Título (opcional)',
        verses:'Versículos *', versesPlaceholder:'p. ej. Salmo 23:1-6, Juan 10:11',
        commentary:'Comentario / Devocional (opcional)',
        commentaryPlaceholder:'Contexto opcional o pensamientos devocionales…',
        questions:'Preguntas de reflexión',
        addQuestion:'+ Agregar pregunta',
        addDay:'Agregar día',
        commentary:'Comentario / Devocional (opcional)',
        questionPlaceholder:(n)=>`Pregunta ${n}`,
      },
    },
    types:{
      church:'Iglesia', ministry:'Ministerio', missional:'Misional / Evangelización',
      small_group:'Grupo pequeño', bible_study:'Estudio bíblico',
      prayer_group:'Grupo de oración', recovery:'Recuperación',
      family_friends:'Familia y amigos',
      interests_hobbies:'Intereses y pasatiempos',
      // Etiquetas heredadas — se mantienen para que las comunidades existentes sigan mostrando un nombre
      neighborhood:'Vecindario', friend:'Grupo de amigos', family:'Familia',
      volunteer:'Voluntariado',
    },
    failedLoad:'No se pudo cargar la comunidad',
    chatBtn:'Conversar',
    brpDayShort:'día', brpWeekShort:'sem',
    readingPlanLabel:'Plan de Lectura',
    visibilityLabels:{ public:'Público', private:'Privado', hidden:'Oculto' },
    draftBadge:'Borrador', activeBadge:'Activo',
    backToCommunities:'Atrás',
    memberCount:(n)=>`${n} miembro${n===1?'':'s'}`,
  },

  profile: {
    editCover:'Editar portada', setUsername:'+ Establecer nombre de usuario',
    joined:(date)=>`Se unió el ${date}`, edit:'Editar', connections:'Conexiones',
    save:'Guardar', cancel:'Cancelar',
    firstName:'Nombre', firstNamePlaceholder:'Tu nombre',
    lastName:'Apellido', lastNamePlaceholder:'Tu apellido',
    username:'Nombre de usuario', bio:'Biografía',
    bioPlaceholder:'Cuéntale a la comunidad sobre ti',
    favoriteVerse:'Versículo favorito', versePlaceholder:'p. ej., Filipenses 4:13',
    privateSettings:'🔒 Configuración privada', privateNote:'Solo visible para ti',
    timezone:'Zona horaria', prayerReminder:'Recordatorio diario de oración',
    prayerReminderNote:'Te enviaremos un correo con la persona por quien orar cada día a esta hora.',
    noReminder:'Sin recordatorio', language:'Idioma', languageNote:'Cambia el idioma de la aplicación',
    stats:{
      postsShared:'Publicaciones', communities:'Comunidades', prayersSaid:'Oraciones',
      connections:'Conexiones', prayerRecipients:'Destinatarios de Oración', prayerRequests:'Peticiones de Oración', currentStreak:'Racha Actual',
      bestStreak:'Mejor Racha', daysActive:'Días Activo', bibleStudies:'Estudios Bíblicos',
      growthCompleted:'Planes Completados', devices:'Mis Dispositivos',
      prayerRate:'Tasa de Oración',
    },
    recentActivity: 'Mi Actividad',
    events: (n) => `${n} evento${n === 1 ? '' : 's'}`,
    prev: '← Ant',
    next: 'Sig →',
    justNow: 'justo ahora',
    mAgo: (m) => `hace ${m}m`,
    hAgo: (h) => `hace ${h}h`,
    dAgo: (d) => `hace ${d}d`,
    actLabels: {
      reflection: 'Reflexión', scripture: 'Escritura', prayer: 'Oración',
      praise: 'Alabanza', surrender: 'Rendición',
      prayer_prayed: 'Calendario de Oración', growth_unit: 'Plan de Crecimiento',
      bible_study: 'Estudio Bíblico', pray_now: 'Orar Ahora',
    },
    dayComplete: (n, title) => title ? `Día ${n}: ${title}` : `Día ${n} completado`,
    weekComplete: (n, title) => title ? `Semana ${n}: ${title}` : `Semana ${n} completada`,
    highlights: 'Resumen Espiritual',
    quickActions: 'Acciones Rápidas',
    hlSub: {
      streak: 'Calendario de oración',
      growthCompleted: 'Crecer en Dios',
      bibleStudies: 'Estudios de la Escritura',
      prayNowSessions: (n) => `Oración${n === 1 ? '' : 'es'} en voz alta`,
      daysActive: 'Miembro desde el día 1',
    },
    qaLabels: {
      prayNow: 'Orar Ahora', prayNowSub: 'Oración guiada en voz alta',
      addPrayer: 'Agregar Petición', addPrayerSub: 'Tus peticiones de oración',
      bibleStudy: 'Estudio Bíblico', bibleStudySub: 'Sumérgete en la Escritura',
      growDeeper: 'Crecer en Dios', growDeeperSub: 'Planes de crecimiento',
    },
    streakDays: (n) => `racha de ${n} días`,
    prayNowSessions: (n) => `${n} sesión${n === 1 ? '' : 'es'} Orar Ahora`,
    planCount: (n) => `${n} plan${n === 1 ? '' : 'es'} completado${n === 1 ? '' : 's'}`,
    bibleCount: (n) => `${n} estudio${n === 1 ? '' : 's'} bíblico${n === 1 ? '' : 's'}`,
    gettingStartedGuide: 'Guía de inicio',
    signOut: 'Cerrar sesión',
    dateOfBirth:'Fecha de nacimiento',
    dobDesc:'Usada para contenido adecuado a tu edad. Cambiarla recalcula tu grupo de edad.',
    dobUnder13:'Ignite es para usuarios de 13 años o más.',
    ageGroupLabel:'Grupo de edad',
    ageGroupAdult:'Adulto (18+)',
    ageGroupMinor:'Adolescente (13–17)',
    ageGroupUnset:'No establecido',
    ageGroupDisplay:(group)=>group==='adult'?'Adulto (18+)':group==='minor'?'Adolescente (13–17)':'No establecido',
  },

  notifications: {
    title:'Notificaciones', unread:(n)=>`${n} sin leer`,
    markAllRead:'Marcar todo como leído', clearAll:'¿Borrar todas las notificaciones?', clearAllBtn:'Borrar todo',
    empty:'¡Todo al día!',
    emptyDesc:'Aún no hay notificaciones. Aparecerán aquí cuando alguien te mencione, responda tus publicaciones o se conecte contigo.',
    failedLoad:'No se pudieron cargar las notificaciones', somethingWrong:'Algo salió mal',
    retry:'Reintentar',
  },

  members: {
    title:'Miembros', subtitle:'Encuentra a tu gente',
    searchPlaceholder:'Buscar por nombre o @usuario…',
    search:'Buscar', noFound:'No se encontraron miembros',
    noResults:(q)=>`Sin resultados para "${q}"`, noOthers:'Aún no hay otros miembros',
    removeConfirm:(name)=>`¿Quitar a ${name} como conexión?`,
    actionFailed:'La acción falló',
    connect:'Conectar', connected:'Conectado', sent:'Enviado', wantsToConnect:'Quiere conectarse',
    viewProfile:'Ver perfil', posts:'publicaciones', groups:'grupos',
  },

  connections: {
    title:'Conexiones', subtitle:'El hierro se afila con hierro',
    tabs:{ connected:'Conexiones', pendingReceived:'Solicitudes', pendingSent:'Enviadas' },
    noConnected:'Aún no hay conexiones. ¡Encuentra miembros para conectarte!',
    noPendingReceived:'No hay solicitudes de conexión pendientes.',
    noPendingSent:'No hay solicitudes enviadas.',
    nothingHere:'Nada aquí', accept:'Aceptar', decline:'Rechazar',
    remove:'Quitar', pending:'Pendiente…',
    removeConfirm:'¿Quitar esta conexión?',
    actionFailed:'La acción falló', findMembers:'Buscar miembros',
  },

  courses: {
    title:'Crecer en Dios', subtitle:'Arraigados y edificados en Él',
    growDeeperTitle:'Crecer en Dios', growDeeperSubtitle:'Arraigados y edificados en Él',
    tabs:{ all:'Todos', enrolled:'Mis planes', explore:'Explorar', progress:'En progreso', done:'Completados', new:'Sin empezar' },
    filterAll:'Todas las categorías',
    filters: {
      category: 'Categoría',
      duration: 'Duración',
      maturity: 'Madurez',
      new: 'Nuevo',
      activeChallenge: 'Desafío activo',
      clearAll: 'Limpiar filtros',
      days1_7: '1-7 Días',
      days8_14: '8-14 Días',
      days15_30: '15-30 Días',
      days31plus: '31+ Días',
      weeks1_4: '1-4 Semanas',
      weeks5_8: '5-8 Semanas',
      weeks9plus: '9+ Semanas',
      everyone: 'Para todos',
      guidanceSuggested: 'Guía sugerida',
      mature: 'Maduro',
      language: 'Idioma',
      langEnglish: 'Inglés',
      langSpanish: 'Español',
      langAll: 'Todos los idiomas',
    },
    startPlan:'Iniciar este plan',
    unenroll:'Salir del plan',
    unenrollConfirm:'¿Salir de este plan? Tu progreso se guardará.',
    continueWhere:'Continuar donde lo dejaste',
    byDay:'Por día (diario)', byWeek:'Por semana (semanal)',
    cadenceDay:'día', cadenceWeek:'semana', cadenceDays:'días', cadenceWeeks:'semanas',
    completed:'completado', enrolled:'Inscrito',
    commentary:'Comentario', reflectionQuestions:'Preguntas de reflexión',
    commentaryCollapse:'cerrar', commentaryRead:'leer',
    commentaryReadMore:'… leer más',
    audioCommentary:'Comentario en audio',
    narratorWoman:'Mujer', narratorMan:'Hombre',
    narratorVoiceAria:'Voz del narrador',
    narratorFemaleTitle:'Narradora',
    narratorMaleTitle:'Narrador',
    audioPlaybackSpeed:'Velocidad de reproducción',
    audioBack15:'Retroceder 15 segundos',
    audioForward15:'Adelantar 15 segundos',
    audioUnavailable:'Audio no disponible',
    audioReplay:'Reproducir de nuevo',
    audioPause:'Pausar',
    audioPlay:'Reproducir comentario',
    invitationBegin:'Comenzar',
    preparingBlessing:'Preparando tu bendición…',
    continueWithGod:'Continúa tu momento con Dios',
    prayAboutThisNow:'Ora sobre esto ahora',
    prayAboutThisNowSub:'Abre Orar Ahora con este pasaje precargado',
    addPrayerRequestAction:'Agregar una petición de oración',
    addPrayerRequestSub:'Lleva esta reflexión a tus Peticiones de oración',
    doneBackToPlan:'✓ Listo — volver al plan',
    reflectionTitlePrefix:(title)=>`Reflexión: ${title}`,
    fromGrowDeeperPlan:(title)=>`De mi plan Crecer en Dios: ${title}`,
    writeFreelyPlaceholder:'Escribe libremente — esto es entre tú y Dios…',
    savePrivately:'Guardar privado', shareWithCommunity:'Compartir con la comunidad',
    writePlaceholder:'Escribe tu reflexión…',
    readOnBibleGateway:'Leer en BibleGateway',
    download:'Descargar',
    sharePlan:'Compartir',
    reportPlan:'Reportar plan',
    linkCopied:'Enlace copiado!',
    newPlan:'Nuevo plan', createFirst:'Crear primer plan',
    nothingHere:'Nada por aquí todavía',
    noPlansAll:'Los planes de crecimiento aparecerán aquí una vez creados.',
    noPlansCategory:'No hay planes en esta categoría.',
    noPlansSearch:'Ningún plan coincide con tu búsqueda.',
    noResultsBuildDesc:'Ningún plan existente coincide — pero podemos crear uno para ti.',
    noPlansExplore:'Aún no hay planes para explorar.',
    searchPlans:'Buscar planes…',
    noPlansEnrolled:'Aún no has comenzado ningún plan.',
    completedPlansHeader:(n)=>`Planes completados (${n})`,
    allPlansCompleted:'Todos tus planes están completados. ¡Explora nuevos!',
    createManually:'Crear manualmente', createWithAI:'Crear con IA',
    userCreateTitle:'Construyamos un plan juntos',
    userCreatePromptPlaceholder:'Describe lo que estás pasando o en qué áreas sientes que te vendría bien algo de ayuda...',
    userCreatePromptRequired:'Por favor describe para qué te gustaría un plan.',
    userCreateBtn:'¡Construyámoslo!',
    userCreateGenerating:'Creando tu plan de crecimiento',
    genStepOutline:'Creando esquema',
    genStepContent:'Creando foto de portada y escribiendo comentario',
    genStepDone:'¡Listo!',
    planTitle:'Título del plan', planDescription:'Descripción',
    duration:'Duración', cadenceLabel:'Cadencia',
    accentColor:'Color de acento', generating:'Generando…',
    editPlan:'Editar plan', editUnit:'Editar unidad',
    saveChanges:'Guardar cambios', regenerateAI:'Regenerar con IA',
    regenerateCover: 'Regenerar foto de portada',
    regeneratingCover: 'Generando…',
    regenerateConfirm:(n,label)=>`¿Generar con IA ${n} ${label}s? Se reemplazarán las unidades existentes.`,
    regenerateRebuildsSibling:'La versión traducida de este plan también se regenerará automáticamente — se perderá cualquier progreso de lectura en ese lado.',
    translationPending:'La versión en español llegará pronto — suele estar lista en unos minutos.',
    langChipEn:'EN',
    langChipEs:'ES',
    viewTranslation:'Ver traducción',
    showOriginal:'Ver original',
    translating:'Traduciendo…',
    translateRetry:'No se pudo traducir — toca para reintentar',
    deletePlan:'Eliminar plan', deleteUnit:(label)=>`¿Eliminar ${label}?`,
    deleteConfirm:(title)=>`¿Eliminar "${title}"? Esto elimina todas las unidades y respuestas.`,
    addUnit:(label)=>`Agregar ${label}`,
    addQuestion:'Agregar pregunta',
    verses:'Versículos bíblicos', versesPlaceholder:'ej. Juan 3:16-18',
    commentary2:'Comentario / devocional', commentaryPlaceholder:'2-3 párrafos de comentario devocional…',
    questions:'Preguntas de reflexión',
    unitNum:(label,n)=>`${label} ${n}`,
    unitTitle:'Título', unitTitleOptional:'Título (opcional)',
    challengeBadge:'Desafío', joinedBadge:'Inscrito', enrolledCount:(n)=>`${n} inscritos`, preparing:'Preparando tu plan…',
    peopleDoingThis:(n)=>`${n} persona${n===1?'':'s'} hacen esto contigo`,
    journeyFeed:'Feed del camino', myJournal:'Mi diario',
    communityFeed:'Actividad del grupo',
    reflectionsWritten:(n)=>`${n} reflexión${n===1?'':'es'} escritas`,
    journalEntry:(n)=>`${n} ${n===1?'entrada':'entradas'}`,
    completedOf:(done,total,label)=>`${done} de ${total} ${label} completados`,
    activeChallengeTitle:'Desafío activo',
    yourReflectionJournal:'Tu diario de reflexión',
    words:'palabras',
    on:'Activo', off:'Inactivo',
    startDateRequired:'La fecha de inicio es obligatoria para los desafíos',
    planCategory: 'Categoría', planRating: 'Clasificación de contenido',
    oakdaleCore4Label: 'Incluir siempre las 5 preguntas Oakdale',
    oakdaleCore4Desc: 'La IA siempre incluirá las 5 preguntas estándar y agregará 1–3 más.',
    userCreateOakdaleCore4Desc: 'Incluir siempre las 5 preguntas de reflexión Oakdale, y un par más.',
    narratorVoice: 'Voz del narrador',
    narratorVoiceDesc: 'Voz utilizada al generar audio para las unidades de este plan.',
    voiceFemale: 'Femenina',
    voiceMale: 'Masculino',
    voiceBoth: 'Ambas',
    publishedLabel: 'Publicado', publishedDesc: 'Visible para usuarios inscritos',
    unpublishedDesc: 'Oculto — solo visible para ti',
    // Journey mode
    journeyMode:'¿Cómo te gustaría crecer?',
    growQuietly:'Crecer en silencio',
    growQuietlyDesc:'Un espacio tranquilo entre tú y Dios.',
    growWithAFew:'Crecer con unos pocos',
    growWithAFewDesc:'Invita a algunas personas a caminar contigo.',
    growWithCommunity:'Crecer con comunidad',
    growWithCommunityDesc:'Camina junto a tu comunidad.',
    growQuietlyBadge:'Camino personal',
    growWithAFewBadge:(count)=>`Círculo (${count})`,
    growWithCommunityBadge:(name)=>`Con ${name}`,
    communityJourney:'Camino comunitario',
    circleJourney:'Creciendo juntos',
    saveReflection:'Guardar reflexión',
    shareWithGroup:(name)=>`Compartir con ${name}`,
    shareWithCircle:'Compartir con el círculo',
    inviteToCircle:'Invitar al círculo',
    inviteMore:'Invitar más',
    inviteOthers:'Invitar a otros',
    convertSoloNote:'Invitar a amigos convierte este plan privado en un pequeño círculo. Tus reflexiones anteriores permanecen privadas.',
    circleInviteSent:'Invitaciones',
    circleInvitePending:'Pendiente',
    circleInviteAccepted:'Unido',
    circleInviteDeclined:'Rechazado',
    circleInviteBanner:(name)=>`${name} te invitó a crecer juntos en este plan`,
    acceptInvite:'Aceptar',
    declineInvite:'Rechazar',
    searchConnections:'Buscar conexiones...',
    noConnections:'Aún no tienes conexiones. Conéctate con otros primero.',
    selectFriends:'Selecciona amigos para invitar (opcional)',
    selectCommunity:'Selecciona una comunidad...',
    noCommunities:'Aún no eres miembro de ninguna comunidad.',
    // Community Growth tab
    communityGrowthTitle:'Planes de crecimiento',
    communityGrowthDesc:'Planes de crecimiento que los miembros hacen juntos en esta comunidad.',
    startPlanWithCommunity:'Iniciar un plan de crecimiento con esta comunidad',
    noGrowthPlans:'Aún no hay planes de crecimiento',
    noGrowthPlansDesc:'Sé el primero en iniciar un plan de crecimiento con esta comunidad.',
    cancel:'Cancelar',
    done:'Listo',
    invite:'Invitar',
    loadingPassage:'Cargando pasaje…',
    unlocksIn:'Se desbloquea en',
    categories: {
      faith_foundations:    'Fundamentos de fe',
      universal_human:      'Solo soy humano',
      battles_against_sin:  'Batallas contra el pecado',
      grief_and_loss:       'Duelo y pérdida',
      real_world:           'Situaciones de la vida real',
      discipleship:         'Discipulado',
      church_community:     'Iglesia y comunidad',
    },
    ratings: {
      everyone:            '✅ Para todos',
      everyoneDesc:        'Apto para todas las edades',
      guidance_suggested:  '👁 Guía parental',
      guidanceDesc:        'Algunos temas maduros — apropiado para adolescentes y adultos',
      mature:              '🔞 Maduro',
      matureDesc:          'Aborda pecado explícito, adicción, integridad sexual o duelo profundo — solo adultos',
    },
    completeAndShareFirst:'Completa un día y toca "Compartir con la comunidad" para ser el primero.',
    readMultipleTranslations:'Leer en múltiples traducciones',
    // Discovery layout
    popularRow:'Popular',
    newRow:'Nuevo',
    seeAll:'Ver todo',
    backToAll:'Todas las categorías',
    featuredLabel:'Destacado',
    ratingBadge:{
      everyone:'T',
      guidance_suggested:'GP',
      mature:'M',
    },
    participantsShort:(n)=>`${n} inscritos`,
    forEveryone:'Para todos',
    matureTopics:'Temas maduros',
    matureHiddenNotice:'Algunos planes con contenido maduro están ocultos. Actualiza tu fecha de nacimiento en tu perfil para desbloquearlos.',
    ageGate:{
      title:'Solo para adultos (18+)',
      body:'Este plan aborda temas para adultos mayores de 18 años. Actualiza tu fecha de nacimiento en la configuración de tu perfil para desbloquearlo.',
      matureLockedBtn:'Bloqueado — Solo adultos',
      goToProfile:'Actualizar perfil',
      close:'Cerrar',
    },
  },

  faithCheckin: {
    labels:      ['Crisis', 'Distante', 'Por inercia', 'Intentando', 'Presente', 'Conectado', 'Cercano'],
    labelsShort: ['Crisis', 'Distante', 'Inercia', 'Intentando', 'Presente', 'Conectado', 'Cercano'],
    modalTitle:  '¿Cómo estás con Dios hoy?',
    modalSub:    '5 segundos. Completamente privado.',
    notePlaceholder: '¿Algo en tu corazón? (opcional)',
    skip:        'Saltar por hoy',
    save:        'Guardar ✓',
    done:        'Anotado. Hasta mañana.',
    back:        '← Volver',
    checkInBtn:  '+ Registrarse',
    chartTitle:  'Cómo estoy con Dios',
    chartSub:    'Tu trayectoria espiritual — últimos 90 días',
    emptyHint:   'Tu primer registro comenzará tu trayectoria.',
    checkInNow:  'Registrarse ahora',
    lastCheckin: 'Último registro',
    avg90:       'Promedio 90 días',
    trend7:      'Tendencia 7 días',
    closer:      'Más cerca',
    movingAway:  'Alejándose',
    steady:      'Estable',
    checkins:    'Registros',
    recentEntries: 'Entradas recientes',
    noCheckin:   'Sin registro hoy — toca para registrarte',
    endLow:      'Crisis',
    endHigh:     'Cercano',
    streakLabel: (n) => `🔥 ${n} días seguidos`,
    profileTitle: 'Cómo estoy con Dios',
    profileToday: (label) => `${label} · hoy — toca para ver trayectoria`,
  },

  evangelism: {
    modalTitle:   '¿Con quién compartiste a Jesús esta semana?',
    modalSub:     'Un ritmo semanal tranquilo. Completamente privado.',
    shareTypes: {
      conversation: 'Conversación',
      invite:       'Invitación',
      gospel:       'Evangelio',
      prayer:       'Oración',
      serve:        'Servicio',
    },
    addPlaceholder:  'Agregar un nombre…',
    notePlaceholder: '¿Algo para recordar de esta semana? (opcional)',
    skip:            'Nada esta semana',
    save:            'Guardar ✓',
    doneTitle:       'Bien hecho, fiel.',
    doneEmptyTitle:  'Anotado.',
    donePeople:      (n) => n === 1 ? 'Sembraste una semilla en 1 vida esta semana.' : `Sembraste semillas en ${n} vidas esta semana.`,
    doneEmptySub:    'Hay gracia para cada semana. Nos vemos el próximo domingo.',
    doneClose:       'Amén',
    streakLabel:     (n) => `🔥 Racha de ${n} semanas`,
    addToPrayer:     'Orar por ellos',
    addedToPrayer:   'En tu lista',
    shareTestimony:  'Compartir un testimonio',
    testimonySeed:   (names) => `Esta semana tuve el gozo de compartir a Jesús con ${names}. `,
    cardTitle:       'Registro semanal de evangelismo',
    cardPrompt:      '¿Con quién compartiste a Jesús esta semana?',
    cardDone:        (n) => n === 1 ? 'Registrado · 1 persona esta semana' : `Registrado · ${n} personas esta semana`,
    cardSkipped:     'Registrado para esta semana',
    statsTitle:      'Compartiendo a Jesús',
    emptyHint:       'Tu primer registro comienza la historia. Toca para empezar.',
    statPeople:      'Personas alcanzadas',
    statWeeks:       'Semanas activas',
    statStreak:      'Racha semanal',
    recurringTitle:  'Personas en las que sigues invirtiendo',
    weeksCount:      (n) => n === 1 ? '1 semana' : `${n} semanas`,
  },

  userProfile: {
    failedLoad:'No se pudo cargar el perfil', goBack:'Regresar',
    recentPosts:'Publicaciones recientes',
    removeConfirm:(name)=>`¿Quitar a ${name} como conexión?`,
    connect:'Conectar', pending:'Solicitud enviada', acceptRequest:'Aceptar solicitud', connected:'Conectado',
    stats:{
      posts:'Publicaciones', groups:'Grupos', prayersSaid:'Oraciones',
      prayingFor:'Orando por', prayerRecipients:'Destinatarios de Oración',
      streak:'Racha actual', bestStreak:'Mejor racha',
      bibleStudies:(n=>'Estudios Bíblicos'), growthCompleted:(n=>'Planes Completados'),
      daysActive:(n=>'Días Activo'),
    },
    postTypes:{
      scripture:'Escritura', reflection:'Reflexión', prayer:'Oración', praise:'Alabanza', surrender:'Rendición',
    },
    commentsTotal:(n)=>`${n} comentarios en total`,
  },

  chat: {
    title:'Mensajes', subtitle:'Anímense unos a otros cada día',
    sharedStudyLabel:'Estudio bíblico',
    sharedMovementLabel:'Historia del movimiento',
    directMessages:'Mensajes directos',
    communities:'Comunidades',
    startDm:(name)=>`Inicia una conversación con ${name}`,
    newMessage:'Nuevo mensaje',
    searchConnections:'Buscar contactos…',
    noResults:'Sin resultados',
    noConnections:'Aún no tienes contactos.',
    noConversations:'Aún no hay conversaciones',
    noConversationsDesc:'Únete a un grupo para empezar a chatear con tu comunidad.',
    somethingWrong:'Algo salió mal',
    tryAgain:'Reintentar',
    noMessages:'Aún no hay mensajes',
    beFirst:'¡Sé el primero en decir algo!',
    messagePlaceholder:'Mensaje...',
    failedSend:'Error al enviar el mensaje',
    failedLoad:'No se pudieron cargar los mensajes. Inténtalo de nuevo.',
    members:(n)=>`${n} miembro${n===1?'':'s'}`,
    groupChat:'Chat de grupo',
    // Editing a sent message (5 minutes) and the admin-only history.
    edit:'Editar',
    edited:'Editado',
    editing:'Editando mensaje',
    cancelEdit:'Cancelar',
    deleteMessage:'Eliminar mensaje',
    saveEdit:'Guardar',
    editWindowClosed:'Los mensajes solo se pueden editar durante 5 minutos después de enviarlos.',
    editFailed:'No se pudo guardar tu edición. Inténtalo de nuevo.',
    editConflict:'Este mensaje se cambió en otro lugar. Inténtalo de nuevo.',
    historyTitle:'Historial de ediciones',
    historyNote:'Solo visible para administradores. Abrirlo queda registrado en el registro de auditoría.',
    historyOriginal:'Original',
    historyEdit:'Edición',
    historyCurrent:'Actual',
    historyFailed:'No se pudo cargar el historial de ediciones.',
    viewHistory:'Editado — ver historial',
    // Day separators and the typing line in an open conversation.
    today:'Hoy',
    yesterday:'Ayer',
    isTyping:(name)=>`${name} está escribiendo…`,
    // Photos and videos in direct messages.
    attach:'Agregar fotos o videos',
    attachTooMany:(n)=>`Puedes enviar hasta ${n} fotos o videos a la vez.`,
    attachTooLarge:'El archivo es demasiado grande. Las fotos pueden pesar hasta 10 MB y los videos hasta 100 MB.',
    attachUnsupported:'Solo se pueden enviar fotos y videos (MP4, MOV, WebM).',
    attachUnprocessable:'No se pudo preparar esta foto en este dispositivo. Intenta guardarla primero como JPEG.',
    attachUploadFailed:'Un archivo no se subió. Quítalo e inténtalo de nuevo.',
    removeAttachment:'Quitar',
    uploading:'Subiendo',
    openPhoto:'Abrir foto',
    close:'Cerrar',
    photo:'Foto',
    photos:(n)=>`${n} fotos`,
    video:'Video',
    videos:(n)=>`${n} videos`,
    mediaItems:(n)=>`${n} fotos y videos`,
  },

  admin: {
    title:'Consola de administración', subtitle:'Pastorea el rebaño',
    accessRequired:'Acceso de administrador requerido',
    noPermission:'No tienes permiso para ver esta página.',
    goHome:'Ir al inicio',
    tabs:{
      dashboard:'Tablero', users:'Usuarios y roles', userActivity:'Actividad de Usuarios', communities:'Comunidades',
      prayerEvents:'Eventos de oración', prayerRecipients:'Destinatarios de oración',
      posts:'Todas las publicaciones', metrics:'Métricas', logs:'Registros de la app', auditLogs:'Registros de auditoría',
      prayNows:'Oraciones — Orar Ahora', bibleStudies:'Estudios Bíblicos', feedback:'Comentarios', reports:'Reportes',
      prayerWall:'Peticiones de Oración', growth:'Crecer Más Profundo', well:'El Pozo', notifLogs:'Registros de Notif.',
      systemPrayers:'Oraciones del Sistema', socialPosts:'Publicaciones Sociales', movementStories:'Historias del Movimiento',
      integrations:'Integraciones de IA',
      emails:'Campañas de Correo',
      emailLogs:'Registros de Correo',
      welcomeMessages:'Mensajes de bienvenida',
      blog:'Blog',
      newsletter:'Boletín',
      settings:'Configuración Ignite',
    },
    stats:{
      totalMembers:'Total de miembros', totalPosts:'Total de publicaciones',
      prayerRecipients:'Destinatarios de oración', prayerEvents:'Eventos de oración',
      connections:'Conexiones', groups:'Grupos',
    },
    search:'Buscar', refresh:'Actualizar', delete:'Eliminar',
    confirmDelete:'¿Estás seguro?',
    noResults:'No se encontraron resultados.',
    loading:'Cargando…',
    roles:{ admin:'Administrador', user:'Miembro de la comunidad' },
    status:{ active:'Activo', suspended:'Suspendido', banned:'Bloqueado' },
    providers:{ cognito:'Contraseña', Google:'Google', SignInWithApple:'Apple' },
    users:{
      title:'Usuarios y roles', searchPlaceholder:'Buscar por nombre, correo o usuario…',
      deleteConfirm:'¿Eliminar cuenta permanentemente?',
      deleteWarning:'Esto eliminará permanentemente la cuenta y todos los datos asociados. Esta acción no se puede deshacer.',
      deleteBtn:'Eliminar cuenta permanentemente', deleteSuccess:'Usuario eliminado.',
      suspend:'Suspender', unsuspend:'Reactivar', ban:'Bloquear',
      joined:'Se unió', lastActive:'Última actividad', noUsers:'No se encontraron usuarios.',
    },
    prayerEvents:{
      title:'Eventos del calendario de oración', noEvents:'No se encontraron eventos de oración.',
    },
    prayerRecipients:{
      title:'Destinatarios de oración', searchPlaceholder:'Buscar por nombre o petición…',
      noRecipients:'No se encontraron destinatarios.',
    },
    posts:{
      title:'Todas las publicaciones', noPosts:'No se encontraron publicaciones.',
    },
    logs:{
      title:'Registros de la app', noLogs:'Aún no hay registros. Los registros se acumulan mientras el servidor está en funcionamiento.',
    },
    scheduler:{
      title:'Programador de oración', runUrgent:'Ejecutar Urgentes', runHigh:'Ejecutar Alta prioridad', runNormal:'Ejecutar Normal',
    },
    emails:{
      newCampaign:'Nueva campaña',
      saveDraft:'Guardar borrador', saving:'Guardando…',
      testSend:'Enviar prueba', sending:'Enviando…', sendCampaign:'Enviar campaña',
      confirmSend:'Confirmar envío',
      titleLabel:'Título de la campaña', titlePlaceholder:'p. ej. Boletín mensual – Abril 2026',
      subjectLabel:'Línea de asunto', subjectPlaceholder:'Lo que los destinatarios ven en su bandeja',
      bodyLabel:'Cuerpo HTML', bodyPlaceholder:'<p>Hola,</p>\n<p>Tu mensaje aquí…</p>',
      audienceLabel:'Audiencia', audienceAll:'Todos los usuarios activos', audienceAdmins:'Solo administradores',
      audienceMembers:'Solo miembros', audienceCustom:'Lista personalizada de correos',
      customEmailsLabel:'Direcciones de correo (separadas por comas)',
      testSendLabel:'Enviar prueba a', testEmailPlaceholder:'tu@ejemplo.com',
      draft:'Borrador', sent:'Enviado',
      noCampaigns:'Aún no hay campañas de correo.',
      noCampaignsDesc:'Crea tu primera campaña para enviar un anuncio a tus usuarios.',
      deleteDraft:'Eliminar borrador',
      sampleRecipients:'Destinatarios de muestra:',
    },
  },

  report: {
    title:(label)=>`Reportar ${label}`,
    intro:(label)=>`¿Por qué reportas este ${label}?`,
    post:'publicación', community:'comunidad', prayer_wall:'petición de oración', growth_plan:'plan de crecimiento', movement_story:'historia del movimiento', content:'contenido',
    reasons: [
      { value:'spam',           label:'📢 Spam o contenido no solicitado' },
      { value:'harassment',     label:'😡 Acoso o intimidación' },
      { value:'hate_speech',    label:'🚫 Discurso de odio o discriminación' },
      { value:'misinformation', label:'❌ Desinformación o afirmaciones falsas' },
      { value:'inappropriate',  label:'⚠️  Contenido inapropiado u ofensivo' },
      { value:'off_topic',      label:'🔇 Fuera de tema o irrelevante' },
      { value:'other',          label:'💬 Otro' },
    ],
    detailsLabel:'Detalles adicionales',
    detailsOptional:'opcional',
    detailsPlaceholder:'Cualquier contexto adicional que pueda ayudar a nuestra revisión…',
    note:'Los reportes son anónimos. Los reportes falsos repetidos pueden resultar en acción sobre la cuenta.',
    submit:'Enviar reporte', submitting:'Enviando…',
    successTitle:'Reporte enviado',
    successBody:(label)=>`Gracias por ayudar a mantener Ignite seguro. Nuestro equipo revisará este ${label} y tomará las medidas apropiadas.`,
    done:'Listo',
    errorRetry:'Intentar de nuevo',
    couldNotSubmit:'No se pudo enviar el reporte. Por favor inténtalo de nuevo.',
  },

  journal: {
    title: 'Mi Diario',
    subtitle: 'Traza la mano de Dios en tu historia',
    privateNote: 'Privado — solo visible para ti',
    searchPlaceholder: 'Buscar en tu diario…',
    noResults: 'Ninguna entrada coincide con tu búsqueda.',
    empty: 'Tu diario está vacío',
    emptyDesc: 'Tus oraciones, reflexiones y estudios bíblicos aparecerán aquí automáticamente. También puedes agregar tus propias entradas.',
    loadMore: 'Cargar más',
    loading: 'Cargando…',
    allCaughtUp: 'Todo al día',
    filterAll: 'Todo', filterPrayer: 'Oración', filterPrayNow: 'Orar Ahora',
    filterBibleStudy: 'Estudio Bíblico', filterReflections: 'Reflexiones',
    filterWell: 'El Pozo',
    filterCheckin: 'Estado espiritual', filterEntries: 'Mis entradas',
    filterEvangelism: 'Evangelismo',
    filterRhythm: 'Ritmo Diario',
    filterConversations: 'Conversaciones',
    sharedWith: (n) => n === 1 ? '1 persona' : `${n} personas`,
    types: {
      prayer_event:      'Oración',
      memorial_prayer:   'Oración memorial',
      pray_now:          'Orar Ahora',
      bible_study:       'Estudio Bíblico',
      brp_reflection:    'Plan de Lectura Bíblica',
      growth_reflection: 'Plan de Crecimiento',
      faith_checkin:     'Estado espiritual',
      evangelism_checkin: 'Registro de evangelismo',
      journal_entry:     'Entrada del diario',
      well_discussion:   'Discusión en El Pozo',
      well_note:         'Notas del Sermón',
      daily_rhythm_reflection: 'Ritmo Diario',
      encounter:         'Conversación',
    },
    wellPosted: 'Discusión en El Pozo',
    wellReplied: 'Respondiste en El Pozo',
    wellAskedQuestion: 'Hiciste una pregunta en El Pozo',
    wellMyNotes: 'Mis notas del sermón',
    prayedFor: 'Oré por',
    remembering: 'Recordando a',
    myNotes: 'Mis notas',
    prayerGenerated: 'Oración generada',
    moment: 'Momento', tone: 'Tono', forWho: 'Para', withWho: 'Con', need: 'Necesidad',
    passage: 'Pasaje',
    aboutGod: '¿Qué nos dice esto sobre Dios?',
    aboutHumans: '¿Qué nos dice esto sobre las personas?',
    howRespond: '¿Cómo te está invitando Dios a responder?',
    sharePrompt: '¿A quién vino a tu mente animar?',
    day: 'Día', week: 'Semana', plan: 'Plan', community: 'Comunidad',
    reflectionQuestions: 'Preguntas de reflexión',
    checkinLevel: 'Cómo estaba con Dios',
    checkinNote: 'Nota',
    checkinLevels: ['Crisis','Distante','Por inercia','Intentando','Presente','Conectado','Cercano'],
    newEntry: 'Nueva entrada',
    editEntry: 'Editar entrada',
    entryTitle: 'Título',
    entryTitlePlaceholder: 'Dale un título a esta entrada… (opcional)',
    entryBody: '¿Qué tienes en el corazón?',
    entryBodyPlaceholder: 'Escribe libremente — esto es solo para ti…',
    entryDate: 'Fecha',
    entryTags: 'Etiquetas',
    entryTagsPlaceholder: 'p.ej. gratitud, familia, trabajo',
    saveEntry: 'Guardar entrada',
    deleteEntry: '¿Eliminar esta entrada?',
    savedEntry: 'Entrada guardada',
    favOnly: 'Solo destacadas',
    starred: 'Destacada',
    unstar: 'Quitar destacado',
    totalEntries: (n) => `${n} ${n === 1 ? 'entrada' : 'entradas'}`,
    totalWords: (n) => `${n.toLocaleString()} palabras`,
    totalPrayers: (n) => `${n} ${n === 1 ? 'oración' : 'oraciones'}`,
    streakDays: (n) => `${n} días seguidos`,
    thisMonth: 'Este mes',
    thisWeek: 'Esta semana',
    allTime: 'Total',
    // Navegación semanal
    prevWeek:  'Semana anterior',
    nextWeek:  'Semana siguiente',
    today:     'Hoy',
    jumpToDate:'Saltar a fecha',
    weekTitle: ({ week, range }) => `Semana ${week} · ${range}`,
    weekStats: ({ entries, days }) =>
      `${entries} ${entries === 1 ? 'entrada' : 'entradas'} · ${days} de 7 días`,
    emptyWeek:        'Nada registrado esta semana',
    emptyWeekDesc:    'A medida que ores, reflexiones y hagas check-in, esta semana se irá llenando. También puedes agregar una entrada manualmente.',
    emptyFavorites:   'Aún no tienes entradas destacadas',
    searchScopedToWeek: 'Buscando esta semana. Borra la búsqueda para ver otras semanas.',
    close: 'Cerrar',
  },

  languages:{ en:'English', es:'Español' },

  prayNow: {
    title: 'Orar Ahora',
    subtitle: 'Pausa. Respira. Habla con Dios.',
    momentLabel: '¿Qué tipo de momento es este?',
    moments: {
      meal: 'Antes de una comida',
      meeting: 'Reunión / decisión',
      family: 'Con familia',
      friends: 'Con amigos',
      need: 'Orando por alguien en necesidad',
      difficult: 'Momento difícil / emocional',
      celebration: 'Celebración / buenas noticias',
      general: 'Solo necesito una oración general',
      morning: 'Buenos días',
      goodnight: 'Buenas noches',
      sleepless: 'No puedo dormir',
      anxious: 'Ansioso / preocupado',
    },
    needLabel: '¿Algo específico por qué orar?',
    needPlaceholder: 'p.ej., sabiduría, sanidad, paz, viaje seguro…',
    withLabel: '¿Quién está aquí contigo?',
    withPlaceholder: 'p.ej., mi esposa, padres, compañeros…',
    forLabel: '¿Hay alguien por quien interceder?',
    forPlaceholder: 'p.ej., un amigo llamado Marco, nuestro equipo…',
    toneLabel: 'Tono',
    tones: {
      comforting: 'Reconfortante',
      encouraging: 'Alentador',
      faithful: 'Fuerte y fiel',
      calm: 'Tranquilo y sereno',
    },
    lengthLabel: 'Duración',
    lengths: { short: 'Corta', standard: 'Media', long: 'Larga', auto: 'Auto' },
    contextLabel: '¿Algún detalle adicional?',
    contextPlaceholder: 'Opcional: cualquier otro contexto que quieras incluir…',
    optional: 'opcional',
    generate: 'Generar Oración',
    generating: 'Generando oración…',
    prayerLabel: 'Oración',
    copy: 'Copiar', copied: '¡Copiado!',
    newPrayer: 'Nueva Oración',
    shareToFeed: 'Compartir al feed',
    share: 'Compartir',
    failedGenerate: 'Error al generar la oración. Inténtalo de nuevo.',
    loading: 'Componiendo tu oración…',
    loadingSub: 'Esto tarda solo unos segundos.',
    tabNew: 'Nueva Oración',
    tabHistory: 'Historial',
    historyEmpty: '¡Aún no hay oraciones guardadas. Genera tu primera arriba!',
    savedPrayers: (n) => n === 1 ? '1 oración guardada' : `${n} oraciones guardadas`,
    viewPrayer: 'Ver oración',
    deleteConfirm: '¿Eliminar esta oración?',
    delete: 'Eliminar',
    cancel: 'Cancelar',
    back: '← Atrás',
    momentLabel2: 'Momento',
    toneLabel2: 'Tono',
    withLabel2: 'Con',
    forLabel2: 'Para',
    needLabel2: 'Necesidad',
    contextLabel2: 'Contexto',
  },
gettingStarted: {
    headerTitle: 'Primeros Pasos',
    stepLabels: ['Lista de Oración', 'Peticiones', 'Tu Perfil', 'Instalar App'],

    // Step 1
    prayerTitle: '¿Por quién quieres orar?',
    prayerDesc: 'Toca una relación y escribe un nombre. Ignite construirá tu calendario de oración automáticamente.',
    privacyBadge: '100% Privado',
    privacyDesc: '— solo tú puedes ver por quién oras. Tu lista de oración nunca se comparte.',
    addAnother: (rel) => `Agregar otro/a ${rel.toLowerCase()}`,
    namePlaceholder: (rel) => `Nombre de ${rel.toLowerCase()}…`,
    skipForNow: 'Omitir por ahora',
    savePeople: (n) => `Guardar ${n} ${n === 1 ? 'persona' : 'personas'}`,
    continue: 'Continuar',
    couldNotSave: 'No se pudo guardar — por favor intenta de nuevo.',

    // Step 2 — Prayer Requests
    requestsTitle: '¿Tienes peticiones de oración?',
    requestsDesc: 'Agrega las cosas que tienes en el corazón ahora. Siempre puedes agregar más después.',
    requestsPrivacyDesc: '— tus peticiones son privadas por defecto. Tú controlas quién las ve.',
    requestPlaceholder: '¿Qué le estás creyendo a Dios?',
    addAnotherRequest: 'Agregar otra petición',
    saveRequests: (n) => `Guardar ${n} petición${n===1?'':'es'}`,

    // Step 2
    accountTitle: 'Configura tu perfil',
    accountDesc: 'Esto ayuda a otros en Ignite a conocerte. Siempre puedes actualizarlo después.',
    firstName: 'Nombre', lastName: 'Apellido',
    firstNamePlaceholder: 'Nombre', lastNamePlaceholder: 'Apellido',
    favoriteVerse: 'Versículo Favorito de la Biblia',
    favoriteVersePlaceholder: 'ej. Juan 3:16 — Porque tanto amó Dios al mundo…',
    bio: 'Biografía', bioOptional: '(opcional)',
    bioPlaceholder: 'Un poco sobre ti…',
    timezone: 'Zona horaria', prayerReminder: 'Recordatorio diario de oración',
    noReminder: 'Sin recordatorio',
    reminderNote: 'Te enviaremos un correo cada mañana con la persona por quien orar a la hora que configures arriba.',

    // Step 3
    installTitle: 'Instala Ignite en tu dispositivo',
    installDesc: 'Agrega Ignite a tu pantalla de inicio para la experiencia completa — más rápido, sin conexión y con notificaciones.',
    iphoneLabel: 'iPhone / iPad',
    androidLabel: 'Android',
    desktopNote: 'Estás en una computadora — guarda esta página como favorito e instala en tu teléfono para la mejor experiencia.',
    iosStep1: 'Abre Ignite en Safari',
    iosStep1Note: 'Debe ser Safari — Chrome en iOS aún no lo admite',
    iosStep2: 'Toca el botón Compartir ⎋ en la parte inferior de la pantalla',
    iosStep3: 'Desplázate hacia abajo y toca "Agregar a la pantalla de inicio"',
    iosStep4: 'Toca "Agregar" en la esquina superior derecha — ¡listo! 🎉',
    iosNote: 'Requiere iOS 16.4+. Después de instalar, las notificaciones funcionarán automáticamente.',
    androidStep1: 'Abre Ignite en Chrome',
    androidStep2: 'Toca el menú ⋮ en la esquina superior derecha',
    androidStep3: 'Toca "Agregar a la pantalla de inicio" o "Instalar aplicación"',
    androidStep4: 'Toca "Instalar" — Ignite aparecerá en tu pantalla de inicio 🎉',
    emailInstructions: '¿Quieres estas instrucciones en tu teléfono?',
    emailSentTo: (email) => `Enviado a ${email}`,
    emailBtn: (email) => `Enviar a ${email}`,
    sending: 'Enviando…',
    letsGo: '¡Vamos!',

    groups: {
      immediate: 'Familia Inmediata',
      extended: 'Familia Extendida',
      friends: 'Amigos, Vecinos y Otros',
    },

    // ── Ritual First Light (tono reverente) ─────────────────────────────────
    back: 'Atrás',
    // 1. Respira
    breathTitle: ['Antes de comenzar,', 'respira hondo.'],
    breathHint: 'toca para comenzar',
    breathVerse: '«Echen toda su ansiedad sobre él, porque él cuida de ustedes.»',
    breathVerseRef: '1 Pedro 5:7',
    // 2. Nombra a quienes llevas
    carryTitle: 'Nombra a quienes llevas',
    carryDesc: 'Cada nombre que pronuncias enciende una vela. Nunca se enfriarán.',
    carryEmpty: 'El altar espera…',
    carryNamePh: (rel) => `Nombre de tu ${String(rel).toLowerCase()}…`,
    carryContinue: (n) => `Continuar · ${n} en oración`,
    addPerson: 'Agregar',
    release: (name) => `Quitar a ${name}`,
    releaseShort: 'Quitar',
    you: 'Tú',
    carryConstHint: 'Toca una vela para ver a quién sostiene.',
    carryConstAria: (n) => `Tu constelación de oración — ${n} ${n === 1 ? 'persona' : 'personas'} en oración`,
    viewList: 'Vista de lista',
    viewConstellation: 'Vista de constelación',
    // 3. ¿En qué temporada estás?
    seasonTitle: '¿En qué temporada estás?',
    seasonDesc: 'Cuéntanos lo que estás viviendo y prepararemos un plan de crecimiento y una oración solo para ti.',
    seasonOptional: 'Algo más que quieras decir… (opcional)',
    seasonContinue: 'Continuar',
    seasonSkip: 'Ahora no',
    season_college: 'En la universidad / estudiando',
    season_spouse: 'Anhelando un cónyuge',
    season_child: 'Esperando un hijo',
    season_grief: 'En duelo por una pérdida',
    season_habit: 'Luchando contra un hábito',
    season_newfaith: 'Nuevo en la fe',
    season_decision: 'Ante una gran decisión',
    season_anxiety: 'Ansioso / abrumado',
    season_marriage: 'Trabajando en mi matrimonio',
    season_parenting: 'Crianza de los hijos',
    season_work: 'Trabajo y vocación',
    season_health: 'Salud / enfermedad',
    season_other: 'Otra cosa',
    blessPlanLine: 'Se está preparando un plan de crecimiento para ti.',
    planPreparing: 'Preparando tu plan…',
    // copia heredada de "Deja algo aquí" (se conserva por seguridad)
    burdenTitle: 'Deja algo aquí',
    burdenDesc: '¿Hay un peso que llevas esta noche? Déjalo aquí.',
    burdenPh: 'Esta noche dejo…',
    burdenGo: 'Dejarlo aquí',
    burdenSkip: 'Esta noche no',
    // 4. ¿Cuándo vendrás?
    hourTitle: '¿Cuándo vendrás?',
    hourDesc: 'Encenderemos el camino y te llamaremos con dulzura.',
    hour_dawn: 'Amanecer · 6:00',
    hour_morning: 'Mañana · 7:30',
    hour_midday: 'Mediodía · 12:00',
    hour_dusk: 'Atardecer · 6:00',
    hour_night: 'Noche · 9:00',
    // 5. ¿Y cuál es tu nombre?
    nameTitle: '¿Y cuál es tu nombre?',
    nameDesc: 'Para darte la bienvenida por él.',
    nameGo: 'Recibir la bendición',
    // 6. Mantén la llama cerca
    installTitle2: 'Mantén la llama cerca',
    installDesc2: 'Agrega Ignite a tu pantalla de inicio para que la luz siempre pueda alcanzarte.',
    installGo: 'La llama está guardada',
    // Promoción de la app nativa
    installAppDesc: 'Lleva la luz contigo — mantén Ignite cerca en tu teléfono.',
    iosCardLabel: 'iPhone y iPad',
    androidCardLabel: 'Android',
    appStoreCta: 'Descargar en el App Store',
    playStoreCta: 'Descargar en Google Play',
    desktopAppNote: 'Continúa aquí, o lleva Ignite contigo en tu teléfono:',
    // 7. Ve en paz
    blessTitle: (name) => name ? `Ve en paz, ${name}.` : 'Ve en paz.',
    blessDesc: (count, time) =>
      `${count ? `${count} ${count === 1 ? 'nombre se guarda' : 'nombres se guardan'} a la luz de las velas.` : 'Tu altar está guardado.'}${time ? ` Velaremos por ti y te llamaremos a las ${time}.` : ' Velaremos por ti.'}`,
    blessGo: 'Entrar a Ignite',
  },
  prayerWall: {
    title: 'Peticiones de Oración',
    subtitle: 'Pide con valentía. Mira a Dios actuar.',
    pleaseHeader: 'Por favor',
    thankYouHeader: 'Gracias',
    pleaseDesc: 'Peticiones de oración activas',
    thankYouDesc: 'Oraciones que Dios ha respondido',
    addRequest: 'Agregar Petición',
    editRequest: 'Editar Petición',
    newRequest: 'Nueva Petición de Oración',
    titleLabel: 'Título', titlePlaceholder: '¿Por qué estás orando?',
    categoryLabel: 'Categoría',
    descriptionLabel: 'Notas / Descripción',
    descriptionPlaceholder: 'Comparte más detalles sobre esta oración...',
    endDateLabel: 'Fecha límite',
    endDateHint: 'Opcional — para oraciones con tiempo limitado (cirugía, viaje, examen...)',
    visibilityLabel: 'Visibilidad',
    visPrivate: 'Privado — solo yo',
    visConnections: 'Mis Conexiones',
    visGroups: 'Mis Comunidades',
    visAll: 'Mis Conexiones y Comunidades',
    // Opciones del formulario de nueva petición / editar.
    formVis: {
      private: 'Privado', privateDesc: 'Solo visible para ti',
      connections: 'Mis Conexiones', connectionsDesc: 'Personas conectadas contigo',
      groups: 'Mis Comunidades', groupsDesc: 'Miembros de tus comunidades',
      all: 'Conexiones y Comunidades', allDesc: 'Todos tus contactos, y todos en tus comunidades',
    },
    saveRequest: 'Guardar Petición',
    markAnswered: '¡Dios respondió! 🙌',
    answeredTitle: '¿Cómo respondió Dios?',
    answeredPlaceholder: 'Comparte cómo Dios respondió — tu testimonio puede animar a otros...',
    answeredLabel: 'Cómo respondió Dios',
    moveToThankYou: 'Mover a Gracias',
    deleteConfirm: '¿Eliminar esta petición de oración?',
    emptyPlease: 'Sin peticiones activas',
    emptyPleaseDesc: 'Agrega tu primera petición de oración para comenzar.',
    emptyThankYou: 'Aún no hay oraciones respondidas',
    emptyThankYouDesc: 'Cuando Dios responda tus oraciones, muévelas aquí para recordar Su fidelidad.',
    answeredOn: 'Respondida',
    endsOn: 'Termina',
    sharedWith: 'Compartido con',
    privateLabel: 'Privado',
    // Distintivo de traducción
    translatedFrom: (lang) => `Traducido del ${lang}`,
    showTranslation: 'Traducir',
    showOriginal: 'Ver original',
    langEnglish: 'inglés',
    langSpanish: 'español',
    categories: ['Personal', 'Familia', 'Salud', 'Finanzas', 'Relaciones', 'Iglesia', 'Nación', 'Mundo / Desastre', 'Discernimiento', 'Gratitud', 'Crecimiento espiritual', 'Trabajo / Carrera', 'Otro'],
    filterAll: 'Todos',
    filterMine: 'El mío',
    markAnsweredShort: 'Respondida',
    filterPlease: 'Por favor',
    filterThankYou: 'Gracias',
    fromNetwork: 'De tu red',
    prayedFor: 'Oré por esto',
    sharedByYou: 'Compartido por ti',
  },

  settings: {
    title: 'Configuración',
    subtitle: 'Haz que Ignite sea tuyo',
    tabs: {
      login:'Información de acceso', notifications:'Notificaciones',
      connections:'Conexiones', invites:'Invitaciones de comunidad',
      faq:'Ayuda y preguntas frecuentes', feedback:'Comentarios',
      privacy:'Privacidad', gettingStarted:'Comenzar', account:'Cuenta',
    },
    login: {
      emailSection:'Correo electrónico', emailDesc:'Toca para cambiar tu correo de acceso',
      emailCurrent:'Correo actual', newEmailLabel:'Nuevo correo electrónico',
      updateEmail:'Actualizar correo', emailUpdated:'Correo actualizado. Revisa tu bandeja para verificar.',
      newPasswordHint: 'Mínimo 8 caracteres',
      emailError:'No se pudo actualizar el correo',
      emailHiddenByApple:'Oculto por Apple',
      emailHiddenDesc:'Elegiste mantener tu correo privado al iniciar sesión con Apple. Toca para configurar un correo de acceso.',
      passwordSection:'Contraseña', changePassword:'Cambiar contraseña',
      passwordDesc:'Actualiza tu contraseña de Ignite',
      currentPassword:'Contraseña actual', newPassword:'Nueva contraseña',
      confirmPassword:'Confirmar nueva contraseña', updatePassword:'Cambiar contraseña',
      passwordUpdated:'Contraseña cambiada exitosamente.',
      passwordError:'No se pudo cambiar la contraseña',
      passwordMismatch:'Las contraseñas nuevas no coinciden',
      passwordTooShort:'La contraseña debe tener al menos 8 caracteres',
      linkedAccounts:'Cuentas vinculadas',
      connected:'Conectado', notConnected:'No conectado', notLinked:'No vinculado',
      socialNote:'Los accesos sociales se gestionan desde la configuración de tu cuenta Apple o Google. Para desconectar, elimina Ignite de tus apps vinculadas allí.',
    },
    invites: {
      noInvites:'Sin invitaciones de comunidad pendientes',
      accept:'Aceptar', decline:'Rechazar', invitedBy:'Invitado por',
      members:'miembros', joined:'¡Te uniste a la comunidad!', declined:'Invitación rechazada.',
      error:'No se pudo responder a la invitación',
    },
    account: {
      signOutSection:'Cerrar sesión',
      signOut:'Cerrar sesión', signOutDesc:'Cerrar sesión de Ignite en este dispositivo',
      newsletterSection:'Boletín',
      newsletterToggle:'Boletín de Ignite',
      newsletterDescOn:'Recibirás el devocional semanal y notas ocasionales del equipo.',
      newsletterDescOff:'No recibirás el boletín de Ignite. Tócalo para volver a suscribirte.',
      newsletterDescLoading:'Verificando tu suscripción…',
      newsletterOn:'Suscrito',
      newsletterOff:'No suscrito',
      newsletterSubscribed:'Estás suscrito.',
      newsletterUnsubscribed:'Te has dado de baja.',
      dangerZone:'Zona de peligro',
      deleteAccount:'Eliminar cuenta',
      deleteWarning:'Elimina permanentemente tu cuenta y anonimiza todos tus datos. Esta acción no se puede deshacer.',
      deleteBtn:'Eliminar mi cuenta',
      typeToConfirm:'Escribe',
      confirmDelete:'Confirmar eliminación',
      deleteError:'No se pudo eliminar la cuenta. Por favor contacta soporte.',
      dataExportSection:'Tus datos',
      downloadData:'Descargar mis datos',
      downloadDataDesc:'Exporta todos tus datos de Ignite como archivo JSON',
      downloadDataSuccess:'Exportación de datos descargada.',
      downloadDataError:'No se pudieron exportar los datos. Por favor inténtalo de nuevo.',
    },
    feedback: {
      sectionTitle:'Enviar comentarios',
      intro:'¿Encontraste un error? ¿Tienes una idea? Lo leemos todo. Tu opinión da forma a lo que construimos.',
      category:'Categoría', selectCategory:'Selecciona una categoría…',
      tellUsMore:'Cuéntanos más', placeholder:'Describe el problema o la idea con detalle…',
      submit:'Enviar comentario', submitting:'Enviando…',
      successMsg:'¡Gracias por tus comentarios! Los revisaremos pronto.',
      errorMsg:'No se pudo enviar el comentario. Por favor inténtalo de nuevo.',
      cat_cosmetic:'Solicitud visual / UI',
      cat_feature:'Solicitud de nueva función',
      cat_bug_minor:'Error menor',
      cat_bug_major:'Funcionalidad principal rota',
      cat_other:'Otro / Comentario general',
    },

    privacy: {
      sectionDiscovery: 'Perfil y Descubrimiento',
      sectionPosts: 'Publicaciones',
      sectionPrayer: 'Oración',
      sectionStats: 'Visibilidad de estadísticas de perfil',
      sectionBlocked: 'Usuarios bloqueados',
      saved: 'Configuración de privacidad guardada.',
      saveFailed: 'No se pudo guardar. Inténtalo de nuevo.',
      saving: 'Guardando…',
      profileVisLabel: 'Visibilidad del perfil',
      profileVisDesc: 'Quién puede ver tu perfil',
      searchLabel: 'Aparecer en búsquedas',
      searchDesc: 'Permite que otros te encuentren por nombre o usuario',
      connReqLabel: 'Solicitudes de conexión',
      connReqDesc: 'Quién puede enviarte una solicitud de conexión',
      activityLabel: 'Estado de actividad',
      activityDesc: 'Mostrar cuándo te uniste y días activo',
      lineageLabel: 'Compartir mi linaje con mis discípulos',
      lineageDesc: 'Cuando está activado, las personas a las que discipulas pueden ver quién te ha discipulado, subiendo por toda la cadena. Cuando está desactivado, el árbol se detiene en ti cuando se ve desde abajo.',
      postVisLabel: 'Visibilidad de publicaciones por defecto',
      postVisDesc: 'Audiencia preseleccionada al crear una publicación',
      prayerNote: 'Tus destinatarios de oración y tu calendario de oración son siempre privados — solo tú puedes ver por quién oras. Puedes elegir quién ve tus estadísticas de oración a continuación.',
      statsHint: 'Toca una estadística para cambiar entre Todos y Mis conexiones. Las estadísticas bloqueadas son siempre privadas.',
      alwaysPrivate: 'Siempre privado',
      clickToChange: 'Toca para cambiar',
      noBlocked: 'No has bloqueado a nadie. Los usuarios bloqueados no pueden ver tu perfil, enviarte mensajes ni aparecer en tu feed.',
      unblock: 'Desbloquear',
      visOptions: {
        public: 'Todos', publicDesc: 'Todos los usuarios de Ignite',
        connections: 'Mis conexiones', connectionsDesc: 'Solo personas con quienes estás conectado',
        private: 'Solo yo', privateDesc: 'Oculto para otros',
        everyone: 'Todos', none: 'Nadie',
      },
      statLabels: {
        prayersSaid: 'Oraciones',
        prayerListCount: 'Destinatarios de oración',
        prayerRequestCount: 'Peticiones de oración',
        prayerCompletionRate: 'Tasa de oración',
        currentStreak: 'Racha actual',
        bestStreak: 'Mejor racha',
        bibleStudies: 'Estudios bíblicos',
        growthCompleted: 'Planes completados',
        daysActive: 'Días activo',
        communitiesJoined: 'Comunidades',
        deviceCount: 'Mis dispositivos',
        connections: 'Conexiones',
      },
    },
    gettingStarted: {
      title:'Configuración e incorporación',
      wizardLabel:'Asistente de inicio',
      wizardDesc:'Revisa el flujo de configuración — lista de oración, perfil e instalación',
      quickLinks:'Accesos rápidos',
      faqLabel:'Ayuda y preguntas frecuentes',
      faqDesc:'Navega las preguntas frecuentes',
    },
  },

  notifSettings: {
    title: 'Configuración de notificaciones',
    subtitle: 'Mantente conectado a tu manera',
    masterTitle: 'Controles principales',
    masterDesc: 'Activa o desactiva un canal completo',
    saved: 'Preferencias guardadas',
    loadError: 'No se pudieron cargar las preferencias',
    footnote: 'Algunos tipos de notificación no admiten correo electrónico — esos controles aparecen inactivos.',
    channels: {
      email: 'Correo', emailDesc: 'Enviado a tu bandeja de entrada',
      web: 'Web', webDesc: 'Notificación de navegador / escritorio',
      app: 'App', appDesc: 'Notificación push en móvil',
    },
    groups: {
      social: 'Social', activity_feed: 'Actividad', connections: 'Conexiones',
      account: 'Cuenta', communities: 'Comunidades', chat: 'Chat',
      prayer_calendar: 'Calendario de oración', prayer_wall: 'Peticiones de oración',
      grow_deeper: 'Crecer en Dios',
      faith_checkin: 'Estado espiritual',
      disciplemaking: 'Hacer Discípulos',
      discipleship: 'Discipulado',
      the_well: 'El Pozo',
      daily_rhythm: 'Ritmo Diario',
      fasting: 'Ayuno',
    },
    types: {
      mention: 'Menciones', comment: 'Comentarios', comment_reply: 'Respuestas',
      reaction: 'Reacciones', connection_request: 'Solicitudes de conexión',
      connection_accepted: 'Conexiones aceptadas', community_join_request: 'Solicitudes de unión',
      community_request_accepted: 'Unión aceptada', community_request_rejected: 'Unión rechazada',
      community_invite: 'Invitaciones de comunidad',
      community_event: 'Eventos',
      community_new_post: 'Nuevas publicaciones en la comunidad',
      prayer_reminder: 'Recordatorios de oración',
      account_password_changed: 'Actividad de cuenta',
      community_event_added: 'Nuevos eventos',
      community_event_updated: 'Actualizaciones de eventos',
      chat_dm: 'Mensajes directos',
      chat_community: 'Chat de comunidad',
      prayer_prayed_for_you: 'Alguien oró por ti',
      prayer_wall_connection_request: 'Peticiones de oración (conexiones)',
      prayer_wall_community_request: 'Peticiones de oración (comunidades)',
      prayer_wall_praying_for_answered: 'Oraciones respondidas por las que oras',
      prayer_wall_praying_for_update: 'Actualizaciones de oraciones por las que oras',
      growth_plan_reminder: 'Recordatorios de plan de crecimiento',
      growth_plan_ready: 'Tu plan de crecimiento está listo',
      growth_challenge_starting: 'Desafío comienza mañana',
      growth_challenge_day1: 'Desafío comienza hoy',
      growth_circle_invite: 'Invitación al círculo',
      growth_circle_unit_completed: 'Un compañero del círculo completó una unidad',
      invite_accepted: 'Invitación aceptada',
      discipleship_request: 'Invitaciones de discipulado',
      discipleship_accepted: 'Discipulado aceptado',
      discipleship_ended: 'Discipulado finalizado',
      coaching_checkin_sent: 'Registro esperándote',
      coaching_checkin_answered: 'Respuestas listas para revisar',
      coaching_checkin_response: 'Tu discipulador respondió a tu registro',
      coaching_checkin_reminder: 'Recordatorio de registro',
      bible_plan_published: 'Nuevo plan de lectura bíblica',
      new_post: 'Nuevas publicaciones de la comunidad',
      dm_message: 'Mensajes directos',
      prayer_wall_prayer: 'Alguien oró por ti',
      faith_checkin_reminder: 'Recordatorio de revisión vespertina',
      evangelism_weekly_checkin: 'Registro semanal de evangelismo',
      well_published: 'Nuevo hilo semanal',
      well_video: 'Video del sermón añadido',
      well_reply: 'Respuestas en El Pozo',
      well_discussion: 'Nuevas discusiones',
      daily_rhythm_morning: 'Ritmo de la mañana',
      daily_rhythm_evening: 'Ritmo de la noche',
      fasting_reminder: 'Recordatorio antes de tu horario de ayuno',
      fasting_shift_start: 'Tu ayuno comienza',
      fasting_shift_done: 'Tu turno terminó',
      fasting_relay_update: 'Cada cambio de turno del relevo',
      fasting_complete: 'Ayuno terminado',
    },
  },

  faq: {
    title: 'Ayuda y preguntas frecuentes',
    subtitle: 'Estamos aquí para ayudarte',
    answers: 'respuestas',
    searchPlaceholder: 'Buscar preguntas…',
    noMatch: 'No se encontraron preguntas coincidentes.',
    cats: {
      all: 'Todo', gettingStarted: 'Comenzar', feed: 'Inicio',
      prayer: 'Calendario de oración', prayerWall: 'Peticiones de oración', prayNow: 'Orar ahora',
      bibleStudy: 'Estudio bíblico', communities: 'Comunidades', connections: 'Conexiones',
      profile: 'Perfil', notifications: 'Notificaciones', courses: 'Crecer en Dios', account: 'Cuenta',
    },
  },

  lineage: {
    title: 'Mi Linaje',
    subtitle: 'Tu familia espiritual',
    loading: 'Reuniendo tu linaje…',
    loadFailed: 'No pudimos cargar tu linaje en este momento.',
    retry: 'Intentar de nuevo',
    heroBoth: (discipling, beingDiscipled) =>
      `Estás discipulando a ${discipling} ${discipling === 1 ? 'persona' : 'personas'}. ${beingDiscipled} ${beingDiscipled === 1 ? 'persona te está discipulando' : 'personas te están discipulando'}.`,
    heroDiscipling: (n) =>
      `Estás discipulando a ${n} ${n === 1 ? 'persona' : 'personas'}.`,
    heroBeingDiscipled: (n) =>
      `${n} ${n === 1 ? 'persona te está discipulando' : 'personas te están discipulando'}.`,
    heroLineageExtra: (total) =>
      `${total} ${total === 1 ? 'persona está' : 'personas están'} en tu linaje.`,
    heroEmptyTitle: 'Todo discípulo-hacedor empezó como discípulo.',
    heroEmptyBody: 'Invita a alguien a crecer contigo o pide que alguien te discipule.',
    heroEmptyInviteCta: 'Invita a alguien a crecer contigo',
    heroEmptyMentorCta: 'Pide que alguien te discipule',
    upstreamHeading: 'Quienes te plantaron',
    privacyBoundary: 'los anteriores, en privado',
    notActive: 'Ya no está activo',
    joined: (when) => `Se unió ${when}`,
    joinedShort: (when) => `se unió ${when}`,
    inLineJoined: (n, when) => `${n} en su línea · se unió ${when}`,
    discipling: (rel) => `discipulándote${rel ? ` · ${rel}` : ''}`,
    paused: (rel) => `en pausa${rel ? ` · ${rel}` : ''}`,
    pausedNoTime: 'en pausa',
    youTag: 'tú',
    primaryTag: 'Primario',
    downstreamHeading: 'A quienes llevas',
    downstreamEmpty: 'Aún no estás caminando con nadie.',
    descendants: (n) => `${n} ${n === 1 ? 'descendiente' : 'descendientes'}`,
    expand: 'Expandir',
    collapse: 'Contraer',
    nodeActions: 'Más acciones',
    lineageSummary: (souls, depth) =>
      `${souls} ${souls === 1 ? 'alma crece' : 'almas crecen'} en tu línea, ${depth} ${depth === 1 ? 'generación' : 'generaciones'} de profundidad.`,
    rel: { now: 'ahora mismo', m: (n) => `hace ${n}m`, h: (n) => `hace ${n}h`, d: (n) => `hace ${n}d`, w: (n) => `hace ${n}sem` },
    inviteCta: 'Invita a alguien a crecer contigo',
    truncatedNotice: 'Tu linaje es más grande de lo que esta vista puede mostrar. Se muestra la primera parte del árbol.',
  },

  discipleship: {
    actions: {
      menuLabel: 'Acciones de discipulado',
      offerToWalk: (name) => `Ofrece caminar con ${name}`,
      askToWalk: (name) => `Pídele a ${name} que camine contigo`,
      pendingPill: 'Discipulado pendiente',
    },
    request: {
      offerTitle: (name) => `Ofrece caminar con ${name}`,
      offerBody: (name) =>
        `Estás ofreciendo caminar con ${name} como su discipulador. Esto es un compromiso real de tu parte — recomendamos una conversación con ${name} antes de enviar esto.`,
      askTitle: (name) => `Pídele a ${name} que camine contigo`,
      askBody: (name) =>
        `Estás a punto de pedirle a ${name} que camine contigo como tu discipulador. Esto es un compromiso real — recomendamos hablar con ${name} directamente antes de enviar esto. La app registra la relación, pero el discipulado vive en la vida real.`,
      send: 'Enviar Solicitud',
      cancel: 'Aún no',
      sent: 'Solicitud enviada.',
      sendFailed: 'No pudimos enviar esa solicitud.',
      alreadyPending: 'Ya tienes una solicitud pendiente con esta persona.',
      alreadyActive: 'Ya estás caminando con esta persona.',
      notConnected: 'Primero necesitas estar conectado con esta persona.',
    },
    pending: {
      title: 'Solicitudes Pendientes',
      subtitle: 'Invitaciones esperando tu respuesta',
      loading: 'Cargando solicitudes…',
      loadFailed: 'No pudimos cargar tus solicitudes.',
      heading: 'Esperando tu respuesta',
      empty: 'No hay invitaciones esperando por ti en este momento.',
      sentHeading: 'Solicitudes que has enviado',
      sentEmpty: 'No has enviado ninguna solicitud de discipulado.',
      waitingForResponse: 'Esperando respuesta.',
      lineAskedAsDiscipler: (name) =>
        `${name} te está pidiendo que camines con ${name} como su discipulador.`,
      lineAskedAsDisciple: (name) =>
        `${name} se ofrece a caminar contigo como discipulador.`,
      lineYouOfferedToDisciple: (name) =>
        `Ofreciste caminar con ${name} como su discipulador.`,
      lineYouAskedForDiscipler: (name) =>
        `Le pediste a ${name} que camine contigo.`,
      accept: 'Aceptar',
      decline: 'Rechazar',
      declined: 'Rechazada.',
      accepted: 'Aceptada.',
      acceptFailed: 'No pudimos aceptar esa solicitud.',
      declineFailed: 'No pudimos rechazar esa solicitud.',
    },
    acceptModal: {
      asDisciplerTitle: (name) => `¿Caminar con ${name} como su discipulador?`,
      asDisciplerBody: (name) =>
        `${name} te está pidiendo que camines con ${name} como su discipulador. Esto es un compromiso real — recomendamos hablar con ${name} directamente sobre cómo se vería esto antes de aceptar. La app registra la relación, pero el discipulado vive en la vida real.`,
      asDiscipleTitle: (name) => `¿Permitir que ${name} camine contigo?`,
      asDiscipleBody: (name) =>
        `${name} se ofrece a caminar contigo como discipulador. Antes de aceptar, tómate un momento para hablar con ${name} sobre cómo se vería esto.`,
      confirm: 'Aceptar',
      cancel: 'Aún no',
    },
    endModal: {
      title: (name) => `¿Terminar tu relación con ${name}?`,
      body: (name) =>
        `Terminar esto significa que ${name} ya no aparecerá en tu linaje como alguien con quien estás caminando. ${name} será notificado/a de que la relación ha terminado, pero no verá ninguna razón.`,
      reasonLabel: '¿Algo que quieras anotar para ti? (Privado — solo tú lo verás.)',
      reasonPlaceholder: 'Opcional…',
      confirm: 'Terminar relación',
      cancel: 'Cancelar',
      ended: 'Relación terminada.',
      endFailed: 'No pudimos terminar esta relación.',
    },
    primaryModal: {
      title: (name) => `¿Hacer a ${name} tu discipulador primario?`,
      body: 'Tu discipulador primario aparece en tu linaje como la línea directa sobre ti. Puedes cambiar esto en cualquier momento.',
      confirm: 'Hacer Primario',
      cancel: 'Cancelar',
      changed: 'Discipulador primario actualizado.',
      changeFailed: 'No pudimos actualizar tu discipulador primario.',
    },
    nodeMenu: {
      openProfile: 'Abrir perfil',
      makePrimary: 'Hacer mi discipulador primario',
      end: 'Terminar esta relación',
    },
    nav: {
      pending: 'Solicitudes Pendientes',
      pendingDesc: 'Invitaciones de discipulado',
    },
    callout: {
      headline: (n) =>
        n === 1
          ? 'Una invitación está esperando por ti'
          : `${n} invitaciones están esperando por ti`,
      sub: 'Ver solicitudes pendientes',
    },
  },

  coaching: {
    // ── Pantalla "Caminando con [Nombre]" ─────────────────────────────────
    back: 'Volver al linaje',
    loading: 'Cargando check-ins…',
    loadFailed: 'No pudimos cargar esto en este momento.',
    retry: 'Intentar de nuevo',
    title: (name) => `Caminando con ${name}`,
    roleMentor: (name) => `Estás discipulando a ${name}.`,
    roleMentee: (name) => `${name} te está discipulando.`,
    // ── Encabezado / secciones de "El Hilo" ───────────────────────────────
    subMentor: 'Lo estás discipulando',
    subMentee: 'Te está discipulando',
    since: (when) => `desde ${when}`,
    cadenceLabel: 'Check-in',
    needsResponseLabel: 'Necesita tu respuesta',
    yourTurnLabel: 'Tu turno',
    yourNote: 'Tu nota',
    theirNote: 'Su nota',
    awaitingAnswer: 'Esperando sus respuestas',
    expandRow: 'Mostrar este check-in',
    collapseRow: 'Ocultar este check-in',
    threadEmptyMentor: 'Aún no hay check-ins. Envía uno para iniciar la conversación.',
    threadEmptyMentee: 'Aún no hay check-ins. Tu discipulador enviará uno cuando sea momento.',
    // ── Estado / etiquetas ────────────────────────────────────────────────
    sentOn: (when) => `Enviado ${when}`,
    statusSent: 'Esperando tu respuesta',
    statusSentMentor: 'Esperando su respuesta',
    statusAnswered: 'Respondido',
    statusResponded: 'Contestado',
    answersHeading: 'Respuestas',
    responseHeading: 'Respuesta del discipulador',
    prayerHeading: 'Una oración por ti',
    noAnswer: '(Sin respuesta)',
    // ── Componer (entrenador) ─────────────────────────────────────────────
    newCheckin: 'Nuevo check-in',
    composeTitle: 'Enviar un check-in',
    pickTemplate: 'Elige un punto de partida',
    questionsHeading: 'Preguntas',
    questionsHint: 'Agrega, edita o elimina lo que quieras antes de enviar.',
    addQuestion: 'Agregar una pregunta',
    questionLabelPlaceholder: 'Pregunta',
    helpTextPlaceholder: 'Texto de ayuda (opcional)',
    removeQuestion: 'Eliminar',
    send: 'Enviar check-in',
    sending: 'Enviando…',
    sent: 'Check-in enviado.',
    sendFailed: 'No pudimos enviar ese check-in.',
    needOneQuestion: 'Agrega al menos una pregunta primero.',
    cancel: 'Cancelar',
    // ── Banco de preguntas IA (entrenador) ────────────────────────────────
    suggestBtn: 'Sugerir preguntas (IA)',
    suggesting: 'Pensando…',
    suggestAdded: 'Se agregaron preguntas sugeridas que puedes editar.',
    suggestFallbackNote: 'Preguntas generales de coaching (personalízalas a tu gusto).',
    suggestFailed: 'No pudimos sugerir preguntas en este momento.',
    // ── Responder (aprendiz) ──────────────────────────────────────────────
    answerTitle: 'Responder este check-in',
    answerPlaceholder: 'Tu respuesta…',
    submit: 'Enviar respuestas',
    submitting: 'Enviando…',
    submitted: 'Respuestas enviadas.',
    submitFailed: 'No pudimos enviar tus respuestas.',
    needOneAnswer: 'Responde al menos una pregunta.',
    // ── Contestar (entrenador) ────────────────────────────────────────────
    respondTitle: 'Responder y orar',
    noteLabel: 'Tu respuesta',
    notePlaceholder: 'Anima, desafía o acompaña…',
    prayerLabel: 'Una oración (opcional)',
    prayerPlaceholder: 'Ora por ellos…',
    respondSend: 'Enviar respuesta',
    respondSending: 'Enviando…',
    responded: 'Respuesta enviada.',
    respondFailed: 'No pudimos enviar tu respuesta.',
    needNoteOrPrayer: 'Agrega una respuesta o una oración primero.',
    // ── Bandejas en la pantalla de Linaje ─────────────────────────────────
    inboxAnswerHeadline: (n) =>
      n === 1 ? 'Un check-in está esperando por ti' : `${n} check-ins están esperando por ti`,
    inboxAnswerSub: 'Responde los check-ins de tu discipulador',
    inboxResponseHeadline: (n) =>
      n === 1 ? 'Una respuesta está lista para revisar' : `${n} respuestas están listas para revisar`,
    inboxResponseSub: 'Responde y ora por sus check-ins',
  },

  planPreview: {
    notFound: 'Plan no encontrado',
    notFoundDesc: 'Este plan puede haber sido eliminado o ya no está disponible.',
    exploreIgnite: 'Explorar Ignite',
    signIn: 'Iniciar sesión',
    signUpToStart: 'Regístrate para comenzar este plan',
    alreadyHaveAccount: '¿Ya tienes una cuenta?',
    whatYoullCover: 'Lo que cubrirás',
    growthPlan: 'Plan de crecimiento',
    days: 'días',
    weeks: 'semanas',
    enrolled: 'inscritos',
    untitled: 'Sin título',
  },

  rhythm: {
    title: 'Ritmo Diario',
    subtitle: 'Un caminar día a día con tu comunidad',

    morning: 'Mañana',
    evening: 'Noche',
    theme: 'Tema',
    focus: 'Enfoque',
    scripture: 'Lectura bíblica',
    devotional: 'Devocional',
    read: 'Lee',
    pray: 'Ora',
    ask: 'Pide',
    listen: 'Escucha',
    respond: 'Responde',
    aboutWeek: 'Sobre esta semana',
    story: 'Historia',
    prayerPrompt: 'Guía de oración',
    watchVideo: 'Ver el video',
    videoUnavailable: 'No se pudo cargar el video. Intenta actualizar la página.',
    storyPending: 'El video de esta historia aún no se ha publicado. Vuelve pronto.',

    dayN: (n) => `Día ${n}`,
    today: 'Hoy',
    untitledDay: 'El ritmo de hoy',
    notYetOpen: 'Aún no disponible',
    nothingHere: 'No se ha agregado nada a esta sección.',
    reflected: 'Reflexionaste en este día',
    otherSeasons: 'Otras temporadas',
    timesLabel: (time) => `Mañanas a las ${time}`,

    opensAt: (time) => `Se abre a las ${time}`,
    eveningAt: (time) => `Noche a las ${time}`,
    inTime: (dur) => `en ${dur}`,
    notScheduled: 'Aún no programado',

    yourReflection: 'Tu reflexión',
    reflectionPlaceholder: '¿Qué está moviendo Dios en ti hoy?',
    defaultJournalPrompt: '¿Qué está trayendo Jesús a tu atención hoy?',
    keepAJournal: 'Lleva un diario',
    optional: 'Opcional',
    // Informe del programa para organizadores (DailyRhythmReportScreen). Solo conteos.
    report: {
      open: 'Informe',
      title: 'Informe del programa',
      back: 'Volver al programa',
      countsOnly: 'Solo conteos. Aquí no se muestra la actividad ni lo que escribió ninguna persona.',
      unavailable: 'El informe no está disponible en este momento.',
      participants: 'Miembros que escribieron',
      participantsSub: (n) => `de ${n} miembros activos`,
      reflections: 'Reflexiones escritas',
      shared: 'Compartidas con la comunidad',
      summaries: 'Resúmenes de “Mi semana”',
      opens: 'Aperturas',
      notTracked: 'Sin registro',
      pushReach: 'Pueden recibir notificaciones push',
      pushReachValue: (n, total) => `${n} de ${total}`,
      pushReachNote: 'Todos reciben la notificación dentro de la app. Solo quienes permitieron notificaciones en un dispositivo reciben un push, así que animar a la gente a activarlas alcanza a más de la iglesia.',
      byDayTitle: 'Reflexiones por día',
      daysTitle: 'Día por día',
      morning: 'Mañana',
      evening: 'Noche',
      notified: 'Notificados',
      delivered: 'Push entregados',
      opened: 'Abrieron',
      cardEngagement: 'Tarjeta del feed',
      reactionsN: (n) => `${n} ${n === 1 ? 'reacción' : 'reacciones'}`,
      commentsN: (n) => `${n} ${n === 1 ? 'comentario' : 'comentarios'}`,
      reflectionsN: (n) => `${n} ${n === 1 ? 'reflexión' : 'reflexiones'}`,
      sharedN: (n) => `${n} compartidas`,
      sources: { push: 'push', bell: 'lista de notificaciones', feed: 'tarjeta del feed', app: 'en la app' },
      states: {
        sent: 'Enviado',
        skipped: 'Nada que enviar',
        empty: 'Sin contenido',
        unscheduled: 'Sin hora',
        due: 'Enviando',
        pending: 'Todavía no',
      },
      promptsTitle: 'Preguntas del diario usadas',
      promptsSub: 'Cuántas reflexiones respondieron cada pregunta.',
      promptJournal: 'La pregunta del día',
      promptEvening: 'La pregunta de la noche',
      hoursTitle: 'Cuándo escribe la gente',
      hoursSub: (tz) => `Reflexiones por hora de inicio, en ${tz}.`,
      hoursPeak: (hour) => `La mayoría empieza a escribir alrededor de las ${hour}.`,
      hourTip: (hour, n) => `${hour}: ${n}`,
      notesTitle: 'Sobre estos números',
      noteOpens: (date) => `Las aperturas se cuentan desde el ${date}: la primera vez que alguien abre un día mientras esa parte está disponible. Los días publicados antes aparecen como “Sin registro”.`,
      noteDelivery: (days) => `El detalle de entrega de push se guarda ${days} días; después se muestra “—”.`,
      noteNotified: 'Notificados son todos los que recibieron la notificación en la app; entregados son los push que llegaron a un dispositivo.',
    },
    // La tarjeta del feed que se publica cuando se abre un momento (components/PostShareCard.js).
    feedCard: {
      tonightsStory: (title) => `La historia de esta noche: ${title}`,
      startToday:    'Comienza el ritmo de hoy',
      watchStory:    'Mira la historia de esta noche',
      openEvening:   'Abre el ritmo de esta noche',
      video:         'Video',
    },
    fields: {
      stoodOut:   'Versículos que te llamaron la atención',
      thoughts:   'Pensamientos o preguntas que surgieron',
      hearing:    'Lo que sientes que Él te puede estar diciendo',
      responding: 'Cómo estás respondiendo',
    },
    myWeek: 'Mi semana',
    myWeekSub: 'Todo lo que escribiste esta semana, en un solo lugar.',
    lookBack: 'Mira atrás a tu semana',
    onlyYou: 'Solo tú puedes ver esta página.',
    nothingWrittenYet: 'Todavía no has escrito nada. Tus reflexiones se irán reuniendo aquí.',
    lookingBack: 'Mirando atrás a tu semana',
    lookingBackNote: 'Basado en lo que escribiste esta semana.',
    summarize: 'Resumir mi semana',
    summarizing: 'Leyendo de nuevo tu semana…',
    refreshSummary: 'Actualizar con mis últimas entradas',
    summaryFailed: 'No pudimos prepararlo ahora. Inténtalo de nuevo en un momento.',
    summarizeHint: 'Una breve mirada atrás a los temas, a lo que sentiste que Él te decía y a los pasos que nombraste, tomada solo de lo que escribiste.',
    summaryOutOfDate: 'Has escrito más desde que se preparó esto.',
    save: 'Guardar',
    saved: 'Guardado',
    saveAndShare: 'Guardar y compartir con la comunidad',
    updateShared: 'Actualizar lo que compartiste',
    sharedNote: 'Compartido con tu comunidad',
    shareTitle: 'Compartir con tu comunidad',
    shareHint: 'Elige qué será visible para el resto de tu comunidad. Lo que dejes sin marcar permanece privado.',
    confirmShare: 'Compartir',
    unshare: 'Dejar de compartir',
    cancel: 'Cancelar',
    communityReflections: (n) => n === 1 ? '1 reflexión compartida' : `${n} reflexiones compartidas`,
    someone: 'Alguien',

    dayNotFound: 'Este día no forma parte del ritmo.',
    dayUnavailable: 'Este ritmo no está disponible en este momento.',
    backToRhythm: 'Volver al ritmo',

    card: {
      openNow: 'Disponible ahora',
      eveningAt: (time) => `La noche se abre a las ${time}`,
      nextOn: (date) => `Próximo el ${date}`,
      viewAll: 'Ver todo el ritmo',
    },

    empty: {
      member: 'Tu comunidad aún no ha comenzado un ritmo.',
      organizer: 'Crea un programa para iniciar un ritmo diario en esta comunidad.',
    },

    settings: {
      enable: 'Activar Ritmo Diario',
      description: 'Publica un ritmo de mañana y noche para cada día de una temporada, con una notificación cuando cada parte se abre.',
      disableConfirm: '¿Desactivar el Ritmo Diario? Los miembros perderán el acceso a todos los programas y días de inmediato hasta que lo actives de nuevo. Sus propias reflexiones permanecen en su Diario.',
      timezone: 'Zona horaria',
      timezoneHint: 'Los horarios de publicación se leen en esta zona. Toda la comunidad recibe la notificación en el mismo momento.',
      morningTime: 'Hora predeterminada de la mañana',
      eveningTime: 'Hora predeterminada de la noche',
      defaultsHint: 'Estos valores inician un programa nuevo. Cambiarlos nunca modifica el horario de un programa que ya está en curso.',
      managePrograms: 'Gestionar programas',
    },

    manage: {
      title: 'Programas de Ritmo Diario',
      createProgram: 'Nuevo programa',
      create: 'Crear programa',
      programTitle: 'Nombre del programa',
      titlePlaceholder: 'Semana IGNITE',
      description: 'Descripción',
      startDate: 'Primer día',
      endDate: 'Último día',
      timezone: 'Zona horaria',
      timezoneHint: 'Los horarios de publicación se leen en esta zona.',
      morningTime: 'La mañana se abre a las',
      eveningTime: 'La noche se abre a las',
      datesTitle: 'Fechas',
      datesHint: 'Acortar el rango elimina los días que quedan fuera. Un día en el que alguien escribió una reflexión siempre se conserva.',
      datesShrinkConfirm: '¿Eliminar los días fuera del nuevo rango? Los días con reflexiones se conservan.',
      saveDates: 'Guardar fechas',
      firstDayNumber: 'Numerar el primer día',
      firstDayOne: 'Día 1',
      firstDayZero: 'Día 0',
      firstDayHint: 'Elige Día 0 cuando la primera fecha es una introducción, para que el día siguiente sea el Día 1.',
      oneDayPerDate: 'Se crea una entrada para cada fecha del rango. Si dejas un día vacío, simplemente no enviará notificación.',
      noPrograms: 'Aún no hay programas.',
      programMissing: 'Ese programa ya no existe.',
      backToPrograms: 'Volver a los programas',
      backToProgram: 'Volver al programa',
      dayCount: (n) => n === 1 ? '1 día' : `${n} días`,
      untitled: 'Día sin título',
      editDay: 'Editar este día',
      saveDay: 'Guardar día',
      saving: 'Guardando…',
      savedTick: '✓ Guardado',
      saveFailed: 'No se pudo guardar',
      actionFailed: 'Algo salió mal. Inténtalo de nuevo.',

      status: { draft: 'Borrador', published: 'Publicado', archived: 'Archivado' },
      draftBanner: 'Este programa sigue siendo un borrador. Los miembros aún no pueden verlo.',
      publish: 'Publicar',
      publishHint: 'Al publicar, el programa se hace visible y comienzan las notificaciones diarias. Los días cuya hora ya pasó no enviarán una notificación tardía.',
      archive: 'Archivar',
      archiveConfirm: '¿Archivar este programa? Los miembros dejarán de verlo, pero no se elimina nada.',
      delete: 'Eliminar',
      deleteConfirm: '¿Eliminar este programa y todos sus días? Esto no se puede deshacer.',
      releaseNow: 'Publicar esta sección ahora',
      releaseConfirm: '¿Publicar esta sección ahora y notificar a toda la comunidad?',
      alreadySent: 'Notificado',
      scheduledFor: (time) => `Se abre a las ${time}`,
      sent: 'enviado',
      unfilledDays: (n) => n === 1
        ? '1 día aún no tiene contenido. No notificará a nadie hasta que agregues algo.'
        : `${n} días aún no tienen contenido. No notificarán a nadie hasta que agregues algo.`,
      partialDays: (n) => n === 1
        ? '1 día está completo solo a medias.'
        : `${n} días están completos solo a medias.`,

      opensWithMorning: 'Se abre con la Mañana.',
      keyVerse: 'Versículo clave',
      keyVersePlaceholder: '“Quédense quietos, reconozcan que yo soy Dios.”',
      keyVerseRef: 'Referencia del versículo clave',
      readGuide: 'Cómo leerlo',
      journalQuestion: 'Pregunta del diario',
      storyTitlePlaceholder: 'Escuchar la voz de Dios',
      introHint: 'Se muestra, plegado, al inicio de la página del programa. Cómo funciona la semana: el ayuno, el diario, los videos de la noche.',
      saveIntro: 'Guardar',
      journalPromptPlaceholder: '¿Qué escuchaste de Jesús hoy?',
      journalPromptHint: 'La pregunta que los miembros responden en su reflexión. Déjala vacía para usar la predeterminada: “¿Qué está trayendo Jesús a tu atención hoy?”',
      storyTitle: 'Título de la historia',
      uploadVideo: 'Subir un video',
      orVideoLink: 'O pega un enlace de video',
      videoLinkHint: 'YouTube o Vimeo. Si también subes un archivo, se usa el archivo.',
      themePlaceholder: 'Dios, háblame',
      focusPlaceholder: 'Escuchar la voz de Dios',
      overrideTime: 'Hora distinta para este día',
      useProgramDefault: (time) => `Usar el valor del programa (${time})`,
      usingDefault: (time) => `Usando el valor del programa — ${time}`,
      previewAsMember: 'Vista previa como miembro',
      previewBanner: 'Esto es lo que ve un miembro en este momento.',
      previewNote: 'Ves todo porque organizas esta comunidad. Los miembros solo ven una sección cuando se abre.',
    },
  },

  well: {
    title:               'El Pozo',
    subtitle:            'Continúa la conversación',
    noThread:            'Aún no hay tema esta semana',
    newThread:           'Nuevo Tema',
    thisWeek:            'Esta Semana',
    previousWeeks:       'Semanas Anteriores',
    sermonNotes:         'Notas del Sermón',
    sermonInfo:          'Información del Sermón',
    scripture:           'Escritura',
    myNotes: {
      title:               'Mis Notas',
      privacy:             'Solo tú puedes verlo',
      addPrompt:           'Agregar una nota…',
      addingTo:            'Agregando nota personal a',
      composerPlaceholder: 'Captura un pensamiento, una pregunta, un versículo…',
      add:                 'Agregar',
      addHint:             '⌘/Ctrl+Enter para agregar',
      empty:               'Tus notas aparecerán aquí a medida que las agregues.',
      edit:                'Editar',
      delete:              'Eliminar',
      deleteConfirm:       '¿Eliminar esta nota?',
      cancel:              'Cancelar',
      save:                'Guardar',
      editError:           'No se pudo guardar tu nota',
      deleteError:         'No se pudo eliminar tu nota',
      tooLong:             'Nota demasiado larga — intenta dividirla en fragmentos más pequeños',
      tooMany:             'Has alcanzado el límite de notas para este sermón',
      colorLabel:          'Color de nota',
      colorCustom:         'Color personalizado',
      colors: {
        indigo:  'Reflexión',
        amber:   'Idea clave',
        rose:    'Convicción',
        emerald: 'Acción',
        sky:     'Pregunta',
        violet:  'Oración',
        stone:   'Otros',
      },
    },
    verseNotes: {
      hint:         '(toca un vers\u00edculo para anotarlo)',
      barLabel:     'Vers\u00edculos seleccionados',
      addNote:      'Anotar esto',
      clear:        'Quitar',
      alreadyNoted: (n) => `Ya hay ${n} ${n === 1 ? 'nota' : 'notas'} aqu\u00ed`,
      passageGone:  'Este pasaje ya no est\u00e1 en el hilo.',
    },
    discussionQuestions: 'Preguntas para Reflexionar',
    openInBible:         'Abrir Escritura',
    challenge:           'Desafío de la Semana',
    challengeShare:      'Comparte tu Respuesta',
    challengePlaceholder:'¿Qué hiciste o experimentaste esta semana?',
    challengeResponses:  'Respuestas de la Comunidad',
    challengeSubmitted:  'Gracias por compartir — tu respuesta ya está registrada.',
    discussion:          'Discusión',
    sortLabel:           'Ordenar discusiones',
    sortNew:             'Nuevas',
    sortTop:             'Destacadas',
    reply:               'Responder',
    replyPlaceholder:    'Únete a la discusión…',
    replyTo:             (name) => `Responder a ${name}`,
    starter: {
      triggerLabel:    'Continúa la conversación de la palabra de esta semana…',
      triggerCta:      'Iniciar una discusión',
      modalEyebrow:    'Agregar a la discusión',
      placeholder:     'Comparte un pensamiento, una pregunta o un versículo que el mensaje despertó…',
      send:            'Publicar',
      cancel:          'Cancelar',
      close:           'Cerrar',
      postError:       'No se pudo publicar',
    },
    replyDeleted:        '[Esta publicación fue eliminada]',
    continueThread:      'Continuar hilo →',
    yourReply:           'Tu respuesta',
    send:                'Enviar',
    pin:                 'Fijar Publicación',
    unpin:               'Desfijar Publicación',
    edit:                'Editar Publicación',
    delete:              'Eliminar Publicación',
    deleteConfirm:       '¿Eliminar esta publicación? No se puede deshacer.',
    report:              'Reportar Publicación',
    reportConfirm:       '¿Reportar esta publicación para revisión?',
    reportSent:          'Gracias — nuestro equipo revisará esta publicación.',
    pinned:              'Fijado',
    questionBadge:       'Pregunta',
    by:                  'por',
    moreOptions:         'Más opciones',
    reactions: {
      amen:    'Amén',
      praying: 'Orando',
      fire:    'Fuego',
      heart:   'Corazón',
      viewAll: 'Ver todas las reacciones',
    },
    video: {
      add:           'Añadir Video del Sermón',
      watch:         'Ver Sermón',
      label:         'URL del Video del Sermón',
      placeholder:   'https://youtube.com/...',
      invalid:       'Por favor ingresa una URL válida de YouTube o Vimeo',
      save:          'Guardar Video',
    },
    settings: {
      title:        'El Pozo',
      subtitle:     'Discusión semanal del sermón para tu comunidad',
      enable:       'Activar El Pozo',
      sourceUrl:    'URL del Sermón',
      sourceUrlPlaceholder: 'https://tuiglesia.com/estasemana',
      sourceUrlHelper: 'Pega la página semanal del sermón de tu iglesia. La automatización está disponible actualmente para Oakdale Church. Para otras iglesias, agregaremos soporte conforme se unan comunidades — te contactaremos cuando la tuya esté lista.',
      autoPost:     'Publicar automáticamente el domingo',
      autoPostHelper: 'La información del sermón se rastreará y publicará automáticamente cada domingo a las 8 AM (hora del Este). Recibirás un correo de vista previa alrededor de las 7 AM (hora del Este) para revisar primero.',
      futureNote:   'La automatización para esta URL se añadirá en una futura actualización.',
      saved:        'Configuración guardada',
      saveError:    'No se pudo guardar la configuración',
      fetchNow:     'Buscar y Generar Ahora',
      fetchNowHelper: 'Ejecuta el rastreador del domingo ahora y crea un borrador que puedes revisar y publicar.',
      fetchSuccess: 'Borrador creado — abriéndolo ahora…',
      fetchError:   'No se pudo obtener el sermón. Verifica la URL e intenta de nuevo.',
      viewDraft:    'Ver Borrador',
      lastFetched:  'Última obtención',
      disableConfirm: '¿Desactivar El Pozo? Los miembros perderán acceso a los temas de sermones existentes hasta que lo vuelvas a activar.',
      nonOakdaleNotice: 'La obtención automática y la publicación dominical solo funcionan actualmente con URLs de oakdale.church. Aún puedes crear temas manualmente.',
    },
    admin: {
      manageThreads:  'Administrar Temas',
      newThread:      'Nuevo Tema',
      editThread:     'Editar Tema',
      saveDraft:        'Guardar Borrador',
      publishNow:       'Publicar Ahora',
      scheduleSunday:   'Programar para el Domingo',
      save:             'Guardar',
      unpublishToDraft: 'Despublicar y Guardar como Borrador',
      moveToDraft:    'Mover a Borrador',
      statusDraft:     'Borrador',
      statusScheduled: 'Programado',
      statusPublished: 'Publicado',
      statusArchived:  'Archivado',
      deleteThread:   'Eliminar',
      deleteConfirm:  '¿Eliminar este tema del sermón? Esto también eliminará todas las publicaciones, respuestas, reacciones y notas privadas de los miembros. Esto no se puede deshacer.',
      scrapePreview:  'Vista Previa del Rastreo',
      confirmScrape:  'Usar Estos Datos',
      regenerate:     'Regenerar Preguntas con IA',
      seriesTitle:    'Título de la Serie (opcional)',
      sermonTitle:    'Título del Sermón',
      speaker:        'Predicador (opcional)',
      weekLabel:      'Semana',
      scriptures:     'Escrituras',
      addScripture:   'Añadir Escritura',
      scriptureRef:   'Referencia (ej. Juan 3:16)',
      scriptureUrl:   'Enlace (bible.com)',
      notes:          'Notas del Sermón',
      notesPlaceholder: 'Escribe los puntos del sermón — usa negrita, cursiva, listas, etc.',
      scraperDiagnostics: 'Fuente del extractor (diagnóstico)',
      parsedNotes:    'Notas interpretadas',
      sourceHtml:     'Muestra del HTML de origen',
      photoUrl:       'Imagen Principal',
      photoUpload:    'Subir imagen principal',
      videoUrl:       'URL del Video del Sermón',
      challenge:      'Desafío Semanal',
      questions:      'Preguntas de Discusión',
      addQuestion:    'Añadir Pregunta',
      status:         'Estado',
      statuses: {
        draft:     'Borrador',
        scheduled: 'Programado',
        published: 'Publicado',
        archived:  'Archivado',
      },
      preview:        'Vista Previa',
      backToFeed:     'Volver a El Pozo',
    },
    notification: {
      openTitle:      '☀️ El Pozo está abierto',
      videoTitle:     '🎥 El video del sermón ya está disponible',
      videoBody:      'Mira el mensaje de esta semana en El Pozo',
      replyTitle:     (username) => `${username} te respondió en El Pozo`,
    },
  },

  // ── Ayuno (screens/fasting/) ────────────────────────────────────────────────
  fasting: {
    title: 'Ayuno',
    subtitle: 'Ayunen y oren juntos — en relevo, o todos a la vez.',
    newFast: 'Nuevo ayuno',
    empty: {
      member: 'Todavía no se ha anunciado ningún ayuno aquí.',
      organizer: 'Organiza un ayuno para esta comunidad — un relevo donde las personas se turnan, o un día en que todos ayunan juntos.',
    },
    modes: {
      relay: 'Ayuno en relevo',
      together: 'Ayuno juntos',
      relayHint: 'Las personas se turnan para que siempre haya alguien ayunando — como una vigilia de oración que nunca se apaga.',
      togetherHint: 'Todos ayunan durante el mismo horario cada día, lado a lado.',
    },
    status: { draft: 'Borrador', published: 'Abierto', archived: 'Archivado' },
    blockLabel: (h) => (h === 1 ? 'turnos de 1 hora' : `turnos de ${h} horas`),
    windowLabel: (h) => (h === 1 ? 'ayuno de 1 hora cada día' : `ayuno de ${h} horas cada día`),
    daysLabel: (n) => (n === 1 ? '1 día' : `${n} días`),
    coverageLine: (covered, total) => `${covered} de ${total} turnos cubiertos`,
    peopleLine: (n) => (n === 1 ? '1 persona' : `${n} personas`),
    togetherPeople: (n) => (n === 1 ? '1 persona ayunando' : `${n} personas ayunando`),
    nowFasting: 'Ayunando ahora',
    upNext: 'Sigue',
    nextOpen: 'El siguiente turno está libre',
    nowOpen: 'Este turno está libre — nadie está ayunando ahora',
    startsOn: (when) => `Comienza ${when}`,
    ended: 'Este ayuno terminó',
    endedThanks: (people, shifts) => `${people} ${people === 1 ? 'persona cubrió' : 'personas cubrieron'} ${shifts} ${shifts === 1 ? 'turno' : 'turnos'}. Gracias por ponerte en la brecha.`,
    yourNext: (when) => `Tu próximo turno: ${when}`,
    yourCount: (n) => (n === 1 ? 'Estás inscrito en 1 horario' : `Estás inscrito en ${n} horarios`),
    until: (time) => `hasta las ${time}`,
    timesIn: (zone) => `Todos los horarios en ${zone}`,
    hero: {
      when: 'Cuándo',
      shifts: 'Turnos',
      eachDay: 'Cada día',
      hours: (h) => (h === 1 ? '1 hora' : `${h} horas`),
      from: (time) => `desde las ${time}`,
      covered: 'Cubiertos',
      ofTotal: (covered, total) => `${covered} de ${total}`,
      purpose: 'Propósito y guía',
      readMore: 'Leer más',
      showLess: 'Mostrar menos',
    },
    encourage: 'Anímense unos a otros en el chat de la comunidad',
    addToCalendar: 'Agregar mis horarios al calendario',
    joinAll: 'Unirme todos los días',
    joinedAll: 'Estás inscrito todos los días',
    startingOn: (day) => `Comienzan el ${day}`,
    shiftsCount: (n) => (n === 1 ? 'comienza 1 turno' : `comienzan ${n} turnos`),
    filters: { all: 'Todos', open: 'Libres', mine: 'Míos' },
    noneMine: 'Todavía no te has inscrito en ningún horario.',
    noneOpen: 'Todos los turnos están cubiertos. 🙌',
    slot: {
      starts: 'Empieza',
      ends: 'Termina',
      durationH: (h) => (h === 1 ? '1 h' : `${h} h`),
      fastingNow: 'Ayunando ahora',
      yourShift: 'Tu turno',
      needsSomeone: 'Falta alguien',
      noOneYet: 'Nadie todavía',
      take: 'Tomar este turno',
      join: 'Unirme',
      leave: 'Dejar',
      leaveConfirm: '¿Devolver este horario? Otra persona podrá tomarlo.',
      full: 'Lleno',
      open: 'Libre',
      spots: (count, cap) => `${count} de ${cap}`,
      people: (n) => (n === 1 ? '1 ayunando' : `${n} ayunando`),
      you: 'Tú',
      guest: 'Invitado',
      now: 'Ahora',
      past: 'Hecho',
      add: 'Agregar a alguien',
      remove: 'Quitar',
      removeConfirm: (name) => `¿Quitar a ${name} de este horario?`,
    },
    errors: {
      full: 'Alguien acaba de tomar ese lugar. Elige otro horario.',
      notOpen: 'Las inscripciones se abren cuando el organizador publique este ayuno.',
      generic: 'Algo salió mal. Inténtalo de nuevo.',
      locked: 'El horario ya no puede cambiar porque hay personas inscritas. Todavía puedes editar el título, la descripción y la configuración.',
    },
    manage: {
      publish: 'Publicar',
      publishConfirm: '¿Publicar este ayuno? Los miembros podrán verlo e inscribirse.',
      publishedNote: 'Publicado — los miembros pueden inscribirse.',
      draftNote: 'Borrador — solo los organizadores pueden verlo. Publícalo cuando esté listo.',
      edit: 'Editar',
      export: 'Exportar CSV',
      archive: 'Archivar',
      archiveConfirm: '¿Archivar este ayuno? Queda visible como historial, pero sale del inicio de la comunidad.',
      delete: 'Eliminar',
      deleteConfirm: '¿Eliminar este ayuno y todas sus inscripciones? No se puede deshacer.',
      publicLink: 'Página pública de inscripción',
      publicLinkHint: 'Cualquiera con este enlace puede inscribirse con su nombre y correo — sin necesidad de cuenta.',
      publicDraft: 'La página pública se activa cuando publiques.',
      copy: 'Copiar enlace',
      copied: 'Copiado',
      open: 'Abrir',
    },
    assign: {
      title: 'Agregar a alguien a este horario',
      member: 'Un miembro de la comunidad',
      guest: 'Alguien sin la app',
      pick: 'Elige un miembro',
      name: 'Nombre',
      email: 'Correo (opcional — recibe una confirmación y un recordatorio)',
      add: 'Agregar',
      cancel: 'Cancelar',
    },
    form: {
      createTitle: 'Nuevo ayuno',
      editTitle: 'Editar ayuno',
      title: 'Título',
      titlePlaceholder: 'Ayuno por nuestra transición pastoral',
      description: 'Propósito y orientación',
      descriptionPlaceholder: '¿Por qué estamos orando? ¿De qué deben ayunar? ¿Alguna orientación sobre salud o cómo terminar el ayuno?',
      style: '¿Cómo van a ayunar?',
      schedule: 'Horario',
      startDate: 'Fecha de inicio',
      days: 'Número de días',
      endDate: 'Fecha final',
      relayStartTime: 'Los turnos cambian a las',
      relayStartHint: 'p. ej. 6:00 PM para ayunos de tarde a tarde.',
      togetherStartTime: 'El ayuno comienza a las',
      blockHours: 'Duración del turno',
      hours: (h) => (h === 1 ? '1 hora' : `${h} horas`),
      windowHours: 'Duración del ayuno cada día (horas)',
      windowHint: '12 para de sol a sol, 24 para un día completo.',
      capacity: 'Personas por turno',
      capacityHint: '0 significa sin límite. La mayoría de los relevos usan 1 o 2.',
      timezone: 'Zona horaria',
      reminders: 'Recordatorios',
      reminderLabel: 'Recordar a las personas antes de su horario',
      reminderOptions: { 0: 'Sin recordatorio', 1: '1 hora antes', 3: '3 horas antes', 12: '12 horas antes', 24: '1 día antes' },
      reminderHint: 'Por notificación a los miembros y por correo a los invitados.',
      announce: 'Publicar novedades en la comunidad',
      announceHint: 'Una tarjeta breve cuando cada turno pasa la antorcha (relevo) o empieza cada día (juntos), y cuando termina el ayuno. A los miembros solo se les notifica sobre sus propios horarios.',
      publicSignup: 'Página pública de inscripción',
      publicSignupHint: 'Un enlace que se puede usar sin la app Ignite. Dan su nombre y correo, y reciben una confirmación, recordatorios y un enlace para cambiar sus horarios.',
      showNames: 'Mostrar nombres en la página pública',
      showNamesHint: 'Como nombre e inicial del apellido ("Amy R."). Desactivado solo muestra "Ocupado".',
      previewRelay: (count, h) => `${count} turnos de ${h} ${h === 1 ? 'hora' : 'horas'}`,
      previewTogether: (count, h) => `${count} ${count === 1 ? 'día' : 'días'}, ${h} ${h === 1 ? 'hora' : 'horas'} cada uno`,
      previewRange: (start, end) => `${start} → ${end}`,
      locked: 'Hay personas inscritas, así que el horario está bloqueado. Todo lo demás todavía puede cambiar.',
      save: 'Guardar',
      create: 'Crear borrador',
      saving: 'Guardando…',
      cancel: 'Cancelar',
      required: 'Agrega un título.',
    },
    feedCard: {
      badge: 'Ayuno',
      handoff: (prev, next, n) => `${prev} terminó un turno — ${next} ${n > 1 ? 'llevan' : 'lleva'} la antorcha ahora.`,
      handoffStart: (next, n) => `El relevo comenzó — ${next} ${n > 1 ? 'ayunan' : 'ayuna'} primero.`,
      handoffOpen: (prev) => (prev ? `${prev} terminó un turno. El siguiente está libre — ¿podrías tomarlo?` : 'Este turno está libre — ¿podrías tomarlo?'),
      day: (n) => (n === 1 ? '1 persona está ayunando hoy.' : `${n} personas están ayunando juntas hoy.`),
      dayNone: 'El ayuno comenzó. Únete hoy.',
      complete: (people, shifts) => `El ayuno terminó — ${people} ${people === 1 ? 'persona cubrió' : 'personas cubrieron'} ${shifts} ${shifts === 1 ? 'tiempo' : 'tiempos'} de ayuno. ¡Gracias!`,
      cta: 'Abrir la hoja de inscripción',
      and: 'y',
      others: (n) => `${n} más`,
    },
    homeCard: {
      live: 'En curso',
      starts: (n) => (n <= 0 ? 'Empieza hoy' : n === 1 ? 'Empieza mañana' : `Empieza en ${n} días`),
      begins: 'Comienza',
      nobodyNow: 'Este turno está abierto — nadie aún',
      openShift: 'Abierto — necesita a alguien',
      signUpCta: 'Anótate para un turno',
    },
    public: {
      chosen: 'Elegido',
      by: (community) => `con ${community}`,
      pickTimes: 'Elige tu(s) horario(s)',
      pickHint: 'Toca cualquier horario libre. Puedes elegir más de uno.',
      taken: 'Ocupado',
      yours: 'Tuyo',
      selected: (n) => (n === 1 ? '1 horario elegido' : `${n} horarios elegidos`),
      continue: 'Continuar',
      yourDetails: 'Tus datos',
      name: 'Tu nombre',
      email: 'Correo electrónico',
      emailHint: 'Te enviaremos una confirmación, un recordatorio antes de tu horario y un enlace para cambiarlo. Nada más.',
      submit: 'Inscribirme',
      submitting: 'Inscribiéndote…',
      back: 'Atrás',
      doneTitle: (name) => `¡Estás inscrito${name ? `, ${name}` : ''}!`,
      doneBody: 'Te enviamos una confirmación por correo con un enlace para ver o cambiar tus horarios.',
      doneFull: (n) => (n === 1 ? 'Un horario que elegiste se ocupó justo antes — elige otro abajo.' : `${n} horarios que elegiste se ocuparon justo antes — elige otros abajo.`),
      welcomeBack: (name) => `Bienvenido de nuevo, ${name} — tus horarios están marcados.`,
      manageLink: 'Ver o cambiar mis horarios',
      addMore: 'Agregar más horarios',
      getApp: 'Obtén la app Ignite para animarse unos a otros en el chat de la comunidad',
      notFound: 'Esta página de inscripción no está disponible. Es posible que el organizador la haya cerrado.',
      errName: 'Escribe tu nombre.',
      errEmail: 'Escribe un correo válido.',
      errNoSlots: 'Elige al menos un horario.',
      language: 'English',
      poweredBy: 'Hecho con Ignite',
    },
    invite: {
      title: (community) => `Te inscribiste para ayunar con ${community}`,
      body: (title, n) => `${title} · ${n === 1 ? '1 horario' : `${n} horarios`}. Únete para ver tus turnos y animarse unos a otros.`,
      join: 'Unirme',
      joining: 'Uniéndote…',
      dismiss: 'Ahora no',
      error: 'No se pudo unir ahora. Inténtalo de nuevo.',
    },
    manageGuest: {
      inAppTitle: 'Tus horarios ya están en la app Ignite',
      inAppBody: (title) => `Te uniste a Ignite con este correo, así que tus horarios de ${title} pasaron a la app. Cámbialos allí.`,
      openApp: 'Abrir en Ignite',
      notMeTitle: '¿No te inscribiste?',
      notMeBody: 'Puede que alguien escribiera tu correo por error. Puedes quitar estos horarios y dejar de recibir los correos.',
      notMeButton: 'Quitar estos horarios',
      notMeConfirm: '¿Quitar todos los próximos horarios de esta inscripción y dejar de recibir los correos?',
      notMeDone: 'Listo — se quitaron los horarios y no recibirás más correos sobre este ayuno.',
      title: 'Tus horarios de ayuno',
      hello: (name) => `Hola ${name}`,
      none: 'No estás inscrito en ningún horario ahora.',
      cancel: 'Cancelar este horario',
      cancelConfirm: '¿Cancelar este horario? Otra persona podrá tomarlo.',
      emails: 'Enviarme confirmación y recordatorios por correo',
      emailsOff: 'No recibirás más correos sobre este ayuno.',
      ended: 'Hecho',
      notFound: 'Este enlace ya no es válido. Es posible que el ayuno haya terminado o se haya cerrado.',
    },
  },
  guide: {
    // ── Ayuno ───────────────────────────────────────────────
    fasting: {
      title: '🔥 Ayuno',
      overview: 'Ayunen y oren juntos como comunidad. Un <b>Relevo</b> pasa el ayuno de persona a persona para que siempre haya alguien ayunando; <b>Juntos</b> significa que todos ayunan en el mismo horario cada día.',
      features: [
        {
          icon: '🗓️', title: 'Inscríbete en un Horario',
          desc: 'Abre un ayuno para ver cada turno por día. Toca <b>Tomar este turno</b> (relevo) o <b>Unirme</b> (juntos) — puedes elegir todos los que quieras, y <b>Dejar</b> devuelve un horario. <b>Unirme todos los días</b> te inscribe en todo un ayuno juntos. Filtra por <b>Libres</b> para encontrar huecos, o <b>Míos</b> para tus horarios.',
        },
        {
          icon: '🔔', title: 'Recordatorios y Relevos', accent: 'orange',
          desc: 'Recibes un recordatorio antes de tu horario, una notificación cuando empieza y, en un relevo, un agradecimiento cuando pasas la antorcha. La comunidad ve cada relevo en las publicaciones para animarse — activa <b>Cada cambio de turno del relevo</b> en Configuración de notificaciones si quieres una notificación por cada uno.',
        },
        {
          icon: '🌐', title: 'Personas Sin la App', accent: 'green',
          desc: 'Los organizadores pueden activar una <b>Página pública de inscripción</b> y compartir su enlace. Las personas se inscriben con su nombre y correo, reciben una confirmación y un recordatorio por correo, y usan el enlace para cambiar sus horarios. Si después se unen a Ignite con el mismo correo, sus horarios pasan a la app y pueden unirse a la comunidad con un toque. Los organizadores también pueden <b>Agregar a alguien</b> a mano y <b>Exportar CSV</b>.',
        },
        {
          icon: '🛠️', title: 'Organizar un Ayuno', accent: 'purple',
          desc: 'Los organizadores tocan <b>Nuevo ayuno</b>, eligen Relevo o Juntos, la fecha y hora de inicio, el número de días y la duración del turno. Un ayuno empieza como <b>Borrador</b>; <b>Publicar</b> lo abre. Cuando alguien se inscribe, el horario se bloquea para que el horario de nadie cambie.',
        },
      ],
    },
    aboutPage: 'Acerca de esta página',
    gotIt: 'Entendido',
    resetGuides: 'Restablecer guías de página',
    resetGuidesDesc: 'Mostrar los botones de ayuda en cada pantalla nuevamente',
    guidesReset: 'Las guías de página se han restablecido',
    // Cada guía usa la `screenKey` que su pantalla pasa a <PageGuide>. Los
    // layouts con pestañas piden `<sección>.<pestañaActiva>`, así que cada
    // pestaña necesita una entrada. Mantener en paralelo con en.js.
    people: {
      people: {
        title: '👥 Personas',
        overview: 'Todas las personas por las que oras y con quienes caminas, en un solo lugar. <b>Esta lista es completamente privada</b> — nadie más puede ver quién está en ella ni nada de lo que has escrito.',
        features: [
          {
            icon: '➕', title: 'Agrega a Quien Sea',
            desc: 'Toca <b>Agregar persona</b> para familia, amigos, compañeros — cualquiera que esté en tu corazón. Anota su relación, por qué estás orando y dónde está en el camino. Usa <b>Agregar personas rápidamente</b> en el menú + del calendario de oración para agregar varias a la vez.',
          },
          {
            icon: '🕒', title: 'Frecuencia de Oración', accent: 'orange',
            desc: 'Con qué frecuencia aparece alguien en tu calendario de oración:<br><b>Diaria</b> — cada día<br><b>Semanal</b> — una vez por semana<br><b>Rotación regular</b> — una persona por día, recorriendo tu lista<br>Es un ritmo, no una clasificación.',
          },
          {
            icon: '🌱', title: 'Dónde Están', accent: 'green',
            desc: 'Seis etapas, desde <b>Labrar</b> (tierra dura) pasando por Suelo, Semilla, Brote y Planta hasta <b>Cosecha</b> (ya hacen discípulos). Solo tú mueves a alguien — una conversación puede sugerir una etapa, pero nada cambia hasta que tú la elijas.',
          },
          {
            icon: '👤', title: 'Su Página', accent: 'purple',
            desc: 'Toca un nombre para abrir <b>Datos</b> (por qué oras, tus oraciones por ellos, detalles), <b>Caminar Con</b> (dónde están y <b>Lo que sabes de ellos</b>) e <b>Historial</b> (cada conversación y cómo han cambiado las cosas). Desde ahí puedes <b>Orar hoy</b>, <b>Orar en día específico</b> o <b>Planear una conversación</b>.',
          },
          {
            icon: '🔍', title: 'Encuentra a Alguien', accent: 'gold',
            desc: 'Filtra por frecuencia con <b>Orando por:</b>, o activa <b>Aún no siguen a Jesús</b> para ver solo a quienes aún no lo conocen. Cuando tu lista crece aparece un buscador. El menú ⋮ de cada fila también te permite <b>Invitar a Ignite</b> con un mensaje adecuado a dónde están.',
          },
          {
            icon: '🕯️', title: 'Quienes Han Partido', accent: 'purple',
            desc: 'Marca a alguien como fallecido para mantenerlo aquí en memoria, en morado. Elige con qué frecuencia recordarlo — <b>en aniversarios</b> (la fecha de su partida, Día de Todos los Santos, Navidad y Pascua), <b>una vez al mes</b> o <b>cada trimestre</b> — y anota su legado de fe. Su camino no continúa aquí; solo tus oraciones.',
          },
        ],
      },
      encounters: {
        title: '💬 Encuentros',
        overview: 'Planea una conversación real con alguien, déjate guiar durante ella y anota después dónde viste a Dios. Todo aquí es privado.',
        features: [
          {
            icon: '🗓️', title: 'Planea Antes de Ir',
            desc: 'Toca <b>Planear una conversación</b> y elige con quién y dónde estarás — un café, en la camioneta, en una comida, caminando, en el trabajo, en el bote o en otro lugar. Elige <b>Descubrir dónde están</b> para una primera conversación, o <b>Dar un paso más</b>. Luego <b>Crear la guía</b> — se adapta a su etapa y a lo que sabes de ellos; no es un guion.',
          },
          {
            icon: '🧭', title: 'Guiado, No Guionado', accent: 'orange',
            desc: 'Una idea a la vez, en letra grande: algo que podrías decir, una o dos preguntas, y qué hacer si se abren o si no. Desliza entre tarjetas. Se carga una sola vez, así que nada se queda cargando mientras te esperan, y recuerda dónde ibas si tu teléfono se bloquea. <b>Anotar algo</b> guarda una nota a mitad de la conversación.',
          },
          {
            icon: '📝', title: 'Después', accent: 'purple',
            desc: 'Toca <b>Terminamos</b> para tres preguntas: <em>¿Qué aprendiste de ellos? ¿Dónde viste a Dios? ¿Cuál es el siguiente paso?</em> Recibirás sugerencias — notas para guardar, un siguiente paso, cosas por las que orar hoy. Nada se guarda hasta que tocas <b>Guardar lo que marqué</b>, y una etapa sugerida siempre la decides tú.',
          },
          {
            icon: '📚', title: 'Tus Conversaciones', accent: 'green',
            desc: '<b>Continúa donde lo dejaste</b> muestra las conversaciones que has planeado; <b>Conversaciones anteriores</b> son las que ya repasaste. También aparecen en el Historial de cada persona.',
          },
        ],
      },
      lineage: {
        title: '🌳 Linaje',
        overview: 'Las personas que te han discipulado y las que tú estás discipulando — tu árbol genealógico espiritual.',
        features: [
          {
            icon: '🤝', title: 'En Ambas Direcciones',
            desc: 'Ofrece caminar con alguien o pide a alguien que camine contigo. Primero deben estar <b>conectados</b>, y <b>ambos tienen que aceptar</b> — nadie se agrega sin aceptar. Las invitaciones que te esperan aparecen en <b>Solicitudes Pendientes</b>.',
          },
          {
            icon: '🌲', title: 'Tu Árbol', accent: 'green',
            desc: '<b>Quienes te plantaron</b> están arriba y <b>A quienes llevas</b> abajo — varias generaciones. Elige quién es tu discipulador primario, o termina una relación desde su menú; a la otra persona se le avisa que terminó, nunca por qué.',
          },
          {
            icon: '💬', title: 'Seguimientos', accent: 'orange',
            desc: 'Abre una relación para enviar un seguimiento, responder uno, y contestar y orar por las respuestas. Linaje te avisa cuando un seguimiento o una respuesta te está esperando.',
          },
          {
            icon: '🔐', title: 'Lo Que Otros Ven', accent: 'purple',
            desc: 'Tú decides si las personas que discipulas pueden ver quién te discipuló <em>a ti</em>. Cámbialo cuando quieras en Configuración → Privacidad → <b>Compartir mi linaje con mis discípulos</b>.',
          },
        ],
      },
    },

    // ── Oración: una guía por pestaña ───────────────────────
    // No hay entrada `recipients`: /prayer/recipients redirige a /people.
    prayer: {
      calendar: {
        title: '📅 Calendario de Oración',
        overview: 'Tu calendario de oración se llena solo cada día, para que nunca te preguntes por quién orar. Es <b>privado</b> — solo tú puedes verlo.',
        features: [
          {
            icon: '✨', title: 'Se Llena Por Ti',
            desc: 'Cada día incluye a todas las personas en <b>Diaria</b>, a las de <b>Semanal</b> repartidas durante la semana, y a <b>una persona</b> de tu Rotación regular. También se agrega una petición de oración al día, por turnos entre tus propias peticiones y las que estás Orando Por. Quienes han partido se recuerdan en los días que elegiste.',
          },
          {
            icon: '🎨', title: 'Cómo Leer el Calendario', accent: 'gold',
            desc: 'Cambia entre <b>Semana</b> y <b>Mes</b>, o vuelve a <b>Hoy</b>. Los colores te dicen qué es cada oración — una persona según su frecuencia, <b>Mi Petición</b> para tus propias peticiones y <b>De…</b> para las de otros. Una marca indica que ya oraste.',
          },
          {
            icon: '🙏', title: 'Ora y Lleva el Registro', accent: 'orange',
            desc: 'Toca cualquier oración para guardar <b>Mis notas</b>, <b>Generar oración de muestra</b> cuando necesites palabras, ver <b>Un siguiente paso que podrías dar</b> según dónde está esa persona, y tocar <b>¡Oré!</b> La tarjeta de arriba muestra cuántas quedan hoy y tu racha de oración.',
          },
          {
            icon: '🎙️', title: 'Orar Ahora y Agregar', accent: 'green',
            desc: '<b>Orar Ahora</b> escribe una oración para el momento que vives. El botón <b>+</b> agrega una petición de oración, una persona o varias a la vez con <b>Agregar personas rápidamente</b>.',
          },
          {
            icon: '🔒', title: 'Privado', accent: 'purple',
            desc: 'Por quién oras y las oraciones que generas son <b>visibles solo para ti</b>. Una excepción: las notas en tu <em>propia</em> petición actualizan esa petición, así que quienes la ven también las verán.',
          },
        ],
      },
      requests: {
        title: '📋 Peticiones de Oración',
        overview: 'Comparte por lo que necesitas oración y lleva el registro de las peticiones por las que te comprometiste a orar.',
        features: [
          {
            icon: '🔒', title: 'Tú Eliges Quién Lo Ve',
            desc: 'Cada petición tiene su propia audiencia:<br><b>Privado</b> — solo tú<br><b>Mis Conexiones</b> — personas conectadas contigo<br><b>Mis Comunidades</b> — todas tus comunidades, o solo las que elijas<br><b>Conexiones y Comunidades</b> — todos tus contactos y todos en tus comunidades<br>También puedes elegir Mis Conexiones y Mis Comunidades juntas.',
          },
          {
            icon: '📝', title: 'Mis Peticiones', accent: 'green',
            desc: 'Dale un título, una categoría y notas, y una <b>fecha de fin</b> opcional para algo urgente. Publica <b>actualizaciones</b> cuando las cosas cambien. Cuando Dios responda, toca <b>¡Dios respondió!</b> y cuenta cómo — pasa de <b>Por favor</b> a <b>Gracias</b> como registro de Su fidelidad. Quienes oran por ella reciben una notificación de cada actualización y de la respuesta — solo ellos, no todos los que pueden verla.',
          },
          {
            icon: '🙏', title: 'Orando Por', accent: 'orange',
            desc: 'Las peticiones que aceptaste en Descubrir viven en <b>Orando Por</b>, donde puedes seguir las actualizaciones de quien la pidió y ver cuándo Dios ha respondido. Recibes una notificación cuando publica una actualización o la marca como respondida.',
          },
          {
            icon: '☰', title: 'Más en Cada Petición', accent: 'purple',
            desc: 'Usa el menú de una petición para <b>Orar hoy</b>, <b>Orar en día específico</b>, compartirla en el feed, editarla o agregar una actualización. En la petición de otra persona también puedes reportarla o quitarla de tu lista.',
          },
        ],
      },
      discover: {
        title: '🧭 Descubrir Peticiones',
        overview: 'Peticiones de oración de tu red, <b>una tarjeta a la vez</b>, para que las tomes en oración.',
        features: [
          {
            icon: '👉', title: 'Desliza a la Derecha — Oraré',
            desc: '<b>Desliza a la derecha</b> (o toca <em>“Oraré”</em>) para comprometerte a orar. Pasa a <b>Orando Por</b> en la pestaña Peticiones y se une a las peticiones que se turnan en tu calendario de oración.',
          },
          {
            icon: '👈', title: 'Desliza a la Izquierda — Pasar', accent: 'orange',
            desc: '<b>Desliza a la izquierda</b> (o toca <em>“Pasar”</em>) para dejarla a un lado. Sin juicio — ora por lo que esté en tu corazón. ¿Cambiaste de opinión? Al llegar al final, <b>Revisar peticiones pasadas</b> las trae de vuelta.',
          },
          {
            icon: '🔍', title: 'Lo Que Verás', accent: 'purple',
            desc: 'Peticiones compartidas contigo por <b>tus conexiones</b> y <b>las comunidades a las que perteneces</b>, además de oraciones comunitarias de Ignite. Las peticiones de personas que has bloqueado nunca aparecen. La pestaña muestra un número cuando llegan nuevas.',
          },
        ],
      },
    },

    // ── Orar Ahora ──────────────────────────────────────────
    prayNow: {
      title: '🙏 Orar Ahora',
      overview: 'Una <b>oración personal</b> para el momento que vives — escrita para lo que está pasando, con quién estás y cómo quieres que se sienta.',
      features: [
        {
          icon: '✨', title: 'Elige Tu Momento',
          desc: 'Empieza por el momento: <b>antes de una comida</b>, <b>buenos días</b>, <b>buenas noches</b>, <b>no puedo dormir</b>, <b>ansioso / preocupado</b>, <b>un momento difícil</b>, <b>celebración</b>, una reunión o decisión, con familia o amigos, y más.',
        },
        {
          icon: '🎵', title: 'Hazla Tuya', accent: 'orange',
          desc: 'Agrega algo específico, quién está contigo y por quién estás orando — todo opcional. Luego elige un tono (<b>Reconfortante</b>, <b>Alentador</b>, <b>Fuerte y fiel</b> o <b>Tranquilo y sereno</b>) y una duración.',
        },
        {
          icon: '📤', title: 'Órala, Compártela', accent: 'purple',
          desc: 'Léela en voz alta, cópiala o compártela en el feed. Toca <b>Nueva Oración</b> para empezar otra vez.',
        },
        {
          icon: '📚', title: 'Tu Historial', accent: 'green',
          desc: 'Cada oración se guarda en <b>Historial</b> para volver a ella cuando quieras, y aparece en tu Diario.',
        },
      ],
    },

    // ── Comunidades (la lista) ──────────────────────────────
    communities: {
      title: '🏘️ Comunidades',
      overview: 'Encuentra a tu gente — iglesias, grupos pequeños, estudios bíblicos, vecindarios — y <b>crezcan juntos</b>.',
      features: [
        {
          icon: '🧭', title: 'Las Mías y Descubrir',
          desc: '<b>Las mías</b> tiene las comunidades a las que perteneces y <b>Pendientes</b> las que pediste unirte. <b>Descubrir</b> te deja buscar y filtrar por tipo; las comunidades <b>Destacadas</b> aparecen primero.',
        },
        {
          icon: '🔐', title: 'Unirse', accent: 'purple',
          desc: 'A las comunidades <b>Públicas</b> te unes de inmediato. Las <b>Privadas</b> las puedes ver, pero tocas <b>Solicitar unirse</b> y un organizador aprueba. Las <b>Ocultas</b> son solo por invitación y nunca aparecen en Descubrir.',
        },
        {
          icon: '🧩', title: 'Qué Hay Dentro', accent: 'green',
          desc: 'Toda comunidad tiene publicaciones, miembros y un chat de grupo. Según lo que activen sus organizadores, también puede tener <b>calendario</b> (con sala de Zoom), <b>planes de lectura bíblica</b>, <b>planes de crecimiento</b>, <b>El Pozo</b> para conversar sobre el sermón y un devocional de <b>Ritmo Diario</b>.',
        },
        {
          icon: '🗝️', title: 'Crea Una', accent: 'gold',
          desc: 'Crea una comunidad y elige su tipo, quién puede unirse, una comunidad principal opcional y qué funciones usará. Te conviertes en su <b>organizador</b> y puedes agregar co-organizadores.',
        },
      ],
    },

    // ── Inicio / Publicaciones de una comunidad ─────────────
    communityHome: {
      title: '🏡 Tu Comunidad',
      overview: 'Todo lo que comparte esta comunidad, en dos pestañas: <b>Inicio</b> para lo que está pasando y <b>Publicaciones</b> para las publicaciones.',
      features: [
        {
          icon: '🏠', title: 'Inicio',
          desc: '<b>Ahora mismo</b> aparece cuando un evento está en vivo o por empezar. Debajo están los eventos de <b>Esta semana</b> y tarjetas para lo que use esta comunidad — Ritmo Diario, El Pozo, el plan de lectura y los planes de crecimiento. Toca una tarjeta para abrirla.',
        },
        {
          icon: '📣', title: 'Publicaciones', accent: 'orange',
          desc: 'Comparte una reflexión, escritura, oración, alabanza o rendición con la comunidad, y reacciona, comenta y anímense unos a otros. También verás cuando alguien se une, cuando se publica un plan o un tema de El Pozo, y las reflexiones que los miembros deciden compartir.',
        },
        {
          icon: '💬', title: 'Chat', accent: 'gold',
          desc: 'El botón <b>Conversar</b> abre el chat de grupo de la comunidad en Mensajes — para conversaciones rápidas y peticiones entre reuniones.',
        },
        {
          icon: '⋯', title: 'Más', accent: 'purple',
          desc: 'El botón <b>⋯</b> tiene Miembros, Invitaciones, Subcomunidades, Ritmo Diario y Salir. Los organizadores también encuentran ahí <b>Funciones de la Comunidad</b> (activar o desactivar funciones — no se borra nada) y <b>Gestionar</b>.',
        },
        {
          icon: '🗝️', title: 'Organizadores', accent: 'green',
          desc: 'Los organizadores y co-organizadores agregan eventos al calendario, crean planes de lectura y programas de Ritmo Diario, llevan El Pozo, invitan miembros y aprueban <b>solicitudes para unirse</b> en la pantalla de Miembros.',
        },
      ],
    },

    // ── Ritmo Diario ────────────────────────────────────────
    rhythm: {
      title: '🌅 Ritmo Diario',
      overview: 'Un devocional día a día que tu comunidad recorre junta, con una <b>Mañana</b> y una <b>Noche</b> cada día.',
      features: [
        {
          icon: '⏰', title: 'Se Abre a Su Hora',
          desc: 'La mañana y la noche de cada día se abren a horas fijas, y recibirás una notificación cuando lo hagan. Hasta entonces verás cuándo se abre. Los días pasados siguen abiertos — perderse uno es normal, así que vuelve cuando quieras.',
        },
        {
          icon: '📖', title: 'Cada Día', accent: 'orange',
          desc: 'La <b>Mañana</b> trae un versículo clave y un devocional; <b>Lee</b> tiene la Escritura del día (cambia entre NIV / NLT / MSG) con una guía; <b>Ora</b> te acompaña a pedir, escuchar y responder; la <b>Noche</b> trae una historia y una guía de oración.',
        },
        {
          icon: '✍️', title: 'Tu Reflexión', accent: 'green',
          desc: 'Escribe en <b>Tu reflexión</b> y usa <b>Lleva un diario</b> para unas preguntas guiadas opcionales. <b>Guardar</b> la mantiene privada; <b>Guardar y compartir con la comunidad</b> te deja elegir qué respuestas pueden leer otros. Tus reflexiones también aparecen en tu Diario.',
        },
        {
          icon: '🔁', title: 'Mi Semana', accent: 'purple',
          desc: '<b>Mi semana</b> reúne todo lo que escribiste en un solo lugar. Toca <b>Resumir mi semana</b> para una mirada atrás hecha solo con tus propias palabras. Solo tú puedes ver esta página.',
        },
      ],
    },

    // ── Planes de Crecimiento ───────────────────────────────
    grow: {
      title: '🌿 Crece Más Profundo',
      overview: 'Planes para ayudarte a <b>crecer más profundo en tu fe</b> — Escritura, comentario pastoral y preguntas de reflexión, a tu propio ritmo. <b>Estudio Bíblico</b> es la tercera pestaña aquí.',
      features: [
        {
          icon: '🧭', title: 'Explorar Planes',
          desc: 'Explora <b>Popular</b>, <b>Nuevo</b> y planes por categoría — Fundamentos de la Fe, Discipulado, Batallas Contra el Pecado, Duelo y Pérdida y más. Busca, o filtra por categoría, duración, madurez, idioma o <b>Desafío activo</b>.',
        },
        {
          icon: '🚀', title: 'Comienza un Plan', accent: 'orange',
          desc: 'Toca <em>“Iniciar este plan”</em> y elige cómo crecer: <b>Crecer en silencio</b> (solo tú y Dios), <b>Crecer con unos pocos</b> (invita a otros a caminar contigo) o <b>Crecer con comunidad</b>. Más tarde puedes tocar <b>Invitar a otros</b> para convertir un plan personal en un pequeño círculo.',
        },
        {
          icon: '✨', title: 'Crea el Tuyo', accent: 'gold',
          desc: '¿No encuentras lo que necesitas? Toca <b>Nuevo plan</b> y describe lo que estás viviendo — Ignite creará un plan para ti.',
        },
        {
          icon: '💬', title: 'Reflexiona y Comparte', accent: 'purple',
          desc: 'Responde las preguntas de cada unidad y guarda — en privado, o compartido con tu círculo o comunidad en el <b>Feed del camino</b> del plan. Cada vez que guardas recibes una <b>bendición personal</b>, y cada reflexión aparece en tu Diario.',
        },
        {
          icon: '🎧', title: 'Escucha', accent: 'teal',
          desc: 'Cuando una unidad tiene narración, toca reproducir para escuchar el comentario — elige voz de mujer o de hombre cuando se ofrecen ambas, cambia la velocidad y retrocede o adelanta.',
        },
        {
          icon: '✅', title: 'Progreso y Desafíos', accent: 'green',
          desc: '<b>Mis planes</b> empieza con <b>Continuar donde lo dejaste</b>. Los <b>Desafíos</b> desbloquean una unidad por día para avanzar juntos. Termina un plan para recibir una <em>carta de fe personal</em>.',
        },
      ],
    },

    // ── Feed ────────────────────────────────────────────────
    feed: {
      title: '🔥 Tu Feed',
      overview: 'Mira lo que Dios está haciendo en las personas a tu alrededor — reflexiones, escritura, oraciones, alabanza y más.',
      features: [
        {
          icon: '✍️', title: 'Comparte Algo',
          desc: 'Elige un tipo: <b>Reflexión</b>, <b>Escritura</b> (busca un versículo para adjuntar), <b>Oración</b>, <b>Alabanza</b> o <b>Rendición</b>. Agrega <b>hasta diez fotos</b> o un video. Las peticiones de oración que compartes desde la pestaña Oración también aparecen aquí.',
        },
        {
          icon: '🌐', title: 'Quién Lo Ve', accent: 'purple',
          desc: 'Elige una audiencia para cada publicación: <b>Público</b>, <b>Conexiones y grupos</b>, <b>Solo conexiones</b> o <b>Solo mis grupos</b>.',
        },
        {
          icon: '❤️', title: 'Responde', accent: 'orange',
          desc: 'Reacciona con 🙏 ❤️ 🔥 o 🙌 — tu propia reacción se resalta, y al tocarla otra vez se quita. Comenta y responde, <b>Republicar</b> con tus propias palabras, <em>@menciona</em> a otros y toca un <em>#hashtag</em> para ver publicaciones relacionadas.',
        },
        {
          icon: '🔖', title: 'Filtra y Guarda', accent: 'gold',
          desc: 'Usa los filtros para ver un solo tipo de publicación. Marca una publicación para guardarla en <b>Guardados</b>.',
        },
      ],
    },

    // ── Diario ──────────────────────────────────────────────
    journal: {
      title: '📓 Mi Diario',
      overview: 'Una <b>línea de tiempo privada</b> de tu vida espiritual, una semana a la vez. Solo tú puedes verla.',
      features: [
        {
          icon: '✨', title: 'Se Llena Solo',
          desc: 'Las oraciones que has orado, las de <b>Orar Ahora</b>, tus <b>estudios bíblicos</b>, <b>reflexiones</b> de planes de lectura y de crecimiento, conversaciones y notas de sermón de <b>El Pozo</b>, reflexiones del <b>Ritmo Diario</b>, <b>conversaciones</b> que ya repasaste, estados espirituales y registros de evangelismo aparecen aquí por sí solos.',
        },
        {
          icon: '✍️', title: 'Escribe lo Tuyo', accent: 'orange',
          desc: 'Agrega una entrada cuando quieras con título, etiquetas y fecha opcionales — <b>ponle una fecha anterior</b> si te estás poniendo al día. Abre una entrada para editarla o <b>destacarla</b>.',
        },
        {
          icon: '📅', title: 'Muévete en el Tiempo', accent: 'purple',
          desc: 'Pasa de una semana a otra, <b>Saltar a fecha</b>, o toca <b>Hoy</b>. Toca un día en la franja para ir directo a él.',
        },
        {
          icon: '🔍', title: 'Buscar y Filtrar', accent: 'green',
          desc: 'Filtra por tipo, activa <b>Solo destacadas</b> para ver tus favoritas de cualquier semana, o busca por palabra en esta semana. El resumen muestra las oraciones, oraciones de Orar Ahora, entradas y palabras escritas de la semana.',
        },
      ],
    },

    // ── El Pozo (la lista y el tema comparten una guía) ─────
    well: {
      title: '💧 El Pozo',
      overview: 'Un tema semanal sobre el sermón para tu comunidad — profundicen juntos durante la semana.',
      features: [
        {
          icon: '☀️', title: 'Cada Semana',
          desc: 'Un tema nuevo por sermón, en <b>Esta semana</b> y semanas anteriores. <b>Información del Sermón</b> tiene la serie, la Escritura (cambia entre NIV / NLT / MSG), las notas del sermón y el video, y un desafío cuando lo hay.',
        },
        {
          icon: '🔥', title: 'Conversen Juntos', accent: 'orange',
          desc: 'En <b>Discusión</b>, responde las preguntas de la semana, empieza tu propia conversación y responde a otros. Ordena por <b>Nuevas</b> o <b>Destacadas</b>, y reacciona al tema.',
        },
        {
          icon: '📝', title: 'Mis Notas', accent: 'purple',
          desc: 'Guarda notas privadas del sermón, con colores según lo que son — una idea clave, una convicción, una acción, una oración. Toca versículos y <b>Anotar esto</b> para unir una nota a ellos; esos versículos se subrayan en el color de tu nota. Las notas aparecen en tu Diario.',
        },
      ],
    },

    // ── Estudio Bíblico ─────────────────────────────────────
    'bible-study': {
      title: '📖 Estudio Bíblico',
      overview: 'Estudia cualquier pasaje con preguntas guiadas y <b>reflexiones de IA</b> que te ayudan a ver lo que Dios está diciendo.',
      features: [
        {
          icon: '📖', title: 'Elige un Pasaje',
          desc: 'Elige un libro, capítulos y versículos, y luego <b>Iniciar estudio bíblico</b> — o toca <b>Inspirarme</b> y se elige un pasaje para ti. En un día de un plan de lectura de comunidad, <b>Estudiar este pasaje</b> abre aquí con los versículos de ese día ya seleccionados. Léelo en NIV, NLT y The Message dentro de la app, con enlaces a otras traducciones.',
        },
        {
          icon: '✨', title: 'Preguntas y Reflexiones', accent: 'orange',
          desc: 'Empieza con <b>Contexto y trasfondo</b>, luego recorre lo que el pasaje muestra sobre Dios, sobre las personas y cómo te invita a responder. Piensa primero y luego toca para ver la reflexión de Ignite. Una última pregunta te invita a pensar a quién podrías animar con él. Toca <b>Guardar mis respuestas</b> para conservarlas.',
        },
        {
          icon: '🔗', title: 'Comparte un Estudio', accent: 'purple',
          desc: 'Crea un enlace para <b>Cualquiera con el enlace</b> o <b>Solo conexiones</b>, y luego <b>Enviar en un mensaje</b> si quieres — tus respuestas se incluyen solo si lo eliges. También puedes compartir un estudio en tu feed.',
        },
        {
          icon: '📚', title: 'Estudios Anteriores', accent: 'green',
          desc: 'Cada estudio se guarda. Toca <b>Estudios anteriores</b> arriba para volver al pasaje, las reflexiones y tus respuestas.',
        },
      ],
    },

    // ── Historias (Inicio → Historias) ──────────────────────
    stories: {
      title: '🌍 Historias del Movimiento',
      overview: 'Mira lo que Dios está haciendo en todo el mundo — y cuenta lo que ha hecho en tu vida.',
      features: [
        {
          icon: '🧭', title: 'Explorar',
          desc: 'Historias destacadas, y luego historias de salvación, sanidad, provisión, persecución y avivamiento de cada región. Reacciona con 🙏 ❤️ 🔥 o 🙌. Toca <b>Mapa</b> para girar el globo y encontrar historias por país.',
        },
        {
          icon: '✍️', title: 'Cuenta Tu Historia', accent: 'orange',
          desc: 'Toca <b>Compartir historia</b> y elige un punto de partida — <b>Cómo conocí a Jesús</b>, <b>Crecí en la fe</b>, <b>El regreso</b>, <b>Una temporada de espera</b>, <b>Una oración respondida</b> o <b>Empezar de cero</b>. Responde preguntas cortas que puedes saltar y recibe un primer borrador con tu voz; luego edítalo hasta que suene a ti.',
        },
        {
          icon: '🔒', title: 'Tú Eliges Quién La Ve', accent: 'purple',
          desc: 'Cada historia es <b>Solo yo</b>, <b>Mis conexiones</b> o <b>Cualquiera con el enlace</b>. Una historia compartible recibe un enlace que cualquiera puede abrir, y tras una breve revisión puede destacarse aquí — de forma anónima si lo prefieres.',
        },
        {
          icon: '📚', title: 'Mis Historias', accent: 'green',
          desc: 'Escribe todas las que quieras — la obra de Dios en tu vida no es un solo capítulo. Encuéntralas en <b>Mis Historias</b> y en tu perfil.',
        },
      ],
    },
  },
};

export default es;
